<template>
  <v-container style="max-width: 100%">
    <!-- {{ $store.state.loadingApp }} -->
    <div class="d-flex flex-row flex-wrap justify-center">
      <div class="d-flex flex-row elevation-1 px-2 pt-4 my-4">
        <v-radio-group
          row
          :value="scopeLanguage"
          class="mt-0"
          :disabled="freeze || $store.state.loadingApp > 0"
          @change="changeScopeLanguage($event)"
        >
          <v-radio
            label="Spanish"
            value="Spanish"
            class="my-0 py-0"
            on-icon="$vuetify.icons.icon_spanish"
          />
          <v-radio
            label="Quechua"
            value="Quechua"
            class="my-0 py-0"
            on-icon="$vuetify.icons.icon_quechua"
          />
          <v-radio
            label="English"
            value="English"
            class="my-0 py-0"
            on-icon="$vuetify.icons.icon_english"
          />
          <v-radio
            label="All Schools"
            value="allLanguages"
            class="my-0 py-0"
          />
        </v-radio-group>
      </div>
    </div>

    <v-tabs
      v-model="activeTabTeaching"
      background-color="transparent"
      color="basil"
      grow
      @change="checkLoadingApp(), checkScopeTypeResources($event)"
    >
      <v-tab
        v-for="itemTab in itemsTabCourses"
        :key="itemTab"
      >
        <span class="ppc_darkgreen--text">
          {{ itemTab }}
        </span>
      </v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="activeTabTeaching">
      <!-- Resources -->
      <v-tab-item>
        <div class="d-flex flex-row flex-wrap justify-center">
          <v-card
            flat
            outlined
            class="d-flex flex-row px-2 pt-8 mb-2"
          >
            <v-radio-group
              row
              :value="scopeOnline"
              class="mt-0"
              :disabled="freeze"
              @change="$store.dispatch('changeScopeOnline', $event), loadCourses()"
            >
              <v-radio
                label="Online"
                value="online"
                class="my-0 py-0"
              />
                            
              <v-radio
                label="In Person"
                value="inPerson"
                class="my-0 py-0"
              />
              <v-radio
                label="Both"
                value="all"
                class="my-0 py-0"
              />
            </v-radio-group>
          </v-card>
          <v-card
            flat
            outlined
            class="d-flex flex-row px-2 pt-2 mb-2"
          >
            <v-radio-group
              row
              :value="scopeResources"
              class="mt-0"
              :disabled="freeze"
              @change="changingScopeResources($event)"
            >
              <div class="d-flex flex-column">
                <div class="d-flex justify-center">
                  <v-radio
                    label="Ongoing"
                    value="ongoing"
                    class="my-0 py-0"
                  />
                </div>
                <v-divider class="my-2" />
                <div class="d-flex flex-row flex-wrap">
                  <div class="d-flex flex-row flex-wrap">
                    <v-radio
                      label="No Classes Planned"
                      value="notPlanned"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="Planning Not Finished"
                      value="courseNotFinished"
                      class="my-0 py-0"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-space-between mx-2">
                <v-radio
                  label="Completed"
                  value="completed"
                  class="my-0 py-0"
                />
              </div>
            </v-radio-group>
          </v-card>
          <v-card
            flat
            outlined
            class="d-flex flex-row flex-wrap px-2 pt-0 mb-2"
          >
            <v-card-title>Starting</v-card-title>
            <span
              class="mx-2 my-0 mt-4"
              style="width: 170px;"
            >
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="between"
                    v-bind="attrs"
                    prepend-icon="$vuetify.icons.icon_mdi_calendar"
                    :value="formattedDate(scopeDates.start)"
                    clearable
                    readonly
                    v-on="on"
                    @click:clear="scopeDates.start = null, resourcesScope = filterResources(resourcesLoaded)"
                  />
                </template>
                <v-date-picker
                  v-model="scopeDates.start"
                  no-title
                  scrollable
                  @change="resourcesScope = filterResources(resourcesLoaded)"
                />
              </v-menu>
            </span>
            <span
              class="mx-2 my-0 mt-4"
              style="width: 170px;"
            >
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="100%"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="and"
                    v-bind="attrs"
                    prepend-icon="$vuetify.icons.icon_mdi_calendar"
                    :value="formattedDate(scopeDates.end)"
                    clearable
                    readonly
                    v-on="on"
                    @click:clear="scopeDates.end = null, resourcesScope = filterResources(resourcesLoaded)"
                  />
                </template>
                <v-date-picker
                  v-model="scopeDates.end"
                  no-title
                  scrollable
                  @change="resourcesScope = filterResources(resourcesLoaded)"
                />
              </v-menu>
            </span>
          </v-card>
        </div>
        <span class="d-flex flex-row flex-wrap justify-center my-2">
          <v-btn
            class="ma-2"
            text
            :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'GroupNormal'"
            x-small
            :style="{'background-color': legendColorsCourses[0].color, color: '#000'}"
            @click="changeScopeTypeResources('GroupNormal')"
          >
            <v-icon
              x-small
              v-html="legendColorsCourses[0].name"
            />
          </v-btn>
          <v-btn
            class="ma-2"
            text
            :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'GroupSpecial'"
            x-small
            :style="{'background-color': legendColorsCourses[1].color, color: '#000'}"
            @click="changeScopeTypeResources('GroupSpecial')"
          >
            <v-icon
              x-small
              v-html="legendColorsCourses[1].name"
            />
          </v-btn>
          <v-btn
            class="ma-2"
            text
            :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'IndividualNormal'"
            x-small
            :style="{'background-color': legendColorsCourses[4].color, color: '#000'}"
            @click="changeScopeTypeResources('IndividualNormal')"
          >
            <v-icon
              x-small
              v-html="legendColorsCourses[4].name || scopeTypeResources === 'IndividualNormal'"
            />
          </v-btn>
          <v-btn
            class="ma-2"
            text
            :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'IndividualSpecial'"
            x-small
            :style="{'background-color': legendColorsCourses[5].color, color: '#000'}"
            @click="changeScopeTypeResources('IndividualSpecial')"
          >
            <v-icon
              x-small
              v-html="legendColorsCourses[5].name"
            />
          </v-btn>
          <v-btn
            class="ma-2"
            text
            :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'all'"
            x-small
            :style="{'background-color': 'grey', color: '#FFF'}"
            @click="changeScopeTypeResources('all')"
          >
            <v-icon
              x-small
            >All</v-icon>
          </v-btn>
        </span>
        <div>
          <v-data-table
            :headers="headersResourcesAll"
            :items="resourcesScope"
            sort-by="start"
            class="my-5 elevation-1"
            :item-class="itemRowBackgroundResources"
            :footer-props="{
              'items-per-page-options': [itemsPerPage]
            }"
            :search="searchResourceTableTeaching"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <div class="d-flex flex-row flex-wrap justify-center">
                  <v-card flat>
                    <v-text-field
                      v-model="searchResourceTableTeaching"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ resourcesScope.length }` + ' Course(s)'"
                      single-line
                      hide-details
                      style="width: 300px"
                      clearable
                    />
                  </v-card>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.full_name`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex flex-row align-center">
                    <v-btn 
                      x-small
                      fab
                      v-bind="attrs"
                      class="mr-3" 
                      v-on="on"
                      @click="goClient(item.client_id, item.resource_id)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <strong>{{ item.full_name }}</strong>
                  </div>
                </template>
                <span>Go to Client</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.class_language`]="{ item }">
              <span class="d-flex flex-row">
                <span>
                  <v-icon small>{{ getIcon(item) }}</v-icon>
                </span>
              </span>
            </template>
            <template v-slot:[`item.class_group`]="{ item }">
              <v-icon
                v-if="item.class_group === 'Individual'"
                small
              >
                $vuetify.icons.icon_mdi_account
              </v-icon>
              <v-icon
                v-if="item.class_group === 'Group'"
                small
              >
                $vuetify.icons.icon_mdi_account_group
              </v-icon>
            </template>

            <template v-slot:[`item.class_location`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="item.class_location === 'School Cusco'"
                    v-on="on"
                  >
                    mdi-home
                  </v-icon>
                </template>
                <span>School Cusco</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="item.class_location === 'Online'"
                    small
                    v-on="on"
                  >
                    {{ "$vuetify.icons.icon_mdi_headphones" }}
                  </v-icon>
                </template>
                <span>Online</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="item.class_location === 'Urubamba'"
                    v-on="on"
                  >
                    mdi-image-filter-hdr
                  </v-icon>
                </template>
                <span>Urubamba</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.class_type`]="{ item }">
              <v-icon
                v-if="item.class_type === 'Normal'"
                small
              />
              <v-icon
                v-if="item.class_type === 'Special'"
                small
              >
                mdi-star
              </v-icon>
            </template>
            <template v-slot:[`item.start`]="{ item }">
              {{ item.start ? formattedDate(item.start, 'date') : formattedDate(editedResource.start, 'date') }}
            </template>
            <template v-slot:[`item.end`]="{ item }">
              {{ item.end ? formattedDate(item.end, 'date') : formattedDate(editedResource.end, 'date') }}
            </template>
                        
            <template v-slot:[`item.minutes_planned`]="{ item }">
              {{ minutesToHours1Decimal(item.minutes_planned) }}
            </template>

            <template v-slot:[`item.minutes_completed`]="{ item }">
              {{ minutesToHours1Decimal(item.minutes_completed) }}
            </template>

            <template v-slot:[`item.minutes_available`]="{ item }">
              {{ minutesToHoursHalf(item.minutes_available) }}
            </template>

            <template v-slot:[`item.graduationClassStart`]="{ item }">
              <span
                v-if="item.graduationClassStart !== null && item.minutes_available === 0"
                small
                v-html="formattedDate(item.graduationClassStart, 'date')"
              />
            </template>
            <template v-slot:[`item.statusResourceId`]="{ item }">
              <v-chip
                small
                text-color="negro"
                v-html="getStatusResource(item).name"
              />
            </template>
            <template v-slot:[`item.sendScheduleStudent`]="{ item }">
              <v-chip 
                v-if="item.sendScheduleStudent === 0"
                small 
                color="#00cc00"
                text-color="white"
                :disabled="$store.state.loadingApp > 0"
                @click="createStudentClassSchedule(item, true), dialogCourse = false"
              >
                ok
              </v-chip>
              <v-chip 
                v-else-if="item.sendScheduleStudent === 1"
                small
                color="#ff6600"
                text-color="white"
                :disabled="$store.state.loadingApp > 0"
                @click="createStudentClassSchedule(item, true)"
              >
                send
              </v-chip>
              <v-chip
                v-else
                small
                color="grey"
                text-color="black"
                disabled
              >
                in progress
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    class="mx-1"
                    :disabled="$store.state.loadingApp > 0"
                    @click="openDialogCourse(item.resource_id)"
                    v-on="on"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                </template>
                <span>Edit Course</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>

      <!-- Class Groups -->
      <v-tab-item>
        <div
          class="d-flex flex-row flex-wrap justify-center"
          style="height: 70px;"
        >
          <v-card
            flat
            outlined
            class="d-flex flex-row px-2 pt-3 mt-1 mb-0"
          >
            <v-radio-group
              row
              :value="scopeClassGroups"
              class="mt-0"
              :disabled="freeze"
              @change="changingScopeClsGroups($event)"
            >
              <div class="d-flex flex-row flex-wrap">
                <div class="d-flex justify-center">
                  <v-radio
                    label="Open"
                    value="open"
                    class="my-0 py-0"
                  />
                </div>
                <div class="d-flex justify-space-between mx-2">
                  <v-radio
                    label="Closed"
                    value="closed"
                    class="my-0 py-0"
                  />
                </div>
              </div>
            </v-radio-group>
          </v-card>
          <v-card 
            flat
            class="d-flex flex-row flex-wrap my-0 mx-6 align-center jusify-space-between" 
            height="65px" 
            width="470px"
          >
            <v-card
              v-for="(item, id) in legendColorsClsGroups"
              :key="id"
              flat
              class="ma-0 pa-0"
              color="white"
            >
              <v-btn
                class="ma-2"
                text
                :disabled="$store.state.loadingApp > 0 || scopeTypeResources === item.id"
                x-small
                :style="{'background-color': item.color, color: '#000'}"
                @click="changeScopeTypeResources(item.id)"
              >
                <v-icon
                  x-small
                  v-html="item.name"
                />
              </v-btn>
            </v-card>
            <v-card flat>
              <v-btn
                class="ma-2"
                text
                :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'all'"
                x-small
                :style="{'background-color': 'grey', color: '#FFF'}"
                @click="changeScopeTypeResources('all')"
              >
                <v-icon
                  x-small
                >
                  All
                </v-icon>
              </v-btn>
            </v-card>
          </v-card>
        </div>
        <v-data-table
          :headers="headersClsGroups"
          :items="classGroupsDisplay"
          sort-by="start"
          class="my-5 elevation-1"
          :item-class="itemRowBackgroundResources"
          :footer-props="{
            'items-per-page-options': [itemsPerPage]
          }"
          :search="searchClsGroups"
          fixed-header
        >
          <template v-slot:top>
            <v-toolbar
              flat
              color="white"
            >
              <div class="d-flex flex-row flex-wrap justify-center">
                <v-card flat>
                  <v-text-field
                    v-model="searchClsGroups"
                    append-icon="$vuetify.icons.icon_mdi_magnify"
                    :label="'Search ' + `${ classGroupsDisplay.length }` + ' Class Goup(s)'"
                    single-line
                    hide-details
                    style="width: 300px"
                    clearable
                  />
                </v-card>
              </div>
              <v-spacer />
            </v-toolbar>
          </template>
          <template v-slot:[`item.class_language`]="{ item }">
            <span class="d-flex flex-row">
              <span>
                <v-icon
                  v-if="item.class_language"
                  small
                >{{ getIcon(item) }}</v-icon>
              </span>
              <v-icon
                v-if="item.class_location === 'Online'"
                small
                class="mx-2 mt-1"
              >{{ "$vuetify.icons.icon_mdi_headphones" }}</v-icon>
            </span>
          </template>
          <template v-slot:[`item.class_location`]="{ item }">
            <v-icon
              v-if="item.class_location === 'School Cusco'"
              small
            >
              mdi-home
            </v-icon>
            <v-icon
              v-if="item.class_location === 'Online'"
              small
            >
              mdi-desktop-classic
            </v-icon>
          </template>
          <template v-slot:[`item.class_type`]="{ item }">
            <v-icon
              v-if="item.class_type === 'Normal'"
              small
            />
            <v-icon
              v-if="item.class_type === 'Special'"
              small
            >
              mdi-star
            </v-icon>
          </template>
          <template v-slot:[`item.startTime`]="{ item }">
            <span
              v-if="item.startTime !== null"
              small
              v-html="formattedDate(item.startTime, 'date')"
            />
          </template>
          <template v-slot:[`item.endTime`]="{ item }">
            <span
              v-if="item.endTime !== null"
              small
              v-html="formattedDate(item.endTime, 'date')"
            />
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mx-1"
                  :disabled="$store.state.loadingApp > 0"
                  @click="openDialogClsGroup(item, null)"
                  v-on="on"
                >
                  $vuetify.icons.icon_mdi_pencil
                </v-icon>
              </template>
              <span>Edit Class Group</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Calendar -->
      <v-tab-item>
        <div class="d-flex flex-row flex-wrap justify-space-between my-4">
          <v-sheet height="64">
            <v-toolbar
              flat
            >
              <v-btn
                outlined
                class="mr-4 py-8"
                color="grey darken-2"
                :disabled="$store.state.loadingApp > 0"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn
                fab
                text
                color="grey darken-2"
                :disabled="$store.state.loadingApp > 0"
                class="mx-4"
                @click="prev"
              >
                <v-icon>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <span style="width: 170px;">
                <v-menu
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      readonly
                      class="mt-4"
                      :disabled="$store.state.loadingApp > 0"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="focusCalendar"
                    color="grey darken-2"
                    no-title
                    scrollable
                    @change="changeDate($event)"
                  />
                </v-menu>
              </span>
              <v-btn
                fab
                text
                color="grey darken-2"
                :disabled="$store.state.loadingApp > 0"
                class="mx-4"
                @click="next"
              >
                <v-icon>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <!-- <v-toolbar-title v-if="$refs.calendar">
                                {{ $refs.calendar.title }}
                            </v-toolbar-title> -->
            </v-toolbar>
          </v-sheet>
          <v-card 
            flat
            class="d-flex flex-row flex-wrap my-0 mx-6 align-center jusify-space-between" 
            height="90px" 
            width="580px"
          >
            <v-card
              v-for="(item, id) in legendColorsCalendar"
              :key="id"
              flat
              class="ma-0 pa-0"
              color="white"
            >
              <v-btn
                class="ma-2"
                text
                :disabled="$store.state.loadingApp > 0 || scopeTypeResources === item.id"
                x-small
                :style="{'background-color': item.color, color: '#000'}"
                @click="changeScopeTypeResources(item.id)"
              >
                <v-icon
                  x-small
                  v-html="item.name"
                />
              </v-btn>
            </v-card>
            <v-card flat>
              <v-btn
                class="ma-2"
                text
                :disabled="$store.state.loadingApp > 0 || scopeTypeResources === 'all'"
                x-small
                :style="{'background-color': 'grey', color: '#FFF'}"
                @click="changeScopeTypeResources('all')"
              >
                <v-icon
                  x-small
                >
                  All
                </v-icon>
              </v-btn>
              <!-- <v-icon
                                style="background-color: transparent"
                                color="black"
                                class="pa-1 ma-1"
                                x-small
                            >
                                edit class = LMB/RMB
                            </v-icon> -->
            </v-card>
          </v-card>
          <!-- <v-switch
                        v-model="showClsGroupsOnly"
                        @change="loadCalendar()"
                        label="Show Class Groups Only"
                        class="mt-6"
                    ></v-switch> -->
          <v-card
            flat
            outlined
            class="d-flex flex-row px-2 pt-3 pb-0 mb-1 mr-4"
            style="border-color: grey;"
          >
            <v-radio-group
              row
              :value="scopeCalendar"
              class="pt-2 pb-0 px-4 ma-0"
              :disabled="freeze || $store.state.loadingApp > 0"
              @change="changingScopeCalendar"
            >
              <v-radio
                label="Day Rooms"
                value="category"
                class="my-0 py-0"
              />
              <v-radio
                label="Week"
                value="week"
                class="my-0 py-0"
              />
              <v-radio
                label="Month"
                value="month"
                class="my-0 py-0"
              />
            </v-radio-group>
          </v-card>
        </div>
        <v-sheet height="100vh">
          <v-calendar
            ref="calendar"
            v-model="focusCalendar"
            color="primary"
            :type="scopeCalendar"
            category-show-all
            category-days="1"
            :categories="categoriesCalendar"
            :events="events"
            event-text-color="black"
            event-overlap-mode="column"
            show-week
            first-interval="7"
            :key="rendererKeyCalendar"
            first-time="06:00"
            @contextmenu:event="prepOpenDialogClass($event.event)"
            @mousedown:event="startDrag"
            @mousedown:time="startTimer"
            @mouseenter:time-category="getCategory"
            @mousemove:time="mouseMove"
            @mouseup:time="endDrag"
            @mouseleave.native="cancelDrag"
            @click:date="clickDate()"
          >
            <template v-slot:event="{ event, timed, eventSummary }">
              <div class="event-button-div">
                <span class="event-title">
                  <v-icon small>{{ event.icon }}</v-icon>
                  <v-icon small>{{ event.iconOnline }}</v-icon>
                  <v-icon small>{{ event.iconGrad }}</v-icon>
                  {{ event.title }}
                </span>
                <v-btn
                  fab
                  x-small
                  class="event-button pa-0"
                  color="darkgrey"
                  elevation="1"
                  @click.stop="openDialogClass(event)"
                >
                  <v-icon
                    small
                    color="black"
                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </div>
              <div class="v-event-draggable">
                <component :is="{ render: eventSummary }" />
              </div>
              <div
                v-if="timed"
                class="v-event-drag-bottom"
                @mousedown.stop="extendBottom(event)"
              />
            </template>
          </v-calendar>
        </v-sheet>
        <v-card
          flat
          outlined
          class="d-flex flex-column ma-4 pa-4 justify-center"
          style="border-color: grey;"
        >
          <v-card
            flat
            class="d-flex flex-row flex-wrap"
          >
            <v-checkbox
              :input-value="selectAllTeachers"
              ripple
              label="All"
              class="py-0 my-0 mx-2"
              color="blue"
              :disabled="freeze || $store.state.loadingApp > 0"
              @change="changeSelectAllTeachers($event)"
            />
            <v-card
              v-for="(teacher, index) in activeTeachers"
              :key="index"
              flat
            >
              <div class="ma-0 pa-0">
                <v-checkbox
                  ripple
                  :input-value="teacher.visible"
                  v-if="teacher.obsolete === null && (scopeLanguage === 'allLanguages' || scopeLanguage === 'Spanish' && teacher.spanish === 1 || scopeLanguage === 'Quechua' && teacher.quechua === 1 || scopeLanguage === 'English' && teacher.english === 1)"
                  :label="`${teacher.contactFullName}`"
                  class="py-0 my-0 mx-2"
                  color="blue"
                  :disabled="freeze || $store.state.loadingApp > 0"
                  @change="changeTeacherVisibility(index, teacher)"
                />
              </div>
            </v-card>
          </v-card>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <!-- Teachers -->
        <div class="d-flex flex-row elevation-1 px-2 pt-4 mb-2 justify-center">
          <v-radio-group
            row
            :value="scopeClassesTeachers"
            class="mt-0"
            :disabled="freeze"
            label="Classes"
            @change="changeScopeClassesTeachers($event)"
          >
            <v-radio
              label="Planification"
              value="ongoing"
              class="my-0 py-0"
            />
            <v-radio
              label="Planned Not Paid"
              value="notPaid"
              class="my-0 py-0"
            />
            <v-radio
              label="Finished Not Paid"
              value="finishedNotPaid"
              class="my-0 py-0"
            />
            <v-radio
              label="Finished Paid"
              value="finishedPaid"
              class="my-0 py-0"
            />
          </v-radio-group>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            class="white--text"
            @click="$router.push({ name: 'Teachers'})"
          >
            Teachers Pool
          </v-btn>
        </div>
        <v-tabs
          v-model="activeTabTeachers"
          background-color="transparent"
          color="basil"
          grow
          @change="selectedClassesTeachers = []"
        >
          <v-tab
            v-for="itemTabTeachers in itemsTabTeachers"
            :key="itemTabTeachers.id"
          >
            <span>
              {{ itemTabTeachers }}
            </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTabTeachers">
          <v-tab-item
            v-for="teacher in indexTeachers"
            :key="teacher.id"
          >
            <v-card
              v-if="(scopeClassesTeachers === 'notPaid' || scopeClassesTeachers === 'finishedNotPaid') && selectedClassesTeachers"
              flat
              outlined
              class="d-flex flex-row flex-wrap ma-4 justify-space-around"
            >
              <v-card
                flat
                class="d-flex flex-row flex-wrap ma-4"
              >
                <v-card
                  flat
                  width="400px"
                >
                  <v-text-field 
                    v-model="teacher.comments_correction"
                    label="Comments"
                    :disabled="selectedClassesTeachers.length === 0"
                    class="ma-2"
                  />
                </v-card>
                <v-card
                  flat
                  width="150px"
                >
                  <v-text-field
                    v-model="teacher.correction"
                    label="Correction PEN"
                    :disabled="selectedClassesTeachers.length === 0"
                    class="ma-2"
                  />
                </v-card>
                <v-btn
                  small
                  :disabled="selectedClassesTeachers.length === 0"
                  class="mx-4 mt-5"
                  @click="createPaymentTeacherForm(teacher)"
                >
                  Payment Teacher Form
                </v-btn>
                <v-btn
                  small
                  :disabled="selectedClassesTeachers.length === 0"
                  class="mx-4 mt-5"
                  @click="payClasses(teacher)"
                >
                  Pay Selected Class(es)
                </v-btn>
              </v-card>
            </v-card>
            <v-card
              v-if="teacher.classes && scopeClassesTeachers === 'ongoing'"
              flat
              height="50px"
              class="d-flex flex-row justify-space-around"
            >
              <v-btn
                small
                :disabled="teacher.classes.length === 0 || $store.state.loadingApp > 0 || selectedClassesTeachers.length === 0"
                class="ma-4 mt-8"
                @click="createTeacherClassSchedule(teacher)"
              >
                <span v-if="teacher.classes.length === 0">No Classes Planned</span>
                <span v-else-if="teacher.lastSchedule === null">Last Planification not sent</span>
                <span v-else-if="teacher.lastSchedule !== null">Last Planification Sent {{ formattedDate(teacher.lastSchedule,'date') }}</span>
              </v-btn>
            </v-card>
            <v-data-table
              v-model="selectedClassesTeachers"
              :headers="headersClassesTeachers"
              :items="teacher.classes"
              class="my-5 elevation-1"
              dense
              :items-per-page="-1"
              disable-pagination
              hide-default-footer
              show-select
              :single-select="false"
              :item-class="getBackgroundColorTeachers"
              sort-by="start"
              item-key="class_id"
              fixed-header
              height="calc(100vh - 500px)"
            >
              <template v-slot:[`item.start`]="{ item }">
                <span
                  v-if="item.start !== null"
                  small
                  v-html="formattedDate(item.start, 'dateTimeShort')"
                />
                <v-icon
                  v-if="item.minutes_completed >= item.duration"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
              <template v-slot:[`item.duration`]="{ item }">
                <span small>{{ durationHoursLabel(item) }}</span>
              </template>
              <template v-slot:[`item.students`]="{ item }">
                <span small>{{ studentsLabel(item) }}</span>
              </template>
              <template v-slot:[`item.individual_instead`]="{ item }">
                <v-icon
                  v-if="item.individual_instead === 1"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
              <template v-slot:[`item.outgoing_id`]="{ item }">
                {{ paymentClassFormatted(item) }}
                <v-icon
                  v-if="item.outgoing_id !== null"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDialogClass(item)"
                >
                  $vuetify.icons.icon_mdi_pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="dialogCourse"
      max-width="90vw"
      height="90vh"
      persistent
    >
      <v-form>
        <v-card>
          <v-card-title 
            :style="{'background-color': editedResource.backgroundColor}"
            class="d-flex justify-space-between"
          >
            <span class="headline black--text">
              <div>
                <v-icon class="mr-2">{{ getIcon(editedResource) }}</v-icon>
                <v-icon
                  v-if="editedResource.class_location === 'Online'"
                  class="mr-2"
                >{{ "$vuetify.icons.icon_mdi_headphones" }}</v-icon>
                {{ editedResource.full_name }} 
                <span v-if="editedResource.initial_spanish_level"> ({{ editedResource.initial_spanish_level }})</span> {{ editedResource.class_group }}, {{ editedResource.class_type }}
              </div>
            </span>
            <div class="caption black--text">
              #{{ editedResource.resource_id }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-row flex-wrap">
              <v-card
                flat
                class="d-flex flex-row flex-wrap"
                style="width: 100%"
              >
                <v-card
                  flat
                  outlined
                  class="mx-2 mb-0 mt-2 pt-0"
                  style="min-width: 40%;"
                >
                  <div class="d-flex flex-row flex-wrap">
                    <div class="mb-2">
                      <v-card-title class="ml-4 mb-2 pa-0">
                        Course Info
                      </v-card-title>
                      <v-card
                        flat
                        class="d-flex flex-column mx-4"
                      >
                        <span>
                          Sold: {{ editedResource.hours }} hrs
                        </span>
                        <span>
                          Per class: {{ editedResource.hours_per_class }} hrs
                        </span>
                        <span>
                          From: {{ this.formattedDate(editedResource.start) }}
                        </span>
                        <span>
                          To: {{ this.formattedDate(editedResource.end) }}
                        </span>
                        <span>
                          Location: {{ editedResource.class_location }}
                        </span>
                      </v-card>
                    </div>
                    <div class="mb-2">
                      <v-card-title class="ml-4 mb-2 pa-0">
                        Client Info
                      </v-card-title>
                      <v-card
                        flat
                        class="d-flex flex-column mx-4"
                      >
                        <div v-if="editedResource.client?.email">
                          Email: {{ editedResource.client.email }}
                        </div>

                        <div v-if="editedResource.client?.phone">
                          Phone: {{ editedResource.client.phone }}
                        </div>
                        
                        <span>
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                small
                                rounded 
                                class="my-6 mx-2"
                                v-on="on"
                                @click="goClient(editedResource.client_id, editedResource.resource_id)"
                              >Go to Resource of Client
                              </v-btn>
                            </template>
                            <span>Cancel changes and go to this Resource of {{ editedResource.full_name }} in Client</span>
                          </v-tooltip>
                        </span>
                      </v-card>
                    </div>
                  </div>
                  <v-textarea
                    v-model="editedResource.comments"
                    class="mt-0 mx-3 mb-0 pb-0"
                    clearable
                    counter="255"
                    outlined
                    height="200px"
                    no-resize
                    label="Comments (255 max)"
                    :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                    @change="noActionsTaken = false"
                  />
                </v-card>
                <v-card
                  outlined
                  class="d-flex flex-column mx-2 mb-0 mt-2 pt-0"
                  style="min-width: 50%; max-width: 60%;"
                >
                  <v-data-table
                    v-if="resourcesInCourseComputed.length > 0"
                    :headers="headersResourcesInCourseOrGroup"
                    :items="resourcesInCourseComputed"
                    class="mb-6 mx-4"
                    dense
                    hide-default-footer
                    disable-pagination
                    sort-by="full_name"
                  >
                    <template v-slot:[`item.full_name`]="{ item }">
                      <v-chip
                        small
                        :style="getStudentColorStyle(item)"
                      >
                        <strong v-if="editedResource.resource_id === item.resource_id">
                          {{ item.full_name }}
                        </strong>
                        <span v-else>
                          {{ item.full_name }}
                        </span>
                      </v-chip>
                    </template>

                    <template v-slot:[`item.minutes_available`]="{ item }">
                      <span
                        v-if="(Math.floor(item.minutes_available / 60 * 2) / 2) < 0"
                        style="color: red"
                      >
                        {{ Math.floor(item.minutes_available / 60 * 2) / 2 }}
                      </span>
                      <span v-else>
                        {{ Math.floor(item.minutes_available / 60 * 2) / 2 }}
                      </span>
                    </template>

                    <template v-slot:[`item.sendScheduleStudent`]="{ item }">
                      <v-chip 
                        v-if="item.sendScheduleStudent === 0 || editedClassesInResource.length === 0"
                        small 
                        color="#00cc00"
                        text-color="white"
                        :disabled="$store.state.loadingApp > 0 || editedClassesInResource.length === 0 || !noActionsTaken || tooManyHoursUsedComputed"
                        @click="createStudentClassSchedule(item, true)"
                      >
                        ok
                      </v-chip>
                      <v-tooltip
                        v-else-if="item.sendScheduleStudent === 1"
                        left
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="#ff6600"
                            text-color="white"
                            :disabled="$store.state.loadingApp > 0 || editedClassesInResource.length === 0 || !noActionsTaken || tooManyHoursUsedComputed"
                            @click="createStudentClassSchedule(item, true)"
                          >
                            send
                          </v-chip>
                        </template>

                        <span>Send selected or future classes</span>
                      </v-tooltip>

                      <v-chip 
                        v-else
                        small
                        color="grey"
                        text-color="black"
                        disabled
                      >
                        in progress
                      </v-chip>
                    </template>
                    <template v-slot:[`item.goCourse`]="{ item }">
                      <v-btn 
                        v-if="editedResource.resource_id !== item.resource_id"
                        x-small 
                        rounded 
                        :disabled="$store.state.loadingApp > 0 || !noActionsTaken"
                        fab
                        @click="dialogCourse = false, resetDialogCourseState(), openDialogCourse(item.resource_id)"
                      >
                        <v-icon>mdi-arrow-up-bold</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card>
              <v-card
                flat
                class="d-flex flex-column"
                style="min-width: 600px"
              >
                <v-card
                  outlined
                  rounded-xl
                  flat
                  class="d-flex flex-row flex-wrap pa-0 mt-2"
                >
                  <v-card-title>Plan Hours</v-card-title>
                  <v-card
                    outlined
                    rounded-xl
                    flat
                    class="d-flex flex-row ma-1"
                  >
                    <v-card-subtitle class="mt-4">
                      Week Pattern
                    </v-card-subtitle>
                    <v-card-text class="d-flex flex-row flex-wrap ma-0 pb-0">
                      <v-card
                        v-for="(copyDay, i) in week"
                        :key="i"
                        flat
                        style="width: 80px"
                      >
                        <v-checkbox 
                          v-model="weekSelect.day[copyDay]"
                          class="ma-0 pa-0 mt-6"
                          :label="`${copyDay}`"
                        />
                      </v-card>
                    </v-card-text>
                    <v-card flat>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="ppc_darkgreen darken-1"
                            v-bind="attrs"
                            small
                            class="ml-0 mr-4 mt-6"
                            :disabled="minutesAvailableForStudentComputed <= 0 || !editedResource.start"
                            v-on="on"
                            @click="addNewClasses(editedResource)"
                          >
                            <span
                              v-if="editedClassesInResource.length > 0"
                              style="color: white"
                            >Create Classes</span>
                            <span
                              v-else
                              style="color: white"
                            >Create 1st Class</span>
                          </v-btn>
                        </template>
                        <span>Create Classes with All Available Hours</span>
                      </v-tooltip>
                    </v-card>
                  </v-card>
                </v-card>
              </v-card>
              <v-card
                flat
                class="d-flex flex-column"
                style="min-width: 600px"
              >
                <v-card
                  outlined
                  flat
                  class="mt-2"
                >
                  <v-card
                    flat
                    class="d-flex flex-row flex-wrap"
                  >
                    <v-card-title>Selected Classes</v-card-title>
                    <v-card
                      v-if="editedResource.class_group === 'Group'"
                      flat
                    >
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            small
                            fab
                            class="ma-4"
                            :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid || !noActionsTaken || differentStudentsInClasses"
                            v-on="on"
                            @click="openDialogSelectResources(editedResource)"
                          >
                            <v-icon>
                              $vuetify.icons.icon_mdi_account_plus
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Change Classmates Selected Class(es)</span>
                      </v-tooltip>
                    </v-card>
                    <v-card flat>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            small
                            fab
                            class="ma-4"
                            :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                            v-on="on" 
                            @click="removeClassesInCourseOrGroup()"
                          >
                            <v-icon>
                              $vuetify.icons.icon_mdi_delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Remove Selected Class(es) Entirely</span>
                      </v-tooltip>
                    </v-card>
                    <v-card
                      flat
                      class="d-flex justify-center"
                    >
                      <v-select
                        v-model="resourceTeacher_id"
                        :items="selectTeachers(editedResource)"
                        item-text="contact"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="Change Teacher"
                        single-line
                        prepend-icon="$vuetify.icons.icon_mdi_school"
                        clearable
                        style="max-width: 250px"
                        class="mx-4"
                        :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                        @change="changeEditedClassesInCourse('teacher')"
                      />
                    </v-card>
                    <v-card
                      flat
                      class="d-flex flex-row"
                    >
                      <v-text-field
                        v-model="resourceClassStartTime"
                        label="Start"
                        style="max-width: 50px"
                        type="time"
                        format="24hr"
                        class="mx-8"
                        :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                        @change="changeEditedClassesInCourse('startTime')"
                      />
                      <v-text-field
                        v-model="resourceClassEndTime"
                        label="End"
                        style="max-width: 50px"
                        type="time"
                        format="24hr"
                        class="mx-8"
                        :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                        @change="changeEditedClassesInCourse('endTime')"
                      />
                    </v-card>
                    <v-select
                      v-model="resourceClass_room_id"
                      :items="classRooms"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ auto: true }"
                      label="Change Classroom"
                      single-line
                      prepend-icon="$vuetify.icons.icon_mdi_classroom"
                      clearable
                      style="max-width: 200px"
                      :disabled="selectedClassesCourseOrGroup.length === 0"
                      class="mx-4"
                      @change="changeEditedClassesInCourse('Room')"
                    />
                    <span
                      v-if="editedResource.class_group === 'Group'"
                      class="d-flex flex-row flex-wrap ma-4"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-select
                            v-model="classGroupId"
                            v-bind="attrs"
                            :items="selectClsGroup"
                            item-text="class_group_name"
                            item-value="class_group_id"
                            :menu-props="{ auto: true }"
                            label="Add to existing Class Group"
                            single-line
                            prepend-icon="$vuetify.icons.icon_mdi_group"
                            clearable
                            v-on="on"
                            style="min-width: 100px; max-width: 400px"
                            :disabled="selectedClassesCourseOrGroup.length === 0"
                            class="mx-4"
                            @change="changeClsGroup($event)"
                          />
                        </template>
                        <span>Add Selected Classes to an Existing Class Group</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-card
                            flat
                            width="400px"
                          >
                            <v-text-field 
                              v-model="newClsGroup"
                              v-bind="attrs"
                              label="New Class Group"
                              :disabled="selectedClassesCourseOrGroup.length === 0 || !noActionsTaken"
                              class="mx-1 mt-1 mb-0"
                              clearable
                              v-on="on"
                            />
                            <span
                              v-if="newClsGroupNotUnique"
                              class="mx-2 my-0"
                            >Name already used before</span>
                            <span
                              v-else
                              class="mx-2 my-0"
                            />
                          </v-card>
                        </template>
                        <span>Add Selected Classes to a New Class Group</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            small
                            class="ma-4"
                            :disabled="selectedClassesCourseOrGroup.length === 0 || !noActionsTaken || !newClsGroup"
                            v-on="on"
                            @click="onSaveCourse()"
                          >Add & Save</v-btn>
                        </template>
                        <span>Save New Class Group</span>
                      </v-tooltip>
                    </span>
                  </v-card>
                </v-card>
              </v-card>
            </div>
            <v-data-table
              v-if="editedClassesInResource.length > 0"
              v-model="selectedClassesCourseOrGroup"
              :headers="headersClassesInResource"
              :items="editedClassesInResource"
              class="my-6 mx-4"
              dense
              hide-default-footer
              disable-pagination
              show-select
              :single-select="false"
              sort-by="start"
              item-key="key"
              @input="filterSelectionClassesResources()"
            >
              <template v-slot:[`item.start`]="{ item }">
                <span
                  v-if="item.start"
                  small
                  :class="{ text_color_changed_content: item.newClass }"
                >
                  {{ startDateLabel(item) }}
                </span>
              </template>
                            
              <template v-slot:[`item.newClass`]="{ item }">
                <v-icon
                  v-if="item.newClass"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
                            
              <template v-slot:[`item.startTime`]="{ item }">
                <span
                  v-if="item.startTime"
                  small
                  :class="{ text_color_changed_content: item.startTime_changed }"
                >
                  {{ timeLabel(item.startTime) }}
                </span>
              </template>

              <template v-slot:[`item.endTime`]="{ item }">
                <span
                  v-if="item.endTime"
                  small
                  :class="{ text_color_changed_content: item.endTime_changed }"
                >
                  {{ timeLabel(item.endTime) }}
                </span>
              </template>

              <template v-slot:[`item.studentsObject`]="{ item }">
                <div
                  v-for="(student, resource_id) in item.studentsObject"
                  :key="resource_id"
                >
                  <v-chip
                    v-if="student.resource_id === editedResource.resource_id"
                    x-small
                    :style="getStudentColorStyle(student)"
                  >
                    <strong>{{ student.full_name }}</strong>
                  </v-chip>
                  <v-chip
                    v-else
                    x-small
                    :style="getStudentColorStyle(student)"
                  >
                    {{ student.full_name }}
                  </v-chip>
                </div>
                <span
                  v-if="item.students_changed"
                  class="text_color_changed_content"
                >
                  CHANGED
                </span>
              </template>

              <template v-slot:[`item.contact`]="{ item }">
                <span
                  v-if="item.contact"
                  small
                  :class="{ text_color_changed_content: item.teacher_changed }"
                >
                  {{ item.contact }}
                </span>
              </template>

              <template v-slot:[`item.duration`]="{ item }">
                <span small>{{ durationHoursLabel(item) }}</span>
              </template>

              <template v-slot:[`item.individual_instead`]="{ item }">
                <span>{{ yesNo(item.individual_instead) }}</span>
              </template>

              <template v-slot:[`item.class_room`]="{ item }">
                <span
                  v-if="item.class_room"
                  small
                  :class="{ text_color_changed_content: item.class_room_changed }"
                >
                  {{ item.class_room }}
                </span>
              </template>

              <template v-slot:[`item.outgoing_id`]="{ item }">
                {{ paymentClassFormatted(item) }}
                <v-icon
                  v-if="item.outgoing_id !== null"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>

              <template v-slot:[`item.class_group_name`]="{ item }">
                <v-btn 
                  v-if="item.class_group_name && !item.class_group_changed" 
                  x-small 
                  rounded 
                  @click="dialogCourse = false, openDialogClsGroup(null, item.class_group_id), resetDialogCourseState()"
                >
                  {{ item.class_group_name }}
                </v-btn>
                <span
                  v-else-if="item.class_group_changed"
                  small
                  class="text_color_changed_content"
                  v-html="item.class_group_name"
                />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <span class="d-flex flex-row flex-wrap">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        x-small
                        fab
                        class="my-4 mx-2"
                        :disabled="item.outgoing_id !== null"
                        v-on="on"
                        @click="removeClassesInCourseOrGroup(item)"
                      >
                        <v-icon>
                          $vuetify.icons.icon_mdi_delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Class Entirely</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        x-small
                        fab
                        class="my-4 mx-2"
                        :disabled="!noActionsTaken"
                        v-on="on"
                        @click="openCourse = editedResource.id, openDialogClass(item)"
                      >
                        <v-icon>
                          $vuetify.icons.icon_mdi_pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Class</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        x-small
                        fab
                        class="my-4 mx-2"
                        :disabled="item.newClass || !noActionsTaken"
                        v-on="on"
                        @click="openClassInCalendar(item)"
                      >
                        <v-icon>
                          mdi-arrow-right-thick
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Cancel changes and open Class in Calendar</span>
                  </v-tooltip>
                </span>
              </template>
            </v-data-table>
            <span class="ml-3">Total {{ editedClassesInResource.length }} class(es) and </span>
            <span>{{ Math.round((editedClassesInResource.reduce((accumulator, currentValue) => {return accumulator + currentValue.duration;}, 0))/60*100)/100 }} hours </span>
            <span v-if="selectedClassesCourseOrGroup.length > 0">- {{ selectedClassesCourseOrGroup.length }} class(es) </span>
            <span v-if="selectedClassesCourseOrGroup.length > 0">{{ Math.round((selectedClassesCourseOrGroup.reduce((accumulator, currentValue) => {return accumulator + currentValue.duration;}, 0))/60*100)/100 }} hours selected</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              v-if="editedResource.transaction_id"
              color="blue lighten-3"
              small
              class="ma-4"
              @click="openTransactionOutgoings(editedResource.transaction_id)"
            >
              <v-icon color="white">
                $vuetify.icons.icon_mdi_credit_card
              </v-icon>
              <span class="white--text">Transaction</span>
            </v-btn>
            <v-spacer />
            <div>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="$store.state.loadingApp > 0"
                @click="resetDialogCourseState(), dialogCourse = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="noActionsTaken"
                @click="revertDialogCourseChanges()"
              >
                Revert Changes
              </v-btn>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="noActionsTaken || tooManyHoursUsedComputed"
                @click="onSaveCourse(false)"
              >
                Save
              </v-btn>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="noActionsTaken || tooManyHoursUsedComputed"
                @click="onSaveCourse(true)"
              >
                Save & Close
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialogClsGroup"
      max-width="80vw"
      height="90vh"
      persistent
    >
      <v-form>
        <v-card>
          <v-card-title 
            :style="{'background-color': 'lightgrey'}"
            class="d-flex justify-space-between"
          >
            <span class="headline black--text d-flex flex-row align-center">
              <v-icon class="mx-2">{{ getIcon(editedClsGroup) }}</v-icon>
              <v-icon
                v-if="editedClsGroup.class_location === 'Online'"
                class="mx-2"
              >{{ "$vuetify.icons.icon_mdi_headphones" }}</v-icon>
              <span class="ml-4">Class Group:</span>
              <v-text-field 
                v-model="editedClsGroup.class_group_name"
                clearable
                class="headline ma-2 mt-4"
                :rules="inputRulesName"
                style="width: 500px"
                @change="noActionsTaken = false"
              />
            </span>
            <div class="d-flex flex-row flex-wrap">
              <span
                v-if="editedClsGroup.closed === 0 || !editedClsGroup.closed"
                class="mt-4 mx-2"
              >Group Open</span>
              <span
                v-else
                class="mt-4 mx-2"
              >Group Closed</span>
              <v-switch
                v-model="editedClsGroup.closed"
                class="mx-2"
                @change="noActionsTaken = false"
              >
                OPEN GROUP
              </v-switch>
              <div class="caption black--text">
                #{{ editedClsGroup.class_group_id }}
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-row flex-wrap">
              <v-card
                flat
                outlined
                class="mx-2 mb-0 mt-2 pt-0"
              >
                <v-card-title class="ml-4 mb-2 pa-0 black--text">
                  Group Info
                </v-card-title>
                <v-card
                  flat
                  class="d-flex flex-column ma-4"
                  style="width: 300px"
                >
                  <v-select
                    v-model="editedClsGroup.language_level"
                    style="width: 250px"
                    :items="getLanguageLevels(editedClsGroup.class_language)"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Study Level"
                    single-line
                    prepend-icon="mdi-star"
                    validate-on-blur
                    clearable
                    @change="noActionsTaken = false"
                  />
                  <span>
                    Type: {{ editedClsGroup.class_type }}
                  </span>
                  <span>
                    Location: {{ editedClsGroup.class_location }}
                  </span>
                </v-card>
                <v-textarea
                  v-model="editedClsGroup.comments"
                  class="mt-0 mx-3 mb-0 pb-0"
                  clearable
                  counter="255"
                  outlined
                  height="200px"
                  no-resize
                  label="Comments (255 max)"
                  :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                  @change="noActionsTaken = false"
                />
              </v-card>
              <v-card
                outlined
                class="mx-2 mb-0 mt-2 pt-0"
                style="width: 50%"
              >
                <v-data-table
                  v-if="resourcesInClsGroupComputed.length > 0"
                  :headers="headersResourcesInCourseOrGroup"
                  :items="resourcesInClsGroupComputed"
                  class="mb-6 mx-4"
                  dense
                  hide-default-footer
                  disable-pagination
                  sort-by="full_name"
                >
                  <template v-slot:[`item.full_name`]="{ item }">
                    <v-chip
                      v-if="editedResource.resource_id === item.resource_id"
                      small
                      :style="{'background-color': item.color.background, 'color': item.color.text}"
                    >
                      <strong>{{ item.full_name }}</strong>
                    </v-chip> 
                    <v-chip
                      v-else
                      small
                      :style="{'background-color': item.color.background, 'color': item.color.text}"
                    >
                      {{ item.full_name }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.minutes_available`]="{ item }">
                    <span
                      v-if="(Math.floor(item.minutes_available / 60 * 2) / 2) < 0"
                      style="color: red"
                    >
                      {{ Math.floor(item.minutes_available / 60 * 2) / 2 }}
                    </span>
                    <span v-else>
                      {{ Math.floor(item.minutes_available / 60 * 2) / 2 }}
                    </span>
                  </template>
                  <template v-slot:[`item.goCourse`]="{ item }">
                    <v-btn 
                      x-small
                      rounded 
                      fab 
                      :disabled="$store.state.loadingApp > 0 || !noActionsTaken"
                      @click="dialogClsGroup = false, resetDialogClsGroupState(),openDialogCourse(item.resource_id)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.sendScheduleStudent`]="{ item }">
                    <v-chip 
                      v-if="item.sendScheduleStudent === 0 || editedClassesInClsGroup.length === 0"
                      small 
                      color="#00cc00"
                      text-color="white"
                      :disabled="$store.state.loadingApp > 0 || editedClassesInClsGroup.length === 0 || !noActionsTaken || tooManyHoursUsedClsGroupComputed"
                      @click="createStudentClassSchedule(item, true)"
                    >
                      ok
                    </v-chip>
                    <v-chip 
                      v-else-if="item.sendScheduleStudent === 1"
                      small
                      color="#ff6600"
                      text-color="white"
                      :disabled="$store.state.loadingApp > 0 || editedClassesInClsGroup.length === 0 || !noActionsTaken || tooManyHoursUsedClsGroupComputed"
                      @click="createStudentClassSchedule(item, true)"
                    >
                      send
                    </v-chip>
                    <v-chip 
                      v-else
                      small
                      color="grey"
                      text-color="black"
                      disabled
                    >
                      in progress
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
              <v-card
                flat
                class="d-flex flex-column"
                style="min-width: 600px"
              >
                <v-card
                  outlined
                  flat
                  class="mt-2 mx-2"
                >
                  <v-card-title class="mt-2">
                    Change Selection
                  </v-card-title>
                  <v-card
                    flat
                    class="d-flex flex-row flex-wrap"
                  >
                    <v-card
                      flat
                      class="d-flex justify-center"
                    >
                      <v-select
                        v-model="resourceTeacher_id"
                        :items="selectTeachers(editedClsGroup)"
                        item-text="contact"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="Change Teacher"
                        single-line
                        prepend-icon="$vuetify.icons.icon_mdi_school"
                        clearable
                        style="max-width: 250px"
                        class="mx-4"
                        :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                        @change="changeEditedClassesInCourse('teacher')"
                      />
                    </v-card>
                    <v-card
                      flat
                      class="d-flex flex-row"
                    >
                      <v-text-field
                        v-model="resourceClassStartTime"
                        label="Start"
                        style="max-width: 50px"
                        type="time"
                        format="24hr"
                        class="mx-8"
                        :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                        @change="changeEditedClassesInCourse('startTime')"
                      />
                      <v-text-field
                        v-model="resourceClassEndTime"
                        label="End"
                        style="max-width: 50px"
                        type="time"
                        format="24hr"
                        class="mx-8"
                        :disabled="selectedClassesCourseOrGroup.length === 0 || oneOfClassesPaid"
                        @change="changeEditedClassesInCourse('endTime')"
                      />
                    </v-card>
                    <v-select
                      v-model="resourceClass_room_id"
                      :items="classRooms"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ auto: true }"
                      label="Change Classroom"
                      single-line
                      prepend-icon="$vuetify.icons.icon_mdi_classroom"
                      clearable
                      style="max-width: 200px"
                      :disabled="selectedClassesCourseOrGroup.length === 0"
                      class="mx-4"
                      @change="changeEditedClassesInCourse('Room')"
                    />
                  </v-card>
                </v-card>
              </v-card>
            </div>
            <v-data-table
              v-if="editedClassesInClsGroup.length > 0"
              v-model="selectedClassesCourseOrGroup"
              :headers="headersClassesInClsGroup"
              :items="editedClassesInClsGroup"
              class="my-6 mx-4"
              dense
              hide-default-footer
              disable-pagination
              show-select
              :single-select="false"
              sort-by="start"
              item-key="key"
              @input="filterSelectionClassesResources()"
            >
              <!-- start date -->
              <template v-slot:[`item.start`]="{ item }">
                <span
                  v-if="item.start"
                  small
                  :class="{ text_color_changed_content: item.newClass }"
                >
                  {{ startDateLabel(item) }}
                </span>
              </template>

              <!-- start time -->
              <template v-slot:[`item.startTime`]="{ item }">
                <span
                  v-if="item.startTime"
                  small
                  :class="{ text_color_changed_content: item.startTime_changed }"
                >
                  {{ timeLabel(item.startTime) }}
                </span>
              </template>

              <!-- end time -->
              <template v-slot:[`item.endTime`]="{ item }">
                <span
                  v-if="item.endTime"
                  small
                  :class="{ text_color_changed_content: item.endTime_changed }"
                >
                  {{ timeLabel(item.endTime) }}
                </span>
              </template>

              <!-- students -->
              <template v-slot:[`item.studentsObject`]="{ item }">
                <div
                  v-for="(student, resource_id) in item.studentsObject"
                  :key="resource_id"
                >
                  <v-chip
                    x-small
                    :style="getStudentColorStyle(student)"
                  >
                    {{ student.full_name }}
                  </v-chip>
                </div>

                <span
                  v-if="item.students_changed"
                  class="text_color_changed_content"
                >
                  CHANGED
                </span>
              </template>

              <!-- contact -->
              <template v-slot:[`item.contact`]="{ item }">
                <span
                  v-if="item.contact"
                  small
                  :class="{ text_color_changed_content: item.teacher_changed }"
                >
                  {{ item.contact }}
                </span>
              </template>

              <!-- duration -->
              <template v-slot:[`item.duration`]="{ item }">
                <span small>{{ durationHoursLabel(item) }}</span>
              </template>

              <!-- individual instead -->
              <template v-slot:[`item.individual_instead`]="{ item }">
                <span>{{ yesNo(item.individual_instead) }}</span>
              </template>

              <!-- class room -->
              <template v-slot:[`item.class_room`]="{ item }">
                <span
                  v-if="item.class_room"
                  small
                  :class="{ text_color_changed_content: item.class_room_changed }"
                >
                  {{ item.class_room }}
                </span>
              </template>

              <!-- outgoing / payment -->
              <template v-slot:[`item.outgoing_id`]="{ item }">
                {{ paymentClassFormatted(item) }}
                <v-icon
                  v-if="item.outgoing_id !== null"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <span class="d-flex flex-row flex-wrap">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        x-small
                        fab
                        class="ma-2"
                        v-on="on"
                        @click="removeClassFromClsGroup(item.class_id)"
                      >
                        <v-icon>
                          $vuetify.icons.icon_mdi_group
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Class from Group</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        x-small
                        fab
                        class="ma-2"
                        :disabled="!noActionsTaken"
                        v-on="on"
                        @click="openClsGroup = item.class_group_id, openDialogClass(item)"
                      >
                        <v-icon>
                          $vuetify.icons.icon_mdi_pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Class</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        x-small
                        fab
                        class="ma-2"
                        :disabled="item.newClass || !noActionsTaken"
                        v-on="on"
                        @click="openClassInCalendar(item)"
                      >
                        <v-icon>
                          mdi-arrow-right-thick
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Cancel changes and open Class in Calendar</span>
                  </v-tooltip>
                </span>
              </template>
            </v-data-table>

            <span class="ml-3">
              Total {{ totalClassesCount }} class(es) and {{ totalHours }} hours
            </span>

            <span v-if="hasSelectedClasses">
              - {{ selectedClassesCount }} class(es) {{ selectedHours }} hours selected
            </span>
          </v-card-text>
          <v-card-actions>
            <div>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                @click="removeClsGroup(editedClsGroup.class_group_id), dialogClsGroup = false"
              >
                Remove Class Group
              </v-btn>
            </div>
            <v-spacer />
            <div>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                @click="resetDialogClsGroupState(), dialogClsGroup = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="noActionsTaken"
                @click="revertChangesDialogClsGroup()"
              >
                Revert Changes
              </v-btn>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="noActionsTaken || tooManyHoursUsedClsGroupComputed"
                @click="onSaveClsGroup(false)"
              >
                Save
              </v-btn>
              <v-btn
                color="ppc_darkgreen darken-1"
                text
                :disabled="noActionsTaken || tooManyHoursUsedClsGroupComputed"
                @click="onSaveClsGroup(true)"
              >
                Save & Close
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialogClass"
      width="1100px"
      persistent
    >
      <v-form ref="dialogFormClass">
        <v-card>
          <v-card-title 
            :style="{'background-color': editedClass.color}"
            class="d-flex justify-space-between"
          >
            <span class="headline black--text">
              <div>
                <v-icon class="mx-1">{{ editedClass.icon }}</v-icon>

                <v-icon
                  v-if="editedClass.class_location === 'Online'"
                  class="mx-2"
                >{{ "$vuetify.icons.icon_mdi_headphones" }}</v-icon>
                <v-icon
                  v-else-if="editedClass.class_location === 'Urubamba'"
                  class="mx-2"
                >mdi-image-filter-hdr</v-icon>
                <v-icon
                  v-else
                  class="mx-2"
                >mdi-home</v-icon>

                
                <span
                  v-if="!editedClass.class_id"
                  class="ml-2"
                >New Class</span>
                <span
                  v-else
                  class="ml-2"
                >Edit Class</span>
                <span v-if="editedClass.initial_spanish_level"> ({{ editedClass.initial_spanish_level }})</span> - {{ editedClass.class_group }}, {{ editedClass.class_type }}
              </div>
            </span>
            <div class="caption black--text">
              #{{ editedClass.class_id }}
            </div>
          </v-card-title>
          <v-card-text
            class="d-flex flex-column pb-0"
            width="100%"
          >
            <v-card
              v-if="editedClass.outgoing_id === null"
              flat
              class="d-flex justify-center"
            >
              <v-select
                v-model="editedClass.teacher_id"
                :items="selectTeachers(editedClass)"
                item-text="contact"
                item-value="id"
                :menu-props="{ auto: true }"
                label="Select teacher"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_school"
                clearable
                style="max-width: 250px"
                :rules="inputRulesReq"
                class="mb-0 pb-0"
                @change="changeTeacherInClass(editedClass)"
              />
            </v-card>
            <v-card
              v-else
              flat
              class="d-flex justify-center ma-2"
            >
              <span v-if="editedClass.teacher_id && getTeacher(editedClass.teacher_id)">
                Teacher: {{ getTeacher(editedClass.teacher_id).contact }}
              </span>
            </v-card>
            <div class="d-flex flex-row flex-wrap mt-4 justify-center">
              <v-menu 
                transition="scale-transition"
                offset-y
                min-width="250px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field 
                    :value="formattedDate(editedClass.day)"
                    label="Day" 
                    v-bind="attrs" 
                    readonly
                    style="max-width: 150px"
                    :disabled="editedClass.outgoing_id !== null"
                    v-on="on"
                    @change="changeDateInDialogClass()"
                  />
                </template>
                <v-date-picker 
                  v-model="editedClass.day"
                  color="ppc_darkgreen"
                  scrollable
                  no-title
                  @change="changeDateInDialogClass()"
                />
              </v-menu>
              <v-text-field
                v-model="editedClass.startTime"
                label="From"
                style="max-width: 50px"
                type="time"
                class="mx-6"
                :rules="inputRulesReq"
                :disabled="editedClass.outgoing_id !== null"
                @change="adjustDurationsClass(), createClassRoomsWithAvailability(editedClass.class_id, editedClass.day, editedClass.startTime, editedClass.endTime), noActionsTaken = false"
              />
              <v-text-field
                v-model="editedClass.endTime"
                label="Until"
                style="max-width: 50px"
                type="time"
                class="mx-6"
                :rules="inputRulesReq"
                :disabled="editedClass.outgoing_id !== null"
                @change="adjustDurationsClass(), createClassRoomsWithAvailability(editedClass.class_id, editedClass.day, editedClass.startTime, editedClass.endTime), noActionsTaken = false"
              />
              <div class="d-flex flex-column ma-4 mt-2">
                <div>
                  <span>
                    Duration: {{ minutesToHoursLabel(editedClass.duration || 0) }} hrs
                  </span>
                </div>

                <div>
                  <span>
                    Spending: {{ minutesToHoursLabel(editedClass.minutes_used || 0) }} hrs
                  </span>
                </div>
              </div>
            </div>
            <v-card
              flat
              class="d-flex flex-row flex-wrap justify-center"
            >
              <v-select
                v-model="editedClass.class_room_id"
                :items="classRoomsWithAvailability || []"
                item-text="name"
                item-value="id"
                :menu-props="{ auto: true }"
                label="Select Classroom"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_classroom"
                clearable
                style="max-width: 200px"
                :rules="inputRulesReq"
                :disabled="editedClass.outgoing_id !== null"
                class="mb-0 pb-0"
                @change="noActionsTaken = false"
              />
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    x-small
                    fab
                    class="my-4 ml-2"
                    :disabled="editedClass.class_group_id === null"
                    v-on="on"
                    @click="openDialogClsGroup(null, editedClass.class_group_id), closeDialogClass()"
                  >
                    <v-icon>
                      mdi-arrow-left-thick
                    </v-icon>
                  </v-btn>
                </template>
                <span>Cancel changes and open Class Group</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-select
                    v-model="editedClass.class_group_id"
                    v-bind="attrs"
                    :items="selectClsGroup"
                    item-text="class_group_name"
                    item-value="class_group_id"
                    :menu-props="{ auto: true }"
                    label="Class Group"
                    single-line
                    prepend-icon="$vuetify.icons.icon_mdi_group"
                    clearable
                    v-on="on"
                    style="min-width: 100px; max-width: 400px"
                    class="mx-4"
                    v-if="editedClass.class_group !== 'Individual'"
                    @change="noActionsTaken = false"
                  />
                </template>
                <span>Add selected classes to a Class Group</span>
              </v-tooltip>
            </v-card>
            <v-card
              flat
              class="d-flex flex-row flex-wrap mt-4 justify-center"
            >
              <v-text-field
                v-model="editedClass.paymentClass"
                label="Payment (PEN)"
                style="max-width: 130px"
                :rules="inputRulesReq"
                :disabled="editedClass.outgoing_id !== null || editedClass.teacher_id === null || !editedClass.teacher_id"
                @change="editedClass.autoPayment = false, noActionsTaken = false"
              />
              <v-switch
                v-model="editedClass.autoPayment"
                label="auto"
                class="mr-5"
                hide-details
                :disabled="
                  editedClass.outgoing_id !== null ||
                    !editedClass.teacher_id
                "
                @change="onAutoPaymentToggle"
              />
              <span
                v-if="editedClass.rate"
                class="pa-5"
              >
                Rate: {{ editedClass.rate }} PEN/hr
              </span>
              <v-card
                v-if="editedClass.individual_instead && (resourcesInClass[0]?.individual_instead === 1 || resourcesInClass[0]?.individual_instead)"
                flat
                class="mt-4"
              >
                <v-chip
                  small
                  rounded
                  class="ma-1 white--text"
                  color="brown lighten-2"
                >
                  Individual Instead
                </v-chip>
              </v-card>
              <v-card
                flat
                class="d-flex flex-row flex-wrap"
              >
                <v-card-subtitle
                  v-if="editedClass.outgoing_id !== null"
                  class="ma-4 mt-5"
                  flat
                >
                  Paid: {{ editedClass.currency }} {{ editedClass.paid }} on {{ formattedDate(editedClass.datePaid, 'date') }}
                </v-card-subtitle>
              </v-card>
            </v-card>
            <v-card
              flat
              class="d-flex flex-column"
            >
              <v-data-table
                v-if="resourcesInClass.length > 0"
                :headers="headersResourcesInClass"
                :items="resourcesInClass"
                item-key="resource_id"
                class="mb-6 mx-4"
                hide-default-footer
                disable-pagination
                sort-by="start"
              >
                <template v-slot:[`item.full_name`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-flex flex-row align-center">
                        <v-btn 
                          x-small
                          fab
                          v-bind="attrs"
                          class="mr-3" 
                          v-on="on"
                          @click="goClient(item.client_id, item.resource_id)"
                        >
                          <v-icon>mdi-arrow-up-bold</v-icon>
                        </v-btn>
                        <v-chip
                          small
                          :style="getStudentColorStyle(item)"
                        >
                          <strong v-if="editedResource.resource_id === item.resource_id">
                            {{ item.full_name }}
                          </strong>
                          <span v-else>
                            {{ item.full_name }}
                          </span>
                        </v-chip>
                      </div>
                    </template>
                    <span>Go to Client</span>
                  </v-tooltip>
                </template>

                <template v-slot:[`item.phone_client`]="{ item }">
                  <div class="d-flex align-center">
                    <span>{{ item.phone_client }}</span>

                    <v-btn
                      v-if="item.phone_client"
                      icon
                      x-small
                      class="ml-1"
                      @click="copyToClipboard(item.phone_client)"
                    >
                      <v-icon small>
                        mdi-content-copy
                      </v-icon>
                    </v-btn>

                    <v-btn
                      v-if="item.phone_client"
                      icon
                      small
                      class="ml-2"
                      :href="whatsappUrl(item.phone_client, item.full_name)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <v-icon color="green">mdi-whatsapp</v-icon>
                    </v-btn>
                  </div>
                </template>

                <template v-slot:[`item.minutes_available`]="{ item }">
                  <span
                    v-if="(Math.floor(item.minutes_available / 60 * 2) / 2) < 0"
                    style="color: red"
                  >
                    {{ Math.floor(item.minutes_available / 60 * 2) / 2 }}
                  </span>
                  <span v-else>
                    {{ Math.floor(item.minutes_available / 60 * 2) / 2 }}
                  </span>
                </template>
                <template v-slot:[`item.goCourse`]="{ item }">
                  <v-btn 
                    v-if="editedClass.class_id" 
                    x-small 
                    rounded 
                    @click="openDialogCourse(item.resource_id), closeDialogClass()"
                  >
                    Open Course
                  </v-btn>
                </template>
              </v-data-table>
              <span class="ml-3 mb-4">Total {{ resourcesInClass.length }} student(s)</span>
            </v-card>
          </v-card-text>
          <v-card-actions class="d-flex flex-column">
            <v-card
              flat
              class="mt-2"
              width="95%"
            >
              <v-textarea
                v-model="editedClass.comments"
                class="rounded-xl mx-3"
                clearable
                counter="100"
                outlined
                no-resize
                label="Comments (100 max)"
                :rules="[v => (v || '' ).length <= 100 || 'Comments must be 100 characters or less']"
                @change="noActionsTaken = false"
              />
            </v-card>
            <v-card
              flat
              width="100%"
              class="d-flex flex-row flex-wrap"
            >
              <v-btn 
                v-if="editedClass.class_id" 
                class="px-4 my-0 mx-5"
                :disabled="editedClass.outgoing_id !== null"
                @click="deleteSingleClass(originalClass)"
              >
                <span class="mr-2">Remove Class</span>
                <v-icon>
                  $vuetify.icons.icon_mdi_delete
                </v-icon>
              </v-btn>
              <v-spacer />
              <v-btn 
                color="ppc_darkgreen darken-1" 
                text 
                :disabled="$store.state.loadingApp > 0"
                @click="dialogClass = false, 
                        cancelDialogClass()"
              >
                Cancel
              </v-btn>
              <!-- {{ allHoursUsedInClass(resourcesInClass) }} {{ $store.state.loadingApp > 0 }} {{ noActionsTaken }} -->
              <v-btn 
                color="ppc_darkgreen darken-1" 
                text 
                :disabled="allHoursUsedInClass(resourcesInClass) || $store.state.loadingApp > 0 || noActionsTaken"
                @click="saveSingleClass(editedClass)"
              >
                Save
              </v-btn>
            </v-card>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

        
    <v-dialog
      v-model="dialogSelectResources"
      width="80vw"
      persistent
    >
      <v-card>
        <v-card-title 
          class="d-flex justify-space-between align-center"
          style="background-color: lightgray; height: 80px;"
        >
          <span>
            Add/Remove Student(s)
          </span>
          <v-card-subtitle class="black--text">
            <span v-if="selectedStudents[0]">
              {{
                [
                  selectedStudents[0].class_language,
                  selectedStudents[0].class_group,
                  selectedStudents[0].class_type,
                  selectedStudents[0].class_location
                ]
                .filter(Boolean)
                .join(' • ')
              }}
            </span>
          </v-card-subtitle>
        </v-card-title>
        
        <div
          class="d-flex flex-row mt-4"
          style="gap: 20px;"
        >
          <!-- LEFT: Available students -->
          <div style="width: 55%;">
            <h3 class="ml-4">
              Available Students <span class="caption grey--text ml-2">for {{ selectedClassesCourseOrGroup.length }} class(es) 
                and {{ minutesToHoursLabel(totalSelectedClassMinutes) }} hrs</span>
            </h3>
            <v-data-table
              :headers="headersResourcesSelectAvailable"
              :items="availableStudents"
              hide-default-footer
              :items-per-page="-1"
              disable-pagination
              item-key="resource_id"
              sort-by="full_name"
              dense
            >

              <template v-slot:[`item.class_language`]="{ item }">
                <v-icon small>{{ getIcon(item) }}</v-icon>
              </template>

              <template v-slot:[`item.class_location`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_location === 'School Cusco'"
                      v-on="on"
                    >
                      mdi-home
                    </v-icon>
                  </template>
                  <span>School Cusco</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_location === 'Online'"
                      small
                      v-on="on"
                    >
                      {{ "$vuetify.icons.icon_mdi_headphones" }}
                    </v-icon>
                  </template>
                  <span>Online</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_location === 'Urubamba'"
                      v-on="on"
                    >
                      mdi-image-filter-hdr
                    </v-icon>
                  </template>
                  <span>Urubamba</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.class_group`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_group === 'Individual'"
                      v-on="on"
                      small
                    >
                      $vuetify.icons.icon_mdi_account
                    </v-icon>
                  </template>
                  <span>Individual</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_group === 'Group'"
                      v-on="on"
                      small
                    >
                      $vuetify.icons.icon_mdi_account_group
                    </v-icon>
                  </template>
                  <span>Group</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.class_type`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_type === 'Normal'"
                      v-on="on"
                      small
                    ></v-icon>
                  </template>
                  <span>Normal</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.class_type === 'Special'"
                      v-on="on"
                      small
                    >
                      $vuetify.icons.icon_mdi_star
                    </v-icon>
                  </template>
                  <span>Special</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.full_name`]="{ item }">
                <v-chip
                  x-small
                  :style="getStudentColorStyle(item)"
                >
                  {{ item.full_name }}
                </v-chip>
              </template>
                            
              <template v-slot:[`item.addToClasses`]="{ item }">
                <v-btn
                  x-small
                  fab
                  @click="addStudent(item)"
                  :disabled="!item.enough_hours"
                >
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </template>

              <template v-slot:[`item.start`]="{ item }">
                {{ formattedDate(item.start, 'date') }}
              </template>

              <template v-slot:[`item.end`]="{ item }">
                {{ formattedDate(item.end, 'date') }}
              </template>

              <template v-slot:[`item.minutes_available_preview`]="{ item }">
                <span v-if="item.enough_hours" style="color: green">
                  {{ minutesToHoursLabel(item.minutes_available_preview) }}
                </span>
                <span v-else>
                  {{ minutesToHoursLabel(item.minutes_available_preview) }}
                </span>
              </template>
            </v-data-table>
          </div>

          <!-- RIGHT: Selected students -->
          <div style="width: 35%;">
            <h3 class="ml-4">
              Classmates<span class="caption grey--text ml-2">after applying</span>
            </h3>
            <v-data-table
              :headers="headersResourcesSelectSelected"
              :items="selectedStudents"
              hide-default-footer
              :items-per-page="-1"
              disable-pagination
              item-key="resource_id"
              sort-by="full_name"
              dense
            >

              <template v-slot:[`item.addToClasses`]="{ item }">
                <!-- removable students -->
                <v-btn
                  x-small
                  fab
                  :disabled="selectedStudents.length <= 1"
                  @click="removeStudent(item)"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </template>

              <template v-slot:[`item.full_name`]="{ item }">
                <div class="d-flex align-center">
                  <v-chip
                        v-if="item.resource_id === editedResource.resource_id"
                        x-small
                        :style="getStudentColorStyle(item)"
                    >
                        <strong>{{ item.full_name }}</strong>
                    </v-chip>
                    <v-chip
                        v-else
                        x-small
                        :style="getStudentColorStyle(item)"
                    >
                        {{ item.full_name }}
                    </v-chip>
                </div>
              </template>

              <template v-slot:[`item.start`]="{ item }">
                {{ getStudentStart(item) }}
              </template>

              <template v-slot:[`item.end`]="{ item }">
                {{ getStudentEnd(item) }}
              </template>

              <template v-slot:[`item.minutes_available_preview`]="{ item }">
                <span v-if="item.minutes_available_preview > 0" style="color: green">
                  {{ minutesToHoursLabel(item.minutes_available_preview) }}
                </span>
                <span v-else>
                  {{ minutesToHoursLabel(item.minutes_available_preview) }}
                </span>
              </template>
            </v-data-table>
          </div>
        </div>
        <v-card-actions class="d-flex flex-column">
          <v-card
            flat
            class="d-flex flex-row flex-wrap"
            width="100%"
          >
            <v-spacer />
            <v-btn 
              color="ppc_darkgreen darken-1" 
              text 
              @click="cancelSelectStudent"
            >
              Cancel
            </v-btn>
            <v-btn
              color="ppc_darkgreen darken-1" 
              text 
              @click="applySelectedStudents"
              :disabled="negativeHoursInSelectedStudents || selectedStudents.length === 0 || (selectedStudents[0].class_group === 'Individual' && selectedStudents.length !== 1)"
            >
              Apply
            </v-btn>
          </v-card>
        </v-card-actions>
      </v-card>
    </v-dialog>
        

    <v-dialog
      v-model="dialogForm"
      :retain-focus="false"
      width="fit-content"
    >
      <div class="d-flex justify-space-around">
        <v-card 
          flat
          class="d-flex flex-column pa-12"
          width="210mm"
          min-height="297mm"
        >
          <span
            class="ma-2"
            v-html="outputData.formHTML"
          />
          <div class="d-flex flex-column invoiceButtons">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="ppc_pink"
                  fab
                  class="white--text my-2"
                  small
                  @click="dialogForm = false"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>close</span>
            </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="orange"
                  fab
                  class="white--text my-2"
                  small
                  @click="createEmailContent(false, null)"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-email
                  </v-icon>
                </v-btn>
              </template>
              <span>email</span>
            </v-tooltip>
                        
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="blue"
                  fab
                  class="white--text my-2"
                  small
                  @click="printNow(outputData.formHTML)"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>print/download</span>
            </v-tooltip>
          </div>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog 
      v-model="dialogEmail"
      :retain-focus="false"
      max-width="50vw"
    >
      <v-flex>
        <v-card>
          <v-card-title>
            Prepare your email
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form>
                <v-flex>
                  <v-text-field
                    v-model="outputData.emailList"
                    filled
                    rounded
                    label="to (seperated by commas)"
                  />
                  <v-text-field
                    v-model="outputData.emailSubject"
                    filled
                    rounded
                    label="subject"
                  />
                  <v-textarea
                    v-model="outputData.emailIntro"
                    filled
                    rounded
                    dense
                    height="50vh"
                    no-resize
                    label="intro"
                  />
                </v-flex>
                        
                <v-flex
                  d-flex
                  justify-center
                >
                  <v-btn
                    color="ppc_darkgreen  white--text"
                    text
                    @click="dialogEmail = !dialogEmail"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    color="ppc_darkgreen  white--text"
                    text
                    @click="sendEmail(outputData.resourceId)"
                  >
                    Send
                  </v-btn>
                </v-flex>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>
  </v-container>
</template>

<script>

import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import dayjs from 'dayjs';
import compare from '../mixins/compare';
import { print } from 'html-to-printer';
import decUtil from '@/utils/decimalUtils';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export default {

    mixins: [inputRules, formattedDate, compare],
    data: () => ({
        availableStudents: [],
        selectedStudents: [],
        itemsTabCourses: [
            'Courses', 'Class Groups', 'Calendar', 'Teachers'
        ],
        decUtil,
        itemsTabTeachers: [],
        indexTeachers: [],
        itemsTabResources: [
            'Groups', 'Individuals'
        ],
        freeze: false,
        dialogCourse: false,
        dialogClsGroup: false,
        dialogClass: false,
        dialogSelectResources: false,
        dialogEmail: false,
        classesResourceMap: {},
        weekSelect:{
            day: [],
                },
        resourcesLoaded: [],
        editedResource: {},
        editedClass: {},
        originalClass: {},
        headersResourcesAll: [
            { 
                text: '',
                align: 'start',
                value: 'class_language',
                width: '0px'
            },
            // { text: 'id', value: 'resource_id' },
            { text: 'Student', value: 'full_name' },
            { text: 'Agency', value: 'agency', width: '30px' },
            { text: 'Start on', value: 'start', width: '110px' },
            { text: 'End before', value: 'end', width: '110px' },
            { text: 'Hours sold', value: 'hours', width: '30px' },
            { text: 'Per class', value: 'hours_per_class', width: '30px' },
            { text: 'Location', value: 'class_location', width: '30px' },
            { text: 'Graduation', value: 'graduationClassStart', width: '110px' },
            // { text: 'Planned', value: 'minutes_planned', width: '30px' },
            // { text: 'Finished', value: 'minutes_completed', width: '30px' },
            { text: 'Hours Available', value: 'minutes_available', width: '30px' },
            { text: 'Status', value: 'statusResourceId', width: '30px' },
            { text: 'Comments', value: 'comments' },
            { text: 'Schedule', value: 'sendScheduleStudent', width: '30px' },
            { text: 'Actions', value: 'actions', width: '80px'},
        ],
        headersClsGroups: [
            { 
                text: '',
                align: 'start',
                value: 'class_language',
                width: '0px'
            },
            { text: 'Name', value: 'class_group_name', width: '150px' },
            { text: 'Level', value: 'language_level', width: '10px' },
            { text: 'Type', value: 'class_type', width: '10px' },
            { text: 'Location', value: 'class_location', width: '10px' },
            { text: 'Start on', value: 'startTime', width: '110px' },
            { text: 'End before', value: 'endTime', width: '110px' },
            { text: '#Classes', value: 'amount_of_classes', width: '10px' },
            { text: 'Hours', value: 'hours_total', width: '10px' },
            { text: 'Comments', value: 'comments', width: '150px' },
            { text: 'Actions', value: 'actions', width: '80px'},
        ],
        headersClassesInResource: [
            // { text: 'Key', value: 'key' },
            { text: 'Date', value: 'start', width: '150px' },
            { text: 'New', value: 'newClass', width: '50px' },
            { text: 'From', value: 'startTime', width: '80px' },
            { text: 'Until', value: 'endTime', width: '80px' },
            { text: 'Duration', value: 'duration', width: '80px' },
            { text: 'Individual', value: 'individual_instead', width: '10px' },
            { text: 'Teacher', value: 'contact', width: '100px' },
            { text: 'Students', value: 'studentsObject', width: '300px' },
            { text: 'Class Group', value: 'class_group_name', width: '120px' },
            { text: 'Payment (paid)', value: 'outgoing_id', width: '120px' },
            { text: 'Room', value: 'class_room', width: '80px' },
            { text: 'Actions', value: 'actions', width: '300px'},
        ],
        headersClassesInClsGroup: [
            // { text: 'Key', value: 'key' },
            { text: 'Date', value: 'start', width: '150px' },
            { text: 'From', value: 'startTime', width: '80px' },
            { text: 'Until', value: 'endTime', width: '80px' },
            { text: 'Duration', value: 'duration', width: '80px' },
            { text: 'Individual', value: 'individual_instead', width: '10px' },
            { text: 'Teacher', value: 'contact', width: '100px' },
            { text: 'Students', value: 'studentsObject', width: '300px' },
            { text: 'Paid', value: 'outgoing_id', width: '120px' },
            { text: 'Room', value: 'class_room', width: '80px' },
            { text: 'Actions', value: 'actions', width: '300px'},
        ],
        headersClassesTeachers: [
            { text: 'Class', value: 'start', width: '140px' },
            { text: 'Duration', value: 'duration' },
            { text: 'Teacher', value: 'contact' },
            { text: 'Students', value: 'students' },
            { text: 'Ind', value: 'individual_instead' },
            { text: 'Payment', value: 'outgoing_id' },
            { text: 'Room', value: 'class_room' },
            { text: 'Actions', value: 'actions'},
        ],
        headersResourcesInClass: [
            { text: 'Student', value: 'full_name' },
            { text: 'phone', value: 'phone_client' },
            { text: 'Level', value: 'initial_spanish_level' },
            { text: 'Available (hrs)', value: 'minutes_available'},
            { text: '', value: 'goCourse', width: '80px'},
        ],
        headersResourcesInCourseOrGroup: [
            { text: 'Classmate(s)', value: 'full_name', width: '140px' },
            { text: 'Cancel changes and open Course', value: 'goCourse', width: '50px'},
            { text: 'Available (hrs)', value: 'minutes_available', width: '10px'},
            { text: 'Level', value: 'initial_spanish_level', width: '10px'},
            { text: 'Class Schedule', value: 'sendScheduleStudent', width: '30px'},
        ],
        baseHeadersResourcesSelect: [
            { text: 'Name', value: 'full_name' },
            { text: 'Start', value: 'start' },
            { text: 'End', value: 'end' },
            { text: 'Available (hrs)', value: 'minutes_available_preview', width: '10px' },
        ],
        editedClassesInResource: [],
        classesInClsGroup: [],
        editedClassesInClsGroup: [],
        resourcesInClass: [],
        editedResourcesInClass: [],
        selectedClassesCourseOrGroup: [],
        selectedClassesTeachers: [],
        selectedClassesCopy: [],
        resourcesSelectList: [],
        selectedResources: [],
        selectedResourcesSingleSelect: true,
        availableHoursClass: null,
        events: [],
        focusCalendar: '',
        categoriesCalendar: [],
        createEvent: null,
        createStart: null,
        extendOriginal: null,
        categoryStart: null,
        dragEvent: null,
        dragEventOriginal: null,
        types: ['month', 'week', 'day', '4day'],
        week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        searchResourceTableTeaching: '',
        searchClsGroups: '',
        scopeDates: [],
        resourceTeacher_id: null,
        resourceClassStartTime: null,
        resourceClassEndTime: null,
        resourceClass_room_id: null,
        extendingBottom: false,
        claimDraggingTime: false,
        noActionsTaken: true,
        legendColorsCourses: [],
        legendColorsCalendar: [],
        legendColorsClsGroups: [],
        typeColors: [ 
            { id: 'GroupNormal', name: 'Group Normal', color: '#93c595'},
            { id: 'GroupSpecial', name: 'Group Special', color: '#d6f3d8'},
            { id: 'GroupNormalClsGroup', name: 'Normal Class Group', color: '#d2dd7e'},
            { id: 'GroupSpecialClsGroup', name: 'Special Class Group', color: '#90ee90'},
            { id: 'IndividualNormal', name: 'Ind Normal', color: '#91d5de'},
            { id: 'IndividualSpecial', name: 'Ind Special', color: '#c6eef3'},
            { id: 'DoubleBookingAula', name: 'Classroom Double Booked', color: '#f3c6c6'},
            { id: 'DoubleBookingProfe', name: 'Profe Double Booked', color: '#e7a67a'},
            // { id: 'OutsideCourseDates', name: 'Outside Course Dates', color: 'grey'},
        ],
        rendererKeyCalendar: Math.random(),
        loadingCalendar: false,
        loadingCourses: false,
        loadingTeachers: false,
        loadingClsGroups: false,
        classRoomsWithAvailability: [],
        allTeachers: [],
        queSetSendToTeachers: new Set(),
        queSetSendToStudents: [],
        classGroupsLoadedOpen: [],
        classGroupsLoadedClosed: [],
        classGroupsDisplay: [],
        editedClsGroup: {},
        classGroupId: null,
        classGroupIdHours: null,
        // showClsGroupsOnly: false,
        classesCalendarLoaded: [],
        dialogForm: false,
        outputData: {},
        emailList: null,
        emailIntro: null,
        emailSubject: null,
        existingColors: [],
        openCourse: null,
        openClsGroup: null,
        newClsGroup: null,
        dialogCourseReady: false,
        dialogClsGroupReady: false,
        minutesAvailableAtDialogOpenCourse: new Map(),
        minutesAvailableAtDialogOpenClsGroup: new Map(),
    }),

    computed: {

        classRooms () {
            let classrooms = this.$store.getters.classRooms;
            classrooms = classrooms.sort(this.dynamicSort('name'));
            return classrooms;
        },

        scopeLanguage () {
            return this.$store.getters.scopeLanguage
        },

        scopeOnline () {
            return this.$store.getters.scopeOnline
        },

        scopeResources () {
            return this.$store.getters.scopeResources
        },

        scopeClassGroups () {
            return this.$store.getters.scopeClassGroups
        },

        scopeClassesTeachers () {
            return this.$store.getters.scopeClassesTeachers
        },

        scopeCalendar () {
            return this.$store.getters.scopeCalendar
        },

        activeTabTeaching: {
            get() {
                return this.$store.getters.activeTabTeaching
            },
            set(val) {
                this.$store.commit('changeActiveTabTeaching', val)
            }
        },

        activeTabTeachers: {
            get() {
                return this.$store.getters.activeTabTeachers
            },
            set(val) {
                this.$store.commit('changeActiveTabTeachers', val)
            }
        },

        scopeTypeResources () {
            return this.$store.getters.scopeTypeResources
        },

        activeTeachers () {
            return this.$store.getters.activeTeachers
        },

        selectAllTeachers () {
            return this.$store.getters.selectAllTeachers
        },

        computedDateFormatted () {
            return this.formattedDate(this.focusCalendar)
        },

        itemsPerPage () {
            return this.$store.getters.itemsPerPage
        },

        totalClassesCount() {
            return this.editedClassesInClsGroup.length;
        },

        totalHours() {
            const minutes = this.editedClassesInClsGroup.reduce(
            (sum, cls) => sum + (cls.duration || 0),
            0
            );
            return (minutes / 60).toFixed(2);
        },

        selectedClassesCount() {
            return this.selectedClassesCourseOrGroup.length;
        },

        selectedHours() {
            const minutes = this.selectedClassesCourseOrGroup.reduce(
            (sum, cls) => sum + (cls.duration || 0),
            0
            );
            return (minutes / 60).toFixed(2);
        },

        hasSelectedClasses() {
            return this.selectedClassesCourseOrGroup.length > 0;
        },

        selectClsGroup() {
            return JSON.parse(JSON.stringify(this.classGroupsLoadedOpen));
        },

        newClsGroupNotUnique() {

            const name = this.newClsGroup?.trim();
            if (!name) return false;

            const allGroups = [
                ...(this.classGroupsLoadedOpen || []),
                ...(this.classGroupsLoadedClosed || [])
            ];

            return allGroups.some(g =>
                g.class_group_name?.trim().toLowerCase() === name.toLowerCase()
            );
        },

        totalMinutesPreview() {
            return (this.selectedClassesCourseOrGroup || []).reduce((sum, cls) => {
                return sum + (cls.minutes_used ?? 0);
            }, 0);
        },

        headersResourcesSelectAvailable() {
            return [
              { text: '', value: 'class_language', width: '20px' },
              { text: '', value: 'class_group', width: '20px' },
              { text: '', value: 'class_location', width: '20px' },
              { text: '', value: 'class_type', width: '20px' },
              ...this.baseHeadersResourcesSelect,
              { text: 'Add', value: 'addToClasses', sortable: false }
            ];
        },

        headersResourcesSelectSelected() {
            return [
                { text: 'Remove', value: 'addToClasses', sortable: false },
                ...this.baseHeadersResourcesSelect
            ];
        },

        effectiveMinutesRequired() {
            const base = Number(this.totalSelectedClassMinutes) || 0;

            const firstClass = this.selectedClassesCourseOrGroup?.[0];
            if (!firstClass) return base;

            const isSpanishGroup =
                firstClass.class_language === 'Spanish' &&
                firstClass.class_group === 'Group';

            const isSingle = this.selectedStudents.length === 1;

            return (isSpanishGroup && isSingle)
                ? base * (4 / 3)
                : base;
        },


        oneOfClassesPaid() {
            if (this.selectedClassesCourseOrGroup.find(obj => {
                return obj.outgoing_id !== null
            }) !== undefined) {
                return true
            } else {
                return false
            }
        },

        differentStudentsInClasses() {
            const classes = this.selectedClassesCourseOrGroup || [];
            if (classes.length <= 1) return false;

            // Normalize a class → sorted string of resource_ids
            const normalize = (cls) => {
                return (cls.studentsObject || [])
                    .map(s => String(s.resource_id))
                    .sort()
                    .join('|');
            };

            const first = normalize(classes[0]);

            return classes.some(cls => normalize(cls) !== first);
        },

        resourcesInCourseComputed() {

            if (
                !this.dialogCourseReady ||
                !this.dialogBaseline ||
                !this.minutesAvailableAtDialogOpenCourse
            ) {
                return [];
            }

            // console.log("RECOMPUTE", this.minutesAvailableAtDialogOpenCourse);

            const base = this.buildResourcesInCourse({
                baselineClasses: this.dialogBaseline.classes,
                editedClasses: this.editedClassesInResource,
                minutesMap: this.ensureMinutesMap(),
                resource: this.editedResource
            });

            return base.map(item => {
                const loaded = this.resourceMap?.get(String(item.resource_id)) || {};

                return {
                    ...item,
                    full_name: loaded.full_name,
                    sendScheduleStudent: loaded.sendScheduleStudent,
                    color: this.intToColor(loaded.id),
                    initial_spanish_level: this.editedResource?.initial_spanish_level,
                };
            });
        },

        minutesAvailableForStudentComputed() {

            if (
                !this.dialogCourseReady ||
                !this.editedResource ||
                !this.editedResource.resource_id ||
                !this.minutesAvailableAtDialogOpenCourse ||
                !this.resourcesInCourseComputed.length
            ) {
                return 0; 
            }

            const me = this.resourcesInCourseComputed.find(
                r => String(r.resource_id) === String(this.editedResource.resource_id)
            );

            return me?.minutes_available ?? 0;
        },

        tooManyHoursUsedComputed() {
            return this.resourcesInCourseComputed.some(
                r => r.minutes_available < 0
            );
        },

        resourcesInClsGroupComputed() {

            if (
                !this.dialogClsGroupReady ||
                !this.dialogClsGroupBaseline ||
                !this.minutesAvailableAtDialogOpenClsGroup
            ) {
                return [];
            }

            const base = this.buildResourcesInCourse({
                baselineClasses: this.dialogClsGroupBaseline.classes,
                editedClasses: this.editedClassesInClsGroup,
                minutesMap: this.minutesAvailableAtDialogOpenClsGroup,
                resource: this.editedClsGroup
            });

            return base.map(item => {
                const loaded = this.resourceMapClsGroup?.get(String(item.resource_id)) || {};

                return {
                    ...item,
                    full_name: loaded.full_name,
                    sendScheduleStudent: loaded.sendScheduleStudent,
                    color: this.intToColor(loaded.id),
                };
            });
        },

        tooManyHoursUsedClsGroupComputed() {
            return this.resourcesInClsGroupComputed.some(
                r => r.minutes_available < 0
            );
        },

        resourcesScope() {
            return this.filterResources(this.resourcesLoaded);
        },

        totalSelectedClassMinutes() {
            return this.selectedClassesCourseOrGroup.reduce(
                (acc, c) => acc + (Number(c.duration) || 0),
                0
            );
        },

        resourceMap() {
            return new Map(
                (this.resourcesLoaded || []).map(r => [String(r.resource_id), r])
            );
        },

        negativeHoursInSelectedStudents() {
            return this.selectedStudents.some(
                r => r.minutes_available_preview < 0
            );
        }

    },

    beforeCreate () {
        if (this.$store.state.accessTeaching === 0) {
            this.$router.push({ name: 'Illegal' })
        }
    },

    created () {
        dayjs.locale("en");
        this.initialize()
    },

    methods: {

        whatsappUrl(phone, name) {
          const number = phone.replace(/\D/g, '')
          const message = `Hola ${name}, `

          return `https://wa.me/${number}?text=${encodeURIComponent(message)}`
        },

        async copyToClipboard(text) {
          try {
            await navigator.clipboard.writeText(text || '');
            this.$store.dispatch('successMessage', 'Copied to clipboard');
          } catch (err) {
            console.error('Failed to copy:', err);
          }
        },

        async initialize () {
            var date = new Date();
            this.focusCalendar = this.formattedDate(date,'date');
            this.$store.dispatch('setLoadingApp', 1);
            this.createLegendColorsCalendar();
            this.createLegendColorsClsGroups();
            this.freeze = true;
            this.allTeachers = JSON.parse(JSON.stringify(await this.$store.dispatch('getAllTeachers')));
            await this.$store.dispatch('getContacts');
            await this.$store.dispatch('breadcrumbs', ['Teaching']);
            await this.formCategoriesCalendar();
            await this.loadDataAll();
            this.freeze = false;
            if (this.$route.params.resourceId) {
                if(this.activeTabTeaching !== 0) {
                    this.activeTabTeaching = 0;
                }
                this.openDialogCourse(this.$route.params.resourceId);
            }
            this.checkAllTeachersSelected();
        },

        minutesToHours1Decimal(minutes) {
            if (minutes == null) return '';
            return (minutes / 60).toFixed(1);
        },

        minutesToHoursHalf(minutes) {
            if (minutes == null) return '';
            return (Math.floor((minutes / 60) * 2) / 2).toFixed(1);
        },

        durationHoursLabel(item) {
            if (!item || item.duration == null) return '';
            return `${(item.duration / 60).toFixed(1)}h`;
        },

        studentsLabel(item) {
            if (!item) return '';
            return `(${item.amount_students}) ${item.students}`;
        },

        paymentClassFormatted(item) {
            if (!item || item.paymentClass == null) return '';
            return `S/. ${this.decUtil.format(item.paymentClass)}`;
        },

        changeScopeLanguage (event) {
            console.log('scopeLanguage', event);
            this.$store.dispatch('changescopeLanguage', event);
            this.showAllTeachers(true);
            this.loadDataAll();
        },

        startDateLabel(item) {
            return item?.start
            ? this.formattedDate(item.start, 'dateDay')
            : '';
        },

        timeLabel(value) {
            return value ?? '';
        },

        yesNo(value) {
            return value === 1 ? 'Yes' : 'No';
        },

        minutesToHoursLabel(minutes) {
            if (minutes == null) return '';
            return (minutes / 60).toFixed(1);
        },

        onAutoPaymentToggle() {
            const result = this.calcPaymentClass(this.editedClass);

            this.editedClass.paymentClass =
            this.decUtil.toDec(result.paymentClass).toNumber();

            this.editedClass.rate =
            this.decUtil.toDec(result.rate).toNumber();

            this.noActionsTaken = false;
        },

        checkLoadingApp () {
            if (this.activeTabTeaching === 0 && this.loadingCourses) {
                // console.log('checkLoadingApp #0 setting LoadingApp 1');
                this.$store.dispatch('setLoadingApp', 1);
            } else if (this.activeTabTeaching === 1 && this.loadingClsGroups) {
                // console.log('checkLoadingApp #1 setting LoadingApp 1');
                this.$store.dispatch('setLoadingApp', 1);
            } else if (this.activeTabTeaching === 2 && this.loadingCalendar) {
                // console.log('checkLoadingApp #2 setting LoadingApp 1');
                this.$store.dispatch('setLoadingApp', 1);
            } else if (this.activeTabTeaching === 3 && this.loadingTeachers) {
                // console.log('checkLoadingApp #3 setting LoadingApp 1');
                this.$store.dispatch('setLoadingApp', 1);
            } else {
                if (this.$store.state.loadingApp > 0 && !this.dialogClsGroup && !this.dialogCourse) {
                    // console.log('checkLoadingApp setting LoadingApp 0');
                    this.$store.dispatch('setLoadingApp', 0);
                } else {
                    // console.log('checkLoadingApp LoadingApp already 0');
                }
            }
        },

        async loadDataAll () {
            // console.log('loadDataAll');
            var date = new Date();
            let start = date.getTime();
            console.log('***1 loadDataAll');
            await Promise.all([this.loadCourses(), this.loadTeachers(), this.loadCalendar(), this.loadClsGroups()]).then(() => {
                this.checkGraduations();
                date = new Date();
                let end = date.getTime();
                const totalTime = ((end-start)/1000);
                console.log('***2 loadDataAll', totalTime);
                this.cleanTableClsGroups();
            });
        },

        async loadCourses () {

            // var date = new Date();
            // let start = date.getTime();
            // console.log('***1 loadCourses');

            this.loadingCourses = true;
            this.checkLoadingApp();
            if (this.scopeResources === 'completed') {
                this.resourcesLoaded = await this.$store.dispatch('getResourcesClassesAll');
            } else {
                this.resourcesLoaded = await this.$store.dispatch('getResourcesClassesIncompleted');
            }
            // console.log('loadCourses test2')
            this.resourcesLoaded = this.prepareResourcesLoaded(this.resourcesLoaded);

            // console.log('loadCourses test3');
            this.selectedClassesCourseOrGroup = [];
            this.loadingCourses = false;
            if (this.activeTabTeaching === 0) {
                this.checkLoadingApp();
            }

            // date = new Date();
            // let end = date.getTime();
            // const totalTime = ((end-start)/1000);
            // console.log('***2 loadCourses end', totalTime);

        },

        prepareResourcesLoaded(resources) {
            for (let i = 0; i < resources.length; i++) {
                resources[i].start = this.formattedDate(resources[i].start, 'date')
                resources[i].end = this.formattedDate(resources[i].end, 'date')
            }
            return resources
        },

        filterResources(resources) {
            if (this.scopeResources === 'notPlanned') {
                resources = resources.filter(function(select_item) {
                    return (select_item.statusResourceId === 9 || select_item.statusResourceId === 10 || select_item.statusResourceId === 11 || select_item.statusResourceId === 12) && select_item.minutes_planned === 0;
                });
            }
            if (this.scopeResources === 'courseNotFinished') {
                resources = resources.filter(function(select_item) {
                    return select_item.statusResourceId !== 1 && select_item.statusResourceId !== 8 && select_item.statusResourceId !== 15 && select_item.minutes_available > 0 && select_item.minutes_completed === select_item.minutes_planned &&  select_item.minutes_planned > 0;
                });
            }
            if (this.scopeResources === 'ongoing') {
                resources = resources.filter(function(select_item) {
                    return select_item.statusResourceId !== 1 && select_item.statusResourceId !== 8 && select_item.statusResourceId !== 15;
                });
            }
            if (this.scopeResources === 'completed') {
                resources = resources.filter(function(select_item) {
                    return select_item.statusResourceId === 1 || select_item.statusResourceId === 15;
                });
            }
            if (this.scopeLanguage === 'Spanish') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_language === 'Spanish';
                });
            } else if (this.scopeLanguage === 'English') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_language === 'English';
                });
            } else if (this.scopeLanguage === 'Quechua') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_language === 'Quechua';
                });
            }
            if (this.scopeOnline === 'online') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_location === 'Online';
                });
            } else if (this.scopeOnline === 'inPerson') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_location === 'School';
                });
            }
            if (this.scopeDates.start || this.scopeDates.end) {
                let start = this.scopeDates.start;
                let end = this.scopeDates.end;
                if (this.scopeDates.start && this.scopeDates.end && this.scopeDates.start > this.scopeDates.end) {
                    this.$store.dispatch('errorMessage', 'between earlier please');
                    return resources;
                }
                if (this.scopeDates.start) {
                    resources = resources.filter(function(select_item) {
                        return select_item.start >= start;
                    });
                }
                if (this.scopeDates.end) {
                    resources = resources.filter(function(select_item) {
                        return select_item.start <= end;
                    });
                }
            }
            if (this.scopeTypeResources === 'GroupNormal') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_type === 'Normal' && select_item.class_group === 'Group';
                });
            } else if (this.scopeTypeResources === 'GroupSpecial') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_type === 'Special' && select_item.class_group === 'Group';
                });
            } else if (this.scopeTypeResources === 'IndividualNormal') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_type === 'Normal' && select_item.class_group === 'Individual';
                });
            } else if (this.scopeTypeResources === 'IndividualSpecial') {
                resources = resources.filter(function(select_item) {
                    return select_item.class_type === 'Special' && select_item.class_group === 'Individual';
                });
            }
            return resources;
        },

        async loadTeachers () {
            
            // var date = new Date();
            // let start = date.getTime();
            // console.log('***1 loadTeachers');

            this.loadingTeachers = true;
            this.checkLoadingApp();
            let sqlTxt = '(';
            for (let index = 0; index < this.activeTeachers.length; index++) {
                if(this.activeTeachers[index].obsolete === null) {
                    sqlTxt = sqlTxt.concat('teacher_id = ', this.activeTeachers[index].id, ' OR ');
                }
            }
            sqlTxt = sqlTxt.substring(0 , sqlTxt.length - 4);
            if (this.scopeClassesTeachers === 'ongoing') {
                sqlTxt = sqlTxt.concat(') AND (minutes_completed = 0 OR outgoing_id IS NULL)')
            } else if (this.scopeClassesTeachers === 'notPaid') {
                sqlTxt = sqlTxt.concat(') AND outgoing_id IS NULL')
            } else if (this.scopeClassesTeachers === 'finishedNotPaid') {
                sqlTxt = sqlTxt.concat(') AND minutes_completed > 0 AND outgoing_id IS NULL')
            } else if (this.scopeClassesTeachers === 'finishedPaid') {
                sqlTxt = sqlTxt.concat(') AND minutes_completed > 0 AND outgoing_id IS NOT NULL')
            } else if (this.scopeClassesTeachers === 'all') {
                sqlTxt = sqlTxt.concat(')')
            }
            let classesTeachers = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassesSafe', sqlTxt)));

            // create classesResourceMap
            for (let index = 0; index < classesTeachers.length; index++) {
                if (!this.classesResourceMap[classesTeachers[index].class_id]) {
                    this.classesResourceMap[classesTeachers[index].class_id] = [];
                }
                this.classesResourceMap[classesTeachers[index].class_id].push(classesTeachers[index]);
            }


            // console.log('loadTeachers', sqlTxt, classesTeachers.length);
            classesTeachers = this.configureClassesFromDB(classesTeachers);
            this.itemsTabTeachers = [];
            this.indexTeachers = [];
            for (let index = 0; index < this.activeTeachers.length; index++) {
                let teacherId = this.activeTeachers[index].id;
                this.activeTeachers[index].classes = classesTeachers.filter(function(select_item) {
                    return select_item.teacher_id === teacherId;
                })
                this.activeTeachers[index].classes = this.activeTeachers[index].classes.sort(this.dynamicSort('start'));
                let colorNr = 0;
                if (this.activeTeachers[index].classes.length) {
                    let month = dayjs(this.activeTeachers[index].classes[0].start).month();
                    for (let index2 = 0; index2 < this.activeTeachers[index].classes.length; index2++) {
                        if (dayjs(this.activeTeachers[index].classes[index2].start).month() !== month) {
                            month = dayjs(this.activeTeachers[index].classes[index2].start).month();
                            colorNr = colorNr + 1;
                            if (colorNr === 4) {
                                colorNr = 0
                            }
                        }
                        // console.log(this.activeTeachers[index], month, colorNr,('backgroundColor' + (colorNr + 1)).toString())
                        this.activeTeachers[index].classes[index2].teacherRowClass = ('backgroundColor' + (colorNr + 1)).toString();
                    }
                }
                this.activeTeachers[index].totalPayment = this.calcTotalPaymentClasses(this.activeTeachers[index].classes);
                if (((this.scopeLanguage === 'Spanish' && this.activeTeachers[index].spanish === 1) || (this.scopeLanguage === 'Quechua' && this.activeTeachers[index].quechua === 1) || (this.scopeLanguage === 'English' && this.activeTeachers[index].english === 1) || this.scopeLanguage === 'allLanguages') && this.activeTeachers[index].obsolete === null) {
                    if (this.activeTeachers[index].lastSchedule) {
                        this.itemsTabTeachers.push(this.activeTeachers[index].contact + ' (' + this.activeTeachers[index].classes.length + ')');
                    } else {
                        this.itemsTabTeachers.push(this.activeTeachers[index].contact + ' (' + this.activeTeachers[index].classes.length + ') !');
                    }
                    this.indexTeachers.push(this.activeTeachers[index]);
                }
            }
            this.loadingTeachers = false;
            if (this.activeTabTeaching === 3) {
                this.checkLoadingApp();
            }
            
            // date = new Date();
            // let end = date.getTime();
            // const totalTime = ((end-start)/1000);
            // console.log('***2 loadTeachers end', totalTime);

        },

        async loadClsGroups() {
            
            // var date = new Date();
            // let start = date.getTime();
            // console.log('***1 loadClsGroups');

            this.loadingClsGroups = true;
            this.checkLoadingApp();
            if (this.scopeClassGroups === 'closed') {
                this.classGroupsLoadedClosed = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassGroupsSafe', 'closed = 1')));
                this.correctClsGroupsFromDB(this.classGroupsLoadedClosed);
            }
            this.classGroupsLoadedOpen = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassGroupsSafe', 'closed = 0')));
            this.correctClsGroupsFromDB(this.classGroupsLoadedOpen);
            // console.log('loadClsGroups #1', this.classGroupsLoadedOpen, this.classGroupsLoadedClosed);
            if (this.scopeClassGroups === 'open') {
                this.classGroupsDisplay = this.filterClsGroups(this.classGroupsLoadedOpen);
            } else {
                this.classGroupsDisplay = this.filterClsGroups(this.classGroupsLoadedClosed);
            }
            this.loadingClsGroups = false;
            if (this.activeTabTeaching === 1) {
                this.checkLoadingApp();
            }
            
            // date = new Date();
            // let end = date.getTime();
            // const totalTime = ((end-start)/1000);
            // console.log('***2 loadClsGroups end', totalTime);

        },

        filterClsGroups (classGroups) {
            console.log('filterClsGroups', this.scopeTypeResources);
            if (this.scopeTypeResources === 'GroupNormalClsGroup') {
                classGroups = classGroups.filter(function(select_item) {
                    return select_item.class_type === 'Normal';
                });
            } else if (this.scopeTypeResources === 'GroupSpecialClsGroup') {
                classGroups = classGroups.filter(function(select_item) {
                    return select_item.class_type === 'Special';
                });
            }
            // console.log('filterClsGroups #1', classGroups);
            return classGroups;
        },

        correctClsGroupsFromDB(classGroups) {
            for (let i = 0; i < classGroups.length; i++) {
                classGroups[i].startTime = this.formattedDate(classGroups[i].startTime, 'dateTime');
                classGroups[i].endTime = this.formattedDate(classGroups[i].endTime, 'dateTime');
                // classGroups[i].amount_of_classes = classGroups[i].amount_of_classes.toString();
                classGroups[i].hours_total = this.decUtil.format(this.decUtil.toDec(classGroups[i].hours_total),1);
                if (classGroups[i].closed === 0) {
                    classGroups[i].closed = false;
                } else {
                    classGroups[i].closed = true;
                }
            }
            return classGroups;
        },

        calcTotalPaymentClasses(classes) {
            return classes.reduce(
                (sum, c) => sum.plus(this.decUtil.toDec(c.paymentClass || 0)),
                this.decUtil.toDec(0)
            );
        },

        // Calendar ##############################################

        // changeCalendar (event) {
        //     console.log('changeCalendar', event);
        // },

        async loadCalendar () {
            
            // var date = new Date();
            // let start = date.getTime();
            // console.log('***1 loadCalendar');

            this.loadingCalendar = true;
            this.checkLoadingApp();
            let sqlTxt = '(teacher_id = ';
            for (let index = 0; index < this.activeTeachers.length; index++) {
                if ( this.activeTeachers[index].obsolete === null && ((this.activeTeachers[index].visible && this.scopeLanguage === 'allLanguages') || (this.activeTeachers[index].visible && this.activeTeachers[index].spanish === 1 && this.scopeLanguage === 'Spanish') || (this.activeTeachers[index].visible && this.activeTeachers[index].english === 1 && this.scopeLanguage === 'English') || (this.activeTeachers[index].visible && this.activeTeachers[index].quechua === 1 && this.scopeLanguage === 'Quechua'))) {
                    sqlTxt = sqlTxt.concat(this.activeTeachers[index].id, ' OR teacher_id = ')
                }
            }
            sqlTxt = sqlTxt.substring(0, sqlTxt.length - 17);
            sqlTxt = sqlTxt.concat(')');
            if (this.scopeCalendar === 'category') {
                sqlTxt = sqlTxt.concat(" AND DATE(startTime) = DATE('", this.formattedDate(this.focusCalendar,'dateTime'), "')");
            } else if (this.scopeCalendar === 'week') {
                let startWeek = dayjs(this.focusCalendar).day(0);
                let endWeek = dayjs(this.focusCalendar).day(6);
                sqlTxt = sqlTxt.concat(" AND DATE(startTime) >= DATE('", this.formattedDate(startWeek,'dateTime'), "')");
                sqlTxt = sqlTxt.concat(" AND DATE(startTime) <= DATE('", this.formattedDate(endWeek,'dateTime'), "')");
            } else if (this.scopeCalendar === 'month') {
                let startMonth = dayjs(this.focusCalendar).startOf("month");
                let endMonth = dayjs(this.focusCalendar).endOf("month");
                sqlTxt = sqlTxt.concat(" AND DATE(startTime) >= DATE('", this.formattedDate(startMonth,'dateTime'), "')");
                sqlTxt = sqlTxt.concat(" AND DATE(startTime) <= DATE('", this.formattedDate(endMonth,'dateTime'), "')");
            }
            // if (this.showClsGroupsOnly) {
            //     sqlTxt = sqlTxt.concat(' AND class_group_id IS NOT NULL');
            // }
            this.classesCalendarLoaded = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassesSafe', sqlTxt)));

            // date = new Date();
            // let loaded = date.getTime();
            // const loadedTime = ((loaded-start)/1000);
            // console.log('***2 loadCalendar loaded from DB', loadedTime);

            this.classesCalendarLoaded = this.configureClassesFromDB(this.classesCalendarLoaded);
            this.classesCalendarLoaded = this.putColorsToClasses(this.classesCalendarLoaded);
            this.events = await this.filterClassesCalendar(JSON.parse(JSON.stringify(this.classesCalendarLoaded)));
            this.loadingCalendar = false;
            if (this.activeTabTeaching === 2) {
                this.checkLoadingApp();
            }
            
            // date = new Date();
            // let end = date.getTime();
            // const totalTime = ((end-start)/1000);
            // console.log('***3 loadCalendar end', totalTime);

        },

        filterClassesCalendar (classes) {
            if (this.scopeTypeResources === 'GroupNormal') {
                classes = classes.filter(function(select_item) {
                    return select_item.class_type === 'Normal' && select_item.class_group === 'Group';
                });
            } else if (this.scopeTypeResources === 'GroupSpecial') {
                classes = classes.filter(function(select_item) {
                    return select_item.class_type === 'Special' && select_item.class_group === 'Group';
                });
            } else if (this.scopeTypeResources === 'IndividualNormal') {
                classes = classes.filter(function(select_item) {
                    return select_item.class_type === 'Normal' && select_item.class_group === 'Individual';
                });
            } else if (this.scopeTypeResources === 'IndividualSpecial') {
                classes = classes.filter(function(select_item) {
                    return select_item.class_type === 'Special' && select_item.class_group === 'Individual';
                });
            } else if (this.scopeTypeResources === 'GroupNormalClsGroup') {
                classes = classes.filter(function(select_item) {
                    return select_item.class_type === 'Normal' && select_item.class_group === 'Group' && select_item.class_group_id !== null;
                });
            } else if (this.scopeTypeResources === 'GroupSpecialClsGroup') {
                classes = classes.filter(function(select_item) {
                    return select_item.class_type === 'Special' && select_item.class_group === 'Group' && select_item.class_group_id !== null;
                });
            } else if (this.scopeTypeResources === 'DoubleBookingProfe') {
                classes = classes.filter(function(select_item) {
                    return select_item.color === '#e7a67a';
                });
            } else if (this.scopeTypeResources === 'DoubleBookingAula') {
                classes = classes.filter(function(select_item) {
                    return select_item.color === '#f3c6c6';
                });
            }
            return classes;
        },

        checkGraduations () {
            console.log('checkGraduations');
            for (let i = 0; i < this.events.length; i++) {
                let classId = this.events[i].class_id;
                let graduationClass = this.resourcesLoaded.filter(function(select_item){
                    return select_item.graduationClassId === classId
                });
                if (graduationClass.length > 0) {
                    this.events[i].iconGrad = "$vuetify.icons.icon_mdi_school"
                } else {
                    this.events[i].iconGrad = null
                }
            }
            this.rendererKeyCalendar = Math.random();
        },

        configureClassesFromDB(classes) {
            for (let i = 0; i < classes.length; i++) {
                
                // get class room name
                let classRoom =  this.classRooms.filter(function(select_item) {
                    return select_item.id === classes[i].class_room_id;
                })
                
                if (classRoom && classRoom.length > 0) {
                    classes[i].class_room = classRoom[0].label;
                    classes[i].class_room_name = classRoom[0].name;
                }

                if (classes[i].outgoing_id !== null) {
                    classes[i].isSelectable = false;
                } else {
                    classes[i].isSelectable = true;
                }
                
                classes[i].category = classes[i].class_room;
                classes[i].timed = true;
                classes[i].day = this.formattedDate(classes[i].start, 'date');
                classes[i].startTime = this.formattedDate(classes[i].start, 'time');
                classes[i].endTime = this.formattedDate(classes[i].end, 'time');
                classes[i].students = this.createStudentsStringfromObject(classes[i].studentsObject);
                classes[i] = this.styleEvent(classes[i]);
                classes[i].key = this.createUUID();
                if (classes[i].autoPayment === 0) {
                    classes[i].autoPayment = false;
                } else if (classes[i].autoPayment === 1) {
                    classes[i].autoPayment = true;
                }
                
            }
            return classes;
        },

        putColorsToClasses(classes) {
            // console.log('putColorsToClasses');
            for (let i = 0; i < classes.length; i++) {
                if (classes[i].studentsObject === null) {
                    classes[i].color = 'black';
                } else {
                    // console.log('configureClassesFromDB test2',classes[i])
                    if (classes[i].class_group_id !== null) {
                        classes[i].color = this.sortColor(classes[i].class_group + classes[i].class_type + "ClsGroup");
                    } else {
                        classes[i].color = this.sortColor(classes[i].class_group + classes[i].class_type);
                    }
                }
                // check double aula bookings
                let classRoomId = classes[i].class_room_id;
                let classStart = classes[i].start;
                let classEnd = classes[i].end;
                if (classRoomId !== 1 && classes[i].color !== 'black') {
                    let doubleAula = classes.filter(function(select_item) {
                        return select_item.class_room_id === classRoomId && !(select_item.start >= classEnd || select_item.end <= classStart);
                    });
                    if (doubleAula.length > 1) {
                        for (let j = 0; j < doubleAula.length; j++) {
                            doubleAula[j].color = '#f3c6c6';
                        }
                    }
                }
                // check double profe bookings
                let teacherId = classes[i].teacher_id;
                let doubleProfe = classes.filter(function(select_item) {
                    return select_item.teacher_id === teacherId && !(select_item.start >= classEnd || select_item.end <= classStart);
                });
                if (doubleProfe.length > 1 && classes[i].color !== 'black') {
                    for (let j = 0; j < doubleProfe.length; j++) {
                        doubleProfe[j].color = '#e7a67a';
                    }
                }
            }
            return classes;
        },

        styleEvent(itemClass) {
            // console.log('styleEvent', itemClass)
            if (itemClass !== null && itemClass.studentsObject !== null) {
                if (itemClass.class_language === "Spanish") {
                    itemClass.icon = "$vuetify.icons.icon_spanish"
                } else if (itemClass.class_language === "English") {
                    itemClass.icon = "$vuetify.icons.icon_english"
                } else {
                    itemClass.icon = "$vuetify.icons.icon_quechua"
                }
                if (itemClass.class_location === 'Online') {
                    itemClass.iconOnline = "$vuetify.icons.icon_mdi_headphones"
                } else {
                    itemClass.iconOnline = null;
                }
                let profe = null;
                if (itemClass.contact === undefined || itemClass.contact === null || itemClass.contact === '') {
                    profe = 'No Teacher';
                } else {
                    profe = itemClass.contact.split(' ')[0];
                }
                if (this.scopeCalendar === 'category') {
                    if (itemClass.class_group_id !== null) {
                        itemClass.name = itemClass.class_group_name;
                    } else {
                        itemClass.name = this.createStudentsFromObject(itemClass.studentsObject);
                    }
                    itemClass.title = ' '.concat(profe);
                } else if (this.scopeCalendar === 'week') {
                    if (itemClass.class_group_id !== null) {
                        itemClass.name = itemClass.class_group_name;
                    } else {
                        itemClass.name = this.createStudentsFromObject(itemClass.studentsObject);
                    }
                    itemClass.title = ' '.concat(itemClass.class_room, ' ', profe);
                } else if (this.scopeCalendar === 'month') {
                    // itemClass.name = this.createStudentsFromObject(itemClass.studentsObject);
                    if (itemClass.class_group_id !== null) {
                        itemClass.title = ' '.concat(itemClass.class_group_name, ' #', itemClass.studentsObject.length);
                    } else {
                        itemClass.title = ' '.concat(itemClass.class_room, ' ', profe, ' #', itemClass.studentsObject.length);
                    }
                }
                return itemClass
            } else {
                itemClass.icon = null;
                itemClass.iconOnline = null;
                itemClass.name = 'Open Class to remove';
                itemClass.title = 'Error No Students';
                return itemClass;
            }
        },

        createStudentsStringfromObject(studentsObject) {
            // console.log('createStudentsStringfromObject', studentsObject);

            if (!Array.isArray(studentsObject)) {
                console.warn('Invalid studentsObject', studentsObject);
                return 'ERROR';
            }

            const validStudents = studentsObject.filter(student => student);

            if (validStudents.length !== studentsObject.length) {
                console.warn('BAD studentsObject', studentsObject);
            }

            return validStudents
                .map(student => {
                    if (
                        student.initial_spanish_level &&
                        student.initial_spanish_level !== '?'
                    ) {
                        return `${student.full_name} (${student.initial_spanish_level})`;
                    }

                    return student.full_name;
                })
                .join(', ');
        },
        
        createStudentsFromObject(studentsObject) {

          if (!Array.isArray(studentsObject)) {
              console.warn('Invalid studentsObject', studentsObject);
              return 'NO STUDENTS';
          }

          const validStudents = studentsObject.filter(student => student);

          if (validStudents.length !== studentsObject.length) {
              console.warn('BAD studentsObject', studentsObject);
          }

          return validStudents
              .map(student => student.full_name)
              .join(', ');
        },

        createStudentsObject(resources) {
            // console.log('createStudentsObject', resources)
            
            let studentsObject = [];
            let student = {};
            for (let i = 0; i < resources.length; i++) {
                if (!resources[i].resources_classes_id) {
                    resources[i].resources_classes_id = null;
                }
                // if (!resources[i].color) {
                //     resources[i].color = null;
                // }
                student = {
                    full_name: resources[i].full_name,
                    client_id: resources[i].client_id,
                    initial_spanish_level: resources[i].initial_spanish_level,
                    resource_id: resources[i].resource_id,
                }
                // console.log('createStudentsObject test1', student)
                studentsObject.push(student);
            }
            console.log('createStudentsObject test2', studentsObject)
            return studentsObject;
        },

        filterResourceIdsFromStudentObjects(studentsObject) {
            // console.log('filterResourceIdsFromStudentObjects', studentsObject)
            let resourceIds = [];
            for (let i = 0; i < studentsObject.length; i++) {
                if (studentsObject[i].resource_id) {
                    resourceIds.push(studentsObject[i].resource_id);
                }
            }
            return resourceIds;
        },

        calcDurationClass(event) {
            // console.log('calcDurationClass',event )
            if (event && event !== null) {
                let start = this.timeToTimeStamp(event.day, event.startTime);
                let end = this.timeToTimeStamp(event.day, event.endTime);
                // console.log('calcDurationClass',event ,start ,end ,Math.floor((end - start) / (1000 * 60)))
                return Math.floor((end - start) / (1000 * 60));
            }
        },

        sortColor(typeCourse) {
            if (typeCourse) {
                let color = this.typeColors.filter(function(select_item) {
                    return select_item.id === typeCourse;
                });
                if (color) {
                    return color[0].color;
                }
            }
        },

        createLegendColorsCalendar() {
            let legendColors = [];
            for (let i = 0; i < this.typeColors.length; i++) {
                this.typeColors[i].color = this.sortColor(this.typeColors[i].id);
                legendColors.push(this.typeColors[i]);
                if (i === this.typeColors.length - 3) {
                    this.legendColorsCourses = JSON.parse(JSON.stringify(legendColors))
                }
            }
            this.legendColorsCalendar = JSON.parse(JSON.stringify(legendColors));
        },

        createLegendColorsClsGroups() {
            let legendColors = [];
            this.typeColors[2].color = this.sortColor(this.typeColors[2].id);
            legendColors.push(this.typeColors[2]);
            this.typeColors[3].color = this.sortColor(this.typeColors[3].id);
            legendColors.push(this.typeColors[3]);
            this.legendColorsClsGroups = JSON.parse(JSON.stringify(legendColors));
        },

        startDrag ({ event, timed }) {
            console.log('startDrag', timed)
            if (event && timed) {
                console.log('startDrag continued')
                this.dragEvent = event
                this.dragEventOriginal = JSON.parse(JSON.stringify(event))
                this.dragTime = null
                this.extendOriginal = null
            }
        },

        getCategory ({ category }) {
            // console.log('getCategory test', this.categoryStart)
            if (this.scopeCalendar === 'category'){
                this.categoryStart = category;
            } else {
                this.categoryStart = null;
            }
            
        },

        async changeSelectAllTeachers(event) {
            console.log('changeSelectAllTeachers', event)
            this.$store.dispatch('changeSelectAllTeachers', !this.selectAllTeachers); 
            this.showAllTeachers(this.selectAllTeachers); 
            if (event) {
                await this.loadCalendar();
                this.checkGraduations();
            }
        },

        startTimer (tms) {
            const mouse = this.toTime(tms)
            console.log('startTimer', tms);
            if (this.dragEvent && this.dragTime === null) {
                console.log('this.dragEvent.start')
                const start = this.dragEvent.start
                this.dragTime = mouse - start
            } else {
                console.log('createStart', this.events)
                this.createStart = this.roundTime(mouse)
                this.createEvent = {
                    name: `New Class`,
                    color: 'grey',
                    start: this.createStart,
                    end: this.createStart,
                    timed: true,
                    category: this.categoryStart,
                }
                this.events.push(this.createEvent)
            }
        },

        extendBottom (event) {
            console.log('extendBottom')
            this.extendingBottom = true;
            this.createEvent = event
            this.createStart = event.start
            this.extendOriginal = event.end
            this.dragEventOriginal = JSON.parse(JSON.stringify(event))
        },

        mouseMove (tms) {
            const mouse = this.toTime(tms)
            // console.log('mouseMove')
            if (this.dragEvent && this.dragTime !== null) {
                // console.log('mouseMove dragEvent', this.dragEvent)
                const start = this.dragEvent.start
                const end = this.dragEvent.end
                const duration = end - start
                const newStartTimer = mouse - this.dragTime
                const newStart = this.roundTime(newStartTimer)
                const newEnd = newStart + duration
                this.dragEvent.start = newStart
                this.dragEvent.end = newEnd
                this.dragEvent.category = this.categoryStart
            } else if (this.createEvent && this.createStart !== null) {
                // console.log('mouseMove createEvent')
                const mouseRounded = this.roundTime(mouse, false)
                const min = Math.min(mouseRounded, this.createStart)
                const max = Math.max(mouseRounded, this.createStart)

                this.createEvent.start = min
                this.createEvent.end = max
            }
        },

        async endDrag () {
            console.log('endDrag', this.createEvent)
            this.claimDraggingTime = true;
            if (this.createEvent !== null && this.createStart !== null) {
                if (this.createEvent.class_id) {
                    let studentsObject = this.dragEventOriginal.studentsObject;
                    this.originalClass.duration = Math.floor((this.extendOriginal - this.createEvent.start) / (1000 * 60));
                    this.createEvent.duration = Math.floor((this.createEvent.end - this.createEvent.start) / (1000 * 60));
                    var minAvailability = null;
                    let resourceIds = [];
                    console.log('endDrag #1', studentsObject)
                    for (let i = 0; i < studentsObject.length; i++) {
                        resourceIds.push(studentsObject[i].resource_id);
                    }
                    let resources = await this.getResourcesFromIds(resourceIds);
                    for (let i = 0; i < resources.length; i++) {
                        if (minAvailability === null || minAvailability > resources[i].minutes_available) {
                            minAvailability = resources[i].minutes_available;
                        }
                    }
                    // console.log('endDrag test1', minAvailability, (minAvailability - (this.createEvent.duration - this.originalClass.duration)));
                    if ((this.formattedDate(this.createEvent.start, 'date') === this.formattedDate(this.createEvent.end, 'date')) && !this.createEvent.outgoing_id && (minAvailability - (this.createEvent.duration - this.originalClass.duration) >= 0 )) {
                        let tmp = this.createEvent;
                        this.dragEvent = null;
                        this.dragTime = null
                        this.createEvent = null
                        this.createStart = null
                        this.extendOriginal = null
                        this.claimDraggingTime = false;
                        this.events = this.putColorsToClasses(this.events);
                        this.$store.dispatch('setLoadingApp', 1);
                        await this.writeClassToDB({originalClass: this.dragEventOriginal, editedClass: tmp});
                        await this.getResourcesFromDB(resourceIds);
                        this.$store.dispatch('setLoadingApp', 0);
                    } else {
                        console.log('drag bottom *****%%***** WRONG', this.createEvent);
                        this.createEvent.end = this.extendOriginal;
                        this.extendingBottom = false;
                        if (this.createEvent.outgoing_id) {
                            this.$store.dispatch('errorMessage', 'class already paid')
                        }
                        if (minAvailability - (this.createEvent.duration - this.originalClass.duration) < 0) {
                            this.$store.dispatch('errorMessage', 'all time used in course');
                            this.createEvent.duration = this.originalClass.duration;
                        }
                    }
                } else {
                    let duration = (this.createEvent.end - this.createEvent.start)/60000;
                    console.log('open new class *****%%*****', duration);
                    this.originalClass.duration = 0;
                    if (duration >= 60 && this.formattedDate(this.createEvent.start, 'date') === this.formattedDate(this.createEvent.end, 'date') && this.formattedDate(startTimeSix, 'dateTime') <= this.formattedDate(this.createEvent.start, 'dateTime')) {
                        this.createEvent.duration = duration;
                        this.createEvent.day = this.formattedDate(this.createEvent.start, 'date');
                        if (this.scopeCalendar === 'category') {
                            let classRoomLabel = this.createEvent.category;
                            let classRoom =  this.getClassRoomLabel(classRoomLabel)
                            if (classRoom) {
                                this.createEvent.class_room_id = classRoom.id;
                            }
                        } else {
                            this.createEvent.class_room_id = null;
                        }
                        this.openSelectStudent(this.createEvent);
                    } else {
                        console.log('open new class *****%%***** WRONG POP');
                        this.events.pop();
                    }
                }
            } else if (this.dragEvent !== null && this.$store.state.loadingApp === 0) {
                console.log('drag event *****%%*****', this.dragEvent);
                if (!this.dialogClass) {
                    var startTimeSix = new Date(this.dragEvent.start);
                    startTimeSix.setHours(6,0,0,0);
                    if ((this.formattedDate(this.dragEvent.start, 'date') === this.formattedDate(this.dragEvent.end, 'date') && this.formattedDate(startTimeSix, 'dateTime') <= this.formattedDate(this.dragEvent.start, 'dateTime')) && !this.dragEvent.outgoing_id) {
                        if (this.scopeCalendar === 'category') {
                            let classRoomLabel = this.dragEvent.category;
                            let classRoom =  this.getClassRoomLabel(classRoomLabel);
                            console.log('drag event *****%%***** test1', this.dragEvent, this.dragEvent.category, this.categoryStart);
                            this.dragEvent.class_room_id = classRoom.id;
                            this.dragEvent.class_room = classRoomLabel;
                            this.dragEvent = this.styleEvent(this.dragEvent)
                        }
                        let tmp = this.dragEvent;
                        this.dragEvent = null;
                        this.dragTime = null
                        this.createEvent = null
                        this.createStart = null
                        this.extendOriginal = null
                        this.claimDraggingTime = false;
                        await this.writeClassToDB({originalClass: this.dragEventOriginal, editedClass: tmp});
                        this.events = this.putColorsToClasses(this.events)
                    } else {
                        console.log('drag *****%%***** WRONG', this.dragEventOriginal);
                        let pos = this.events.map(function(e) { return e.class_id; }).indexOf(this.dragEvent.class_id);
                        this.changeObjectInArray(this.events, this.dragEventOriginal, pos);
                        // this.events.splice(pos, 1);
                        // this.events.push(this.dragEventOriginal);
                        if (this.dragEvent.outgoing_id) {
                            this.$store.dispatch('errorMessage', 'class already paid')
                        }
                    }
                }
            }
            this.dragEvent = null;
            this.dragTime = null
            this.createEvent = null
            this.createStart = null
            this.extendOriginal = null
            this.claimDraggingTime = false;
        },

        cancelDrag () {
            console.log('cancelDrag')
            if (this.createEvent) {
                if (this.extendOriginal) {
                this.createEvent.end = this.extendOriginal
                this.extendOriginal = null
                } else {
                    const i = this.events.indexOf(this.createEvent)
                    if (i !== -1) {
                        console.log('cancelDrag splice')
                        this.events.splice(i, 1)
                    }
                }
            }
            this.createEvent = null
            this.createStart = null
            this.dragTime = null
            this.dragEvent = null
            this.categoryStart = null
        },

        roundTime (time, down = true) {
            const roundTo = 15 // minutes
            const roundDownTime = roundTo * 60 * 1000

            return down
                ? time - time % roundDownTime
                : time + (roundDownTime - (time % roundDownTime))
        },

        toTime (tms) {
            return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
        },
        
        formCategoriesCalendar() {
            this.categoriesCalendar = [];
            for (let index = 0; index < this.classRooms.length; index++) {
                if(!this.classRooms[index].hide) {
                    this.categoriesCalendar.push(this.classRooms[index].label)
                }
            }
        },

        async getResourcesFromIds(resourceIds) {
            // 🔑 Always work with unique IDs
            const uniqueIds = [...new Set(resourceIds)];

            const found = [];
            const missing = [];

            // 1️⃣ Try to resolve from already loaded resources
            for (let i = 0; i < uniqueIds.length; i++) {
                const id = uniqueIds[i];

                const match = this.resourcesLoaded.find(
                    r => String(r.resource_id) === String(id)
                );

                if (match) {
                    found.push(match);
                } else {
                    missing.push(id);
                }
            }

            // 2️⃣ Only fetch missing ones (NOT all)
            if (missing.length > 0) {
                const fetched = await this.getResourcesFromDB(missing);
                return [...found, ...fetched];
            }

            return found;
        },

        async getResourcesFromDB(resourceIds) {
            // console.log('getResourcesFromDB', resourceIds);
            let resources = [];
            if (resourceIds && resourceIds.length) {
                let sqlTxt = '';
                for (let i = 0; i < resourceIds.length; i++) {
                    sqlTxt = sqlTxt.concat('resource_id = ', resourceIds[i], ' OR ');
                }
                sqlTxt = sqlTxt.substring(0 , sqlTxt.length - 4);
                resources = JSON.parse(JSON.stringify(await this.$store.dispatch('getResourcesSafe', sqlTxt)));
            }
            resources = this.prepareResourcesLoaded(resources);
            let indexToReplace = -1;
            for (let i = 0; i < resources.length; i++) {
                indexToReplace = this.resourcesLoaded.findIndex(obj => obj.resource_id === resources[i].resource_id);
                if (indexToReplace > -1) {
                    this.resourcesLoaded[indexToReplace] = resources[i];
                    // console.log('getResourcesFromDB #1', this.resourcesLoaded[indexToReplace]);
                } else {
                    this.resourcesLoaded.push(resources[i]);
                    // console.log('getResourcesFromDB #2', resources[i]);
                }
            }
            this.resourcesLoaded = this.resourcesLoaded.map(item => ({...item, // Keep existing properties
                start: this.formattedDate(item.start, 'date'),
                end: this.formattedDate(item.end, 'date'),
            }));
            return resources;
        },

        async createResourcesFromStudentsObject(studentObjects) {
            // console.log('createResourcesFromStudentsObject', studentObjects);
            let resources = [];
            let resourceIds = [];
            if (studentObjects && studentObjects.length) {
                for (let i = 0; i < studentObjects.length; i++) {
                    var resourceId = studentObjects[i].resource_id;
                    resourceIds.push(resourceId);
                }
                resources = await this.getResourcesFromIds(resourceIds);
                console.log('createResourcesFromStudentsObject', resources);
                return JSON.parse(JSON.stringify(resources));
            }
            return [];
        },

        prepOpenDialogClass(event) {
            console.log('prepOpenDialogClass', this.extendingBottom , this.claimDraggingTime , this.$store.state.loadingApp)
            if  (!this.extendingBottom && !this.claimDraggingTime && this.$store.state.loadingApp <= 0) {
                this.dialogClass = true;
                this.openDialogClass(event)
            }
        },

        async openDialogClass (itemClass) {
          console.log('openDialogClass', itemClass);
          this.$store.dispatch('setLoadingApp', 1);

          try {
            // -------------------------------------------------
            // 1️⃣ Clone + normalize base class
            // -------------------------------------------------
            const cls = JSON.parse(JSON.stringify(itemClass));

            cls.individual_instead = !!cls.individual_instead;

            cls.color = this.sortColor(cls.class_group + cls.class_type) || '#ccc';

            cls.day = this.formattedDate(cls.start, 'date');
            cls.startTime = this.formattedDate(cls.start, 'time');
            cls.endTime = this.formattedDate(cls.end, 'time');

            cls.class_group = cls.class_group || '';
            cls.class_type = cls.class_type || '';
            cls.name = cls.name || '';
            cls.studentsObject = cls.studentsObject || [];

            // teacher validation
            if (
              cls.teacher_id &&
              this.getTeacher(cls.teacher_id)?.obsolete !== null &&
              cls.outgoing_id === null
            ) {
              cls.teacher_id = null;
            }

            this.editedClass = cls;

            // -------------------------------------------------
            // 2️⃣ Load resources if needed
            // -------------------------------------------------
            if (!this.resourcesInClass.length) {
              this.resourcesInClass =
                await this.createResourcesFromStudentsObject(cls.studentsObject);
            }

            // -------------------------------------------------
            // 3️⃣ Existing vs new class branching
            // -------------------------------------------------
            if (cls.class_id) {
              this.handleExistingClass(cls, itemClass.class_id);
            } else {
              this.handleNewClass(cls);
            }    

            // -------------------------------------------------
            // 4️⃣ Snapshot + availability
            // -------------------------------------------------
            this.originalClass = JSON.parse(JSON.stringify(this.editedClass));

            await this.createClassRoomsWithAvailability(
              cls.class_id,
              cls.day,
              cls.startTime,
              cls.endTime
            );

            // -------------------------------------------------
            // 5️⃣ Final UI state
            // -------------------------------------------------
            this.dialogClass = true;
            this.adjustDurationsClass();

          } finally {
            this.$store.dispatch('setLoadingApp', 0);
          }
        },

        handleExistingClass(cls, classId) {
          // graduation icons
          this.resourcesInClass.forEach(r => {
            r.iconGrad =
              r.graduationClassId === classId
                ? "$vuetify.icons.icon_mdi_school"
                : null;
          });

          // payment
          cls.paymentClass = this.decUtil
            .toDec(this.calcPaymentClass(cls).paymentClass)
            .toNumber();

          // individual override
          cls.individual_instead = (
            this.resourcesInClass.length === 1 &&
            this.resourcesInClass[0].class_group === 'Group' &&
            this.resourcesInClass[0].class_language !== 'English'
          );
        },

        handleNewClass(cls) {
          cls.paymentClass = 0;
          cls.outgoing_id = null;
          cls.autoPayment = 1;

          if (
            cls.class_location === 'Online' &&
            this.scopeCalendar !== 'category'
          ) {
            cls.class_room_id = 1;
          }

          this.editedClass = this.styleEvent(cls);
        },

        allHoursUsedInClass(resources) {
            if (resources) {
                for (let i = 0; i < resources.length; i++) {
                    if (resources[i].minutes_available < 0) {
                        return true
                    }
                }
            }
            return false;
        },

        cancelDialogClass() {
            // console.log('cancelDialogClass')
            if (!this.editedClass.class_id) {
                // console.log('cancelDialogClass pop')
                this.events.pop();
            }
            this.closeDialogClass();
        },

        closeDialogClass() {
            this.editedClass = {};
            this.originalClass = [];
            this.resourcesInClass = [];
            this.selectedClassesCourseOrGroup = [];
            this.noActionsTaken = true;
        },

        async removeStudentFromClassInClass(itemResource) {
            let pos = this.resourcesInClass.map(function(e) { return e.resource_id; }).indexOf(itemResource.resource_id);
            if (pos > -1) {
                this.resourcesInClass.splice(pos, 1);
            }
            this.editedClass.studentsObject = this.createStudentsObject(this.resourcesInClass);
            if (this.resourcesInClass.length < 2 && this.resourcesInClass[0].class_language !== 'English') {
                this.editedClass.individual_instead = true;
            }
            this.adjustDurationsClass();
        },

        async adjustDurationsClass() {
            console.log('adjustDurationsClass start');

            // 1️⃣ Recompute duration
            this.editedClass.duration = this.calcDurationClass(this.editedClass);

            // 2️⃣ Recompute financials
            this.recomputeClassFinancials(this.editedClass);

            // 3️⃣ Compute minutes_used (old vs new)
            this.originalClass.minutes_used =
                this.computeMinutesUsed(this.originalClass);

            this.editedClass.minutes_used =
                this.computeMinutesUsed(this.editedClass);

            const changeMinutesUsed =
                this.originalClass.minutes_used - this.editedClass.minutes_used;

            // 4️⃣ Load original resource baselines
            const resourceIds = this.resourcesInClass.map(r => r.resource_id);
            const resourcesOriginal = await this.getResourcesFromIds(resourceIds);

            // 5️⃣ Recalculate minutes_available per student
            for (const student of this.resourcesInClass) {

                const originalResource = resourcesOriginal.find(
                    r => r.resource_id === student.resource_id
                );

                if (!originalResource) continue;

                const minutesAvailableOriginal =
                    originalResource.minutes_available;

                // New student had no previous allocation → compensate full original usage
                const compensationNewStudent =
                    student.newStudent ? this.originalClass.minutes_used : 0;

                student.minutes_available =
                    minutesAvailableOriginal +
                    changeMinutesUsed -
                    compensationNewStudent;
            }
        },

        recomputeClassFinancials(cls) {
            const payment = this.calcPaymentClass(cls);

            cls.paymentClass = this.decUtil.toDec(payment.paymentClass).toNumber();
            cls.rate = this.decUtil.toDec(payment.rate).toNumber();
        },

        async saveSingleClass(itemClass) {
            console.log('saveSingleClass itemClass =', itemClass);

            if (!this.$refs.dialogFormClass.validate()) {
                return;
            }

            this.$store.dispatch('setLoadingApp', 1);

            try {
                // clone to avoid mutating UI-bound object
                let editedClass = JSON.parse(JSON.stringify(itemClass));

                editedClass.amount_students = this.resourcesInClass.length;
                editedClass.timed = true;
                editedClass = this.createClassFromDayTime(editedClass);

                if (editedClass.class_id) {
                    await this.writeClassToDB({
                        originalClass: this.originalClass || {},
                        editedClass
                    });
                } else {
                    editedClass.newClass = true;
                    await this.writeClassToDB({
                        originalClass: {},
                        editedClass
                    });
                }

                for (let i = 0; i < this.resourcesInClass.length; i++) {
                    await this.updateResource(this.resourcesInClass[i]);
                }

                if (this.queSetSendToTeachers.length > 0) {
                    await this.setSendToTeacher();
                }

                await this.loadDataAll();

                if (this.dialogCourse) {
                    await this.openDialogCourse(this.openCourse);
                    this.openCourse = null;
                }

                if (this.dialogClsGroup) {
                    await this.openDialogClsGroup(null, this.openClsGroup);
                    this.openClsGroup = null;
                }

                this.dialogClass = false;
                this.closeDialogClass();
            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }
        },

        createClassFromDayTime(itemClass) {
            // console.log('createClassFromDayTime itemClass=', itemClass);
            itemClass.class_room = this.getClassRoomId(itemClass.class_room_id).name;
            itemClass.category = itemClass.class_room;
            if (itemClass.teacher_id) {
                itemClass.contact = this.getTeacher(itemClass.teacher_id).contact;
            }
            itemClass.color = this.sortColor(itemClass.class_group + itemClass.class_type).toString();
            itemClass.start = this.timeToTimeStamp(itemClass.day, itemClass.startTime);
            itemClass.end = this.timeToTimeStamp(itemClass.day, itemClass.endTime);
            itemClass = this.styleEvent(itemClass);
            itemClass = this.calcPaymentClass(itemClass);
            return itemClass;
        },

        async openDialogCourse(resourceId) {

            this.dialogCourseReady = false;
            
            this.$store.dispatch('setLoadingApp', 1);

            try {

                /* -------------------------------------------------
                * Reset dialog state
                * ------------------------------------------------- */
                this.activeTabTeaching = 0;
                this.classGroupId = null;
                this.classGroupIdHours = null;
                this.dialogClass = false;
                this.dialogClsGroup = false;
                this.selectedClassesCourseOrGroup = [];
                this.noActionsTaken = true;
                this.newClsGroup = null;

                /* -------------------------------------------------
                * Load resource + classes
                * ------------------------------------------------- */

                const [classes, resource] = await Promise.all([
                    this.$store.dispatch('getClassesResourceId', resourceId),
                    this.$store.dispatch('getResourceId', resourceId),
                ]);

                if (resource?.client_id) {
                  const client = await this.$store.dispatch('getClientId', resource.client_id)
                  if (client) {
                    resource.client = client;
                  }
                }

                await this.prepareClassesAndCourseForDialog(classes, resource);

                /* -------------------------------------------------
                * Final dialog state
                * ------------------------------------------------- */

                // 1️⃣ UI config
                this.weekSelect = {
                    day: {
                        Sun: false,
                        Mon: true,
                        Tue: true,
                        Wed: true,
                        Thu: true,
                        Fri: true,
                        Sat: false,
                    },
                };

                // 4️⃣ Ready BEFORE render
                this.dialogCourseReady = true;

                // 5️⃣ Open dialog
                this.dialogCourse = true;

            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }
        },

        async prepareClassesAndCourseForDialog(classesFromDb, resourceFromDB) {

            this.editedResource = JSON.parse(JSON.stringify(resourceFromDB[0] ?? resourceFromDB));

            this.resetClassEditFlags(this.editedClassesInResource);

            /* -------------------------------------------------
            * Prepare resource
            * ------------------------------------------------- */
            this.editedResource.backgroundColor = this.sortColor(
                this.editedResource.class_group + this.editedResource.class_type
            ).toString();

            /* -------------------------------------------------
            * Prepare classes
            * ------------------------------------------------- */
            const cleanClasses = this.configureClassesFromDB(
                this.deepClone(classesFromDb)
            );

            let editedClassesInResource = [...cleanClasses]
                .sort(this.dynamicSort('start'));

            this.editedClassesInResource = this.deepClone(editedClassesInResource);

            /* -----------------------------------------
            * SNAPSHOT BASELINE
            * ----------------------------------------- */
            this.dialogBaseline = this.deepClone({
                resource: this.editedResource,
                classes: this.editedClassesInResource
            });

            // --------------------------------------------------
            // Retrieve available resources
            // --------------------------------------------------

            const resourceIds = new Set();

            // collect from classes
            editedClassesInResource.forEach(cls => {
                (cls.studentsObject || []).forEach(s => {
                    if (s.resource_id) {
                        resourceIds.add(String(s.resource_id));
                    }
                });
            });

            // include owner
            if (this.editedResource?.resource_id) {
                resourceIds.add(String(this.editedResource.resource_id));
            }

            // fetch ONLY what you need
            const resources = await this.getResourcesFromIds([...resourceIds]);

            resources.forEach(r => {
                this.resourceMap.set(String(r.resource_id), r);
            });

            this.minutesAvailableAtDialogOpenCourse = new Map();

            resources.forEach(r => {
                this.minutesAvailableAtDialogOpenCourse.set(
                    String(r.resource_id),
                    r.minutes_available
                );
            });
            
        },

        async openDialogClsGroup(classGroup = null, classGroupId = null) {

            this.dialogClsGroupReady = false;

            this.$store.dispatch('setLoadingApp', 1);

            try {
                /* -------------------------------------------------
                * Reset dialog state
                * ------------------------------------------------- */
                this.activeTabTeaching = 1;
                this.dialogClass = false;
                this.dialogCourse = false;
                this.selectedClassesInClsGroup = [];
                this.noActionsTaken = true;

                /* -------------------------------------------------
                * Load class group
                * ------------------------------------------------- */
                if (!classGroup && classGroupId !== null) {
                    const sqlTxt = `class_group_id = ${classGroupId}`;
                    const groups = await this.$store.dispatch(
                        'getClassGroupsSafe',
                        sqlTxt
                    );
                    classGroup = JSON.parse(JSON.stringify(groups[0]));
                }

                this.editedClsGroup = JSON.parse(JSON.stringify(classGroup));

                /* -------------------------------------------------
                * Load classes
                * ------------------------------------------------- */
                const classesFromDb = await this.$store.dispatch(
                    'getClassesClassGroupId',
                    this.editedClsGroup.class_group_id
                );

                const cleanClasses = this.configureClassesFromDB(
                    JSON.parse(JSON.stringify(classesFromDb))
                );

                let editedClassesInClsGroup = [...cleanClasses]
                    .sort(this.dynamicSort('start'));

                /* -----------------------------------------
                * SNAPSHOT BASELINE
                * ----------------------------------------- */
                const resourceIds = [...new Set(
                    cleanClasses
                        .flatMap(c => c.studentsObject || [])
                        .map(s => s.resource_id)
                )];

                const resources = await this.getResourcesFromIds(resourceIds);

                // ✅ build dedicated resource map for class group (for full_name etc.)
                this.resourceMapClsGroup = new Map();
                resources.forEach(r => {
                    this.resourceMapClsGroup.set(String(r.resource_id), r);
                });

                // ✅ baseline minutes snapshot
                this.minutesAvailableAtDialogOpenClsGroup = new Map();
                resources.forEach(r => {
                    this.minutesAvailableAtDialogOpenClsGroup.set(
                        String(r.resource_id),
                        r.minutes_available
                    );
                });

                /* -------------------------------------------------
                * Final dialog state (NO calculations here)
                * ------------------------------------------------- */
                this.weekSelect = {
                    day: {
                        Sun: false,
                        Mon: true,
                        Tue: true,
                        Wed: true,
                        Thu: true,
                        Fri: true,
                        Sat: false,
                    },
                };

                this.editedClassesInClsGroup = this.deepClone(editedClassesInClsGroup);

                // 🔑 baseline must ALWAYS be clean DB state
                this.dialogClsGroupBaseline = this.deepClone({
                    classGroup: this.editedClsGroup,
                    classes: cleanClasses
                });

                this.dialogClsGroupReady = true;

                this.dialogClsGroup = true;

            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }
        },

        async writeClassToDB({ originalClass, editedClass }) {
            // console.log('writeClassToDB start', editedClass);

            let classId = editedClass.class_id ?? null;

            // --------------------------------------------------
            // 1️⃣ Normalize copies (never mutate inputs)
            // --------------------------------------------------
            const cleanOriginal = originalClass
                ? this.stripNonDBFields(originalClass)
                : null;

            const cleanEdited = this.stripNonDBFields(editedClass);

            // --------------------------------------------------
            // 2️⃣ Detect no-op
            // --------------------------------------------------
            if (cleanOriginal && this.sameArrays(cleanOriginal, cleanEdited)) {
                console.log('writeClassToDB: no changes');
                return;
            }

            // --------------------------------------------------
            // 3️⃣ Insert or update class
            // --------------------------------------------------
            if (classId) {
                await this.$store.dispatch('insertClass', cleanEdited);
                this.collectChangeNotifications(cleanOriginal, cleanEdited);
            } else {
                classId = await this.insertNewClass(cleanEdited);
                editedClass.class_id = classId; // keep UI in sync
            }

            // --------------------------------------------------
            // 4️⃣ Sync students ↔ class
            // --------------------------------------------------
            await this.syncStudentsInClass(
                originalClass?.studentsObject ?? [],
                editedClass.studentsObject,
                classId
            );

            this.extendingBottom = false;

            // console.log('writeClassToDB end', classId);
        },

        stripNonDBFields(cls) {
            const copy = JSON.parse(JSON.stringify(cls));

            delete copy.day;
            delete copy.rate;

            return copy;
        },

        async insertNewClass(editedClass) {
            editedClass.class_id = null;

            const teacher = this.activeTeachers.find(t => t.id === editedClass.teacher_id);

            if (teacher) {
                editedClass.contact = teacher.contact;

                if (editedClass.class_group === 'Group') {
                    editedClass.rate_teacher =
                        editedClass.class_type === 'Normal'
                            ? teacher.rate_group
                            : teacher.rate_special_group;
                } else {
                    editedClass.rate_teacher =
                        editedClass.class_type === 'Normal'
                            ? teacher.rate_individual
                            : teacher.rate_special;
                }
            }

            const classId = await this.$store.dispatch('insertClass', editedClass);

            this.queSetSendToStudents.push(editedClass.studentsObject);
            this.queSetSendToTeachers.add(editedClass.teacher_id);

            return classId;
        },

        collectChangeNotifications(original, edited) {
            // NEW CLASS
            if (!original) {
                // notify everyone involved
                this.queSetSendToStudents.push(edited.studentsObject);
                this.queSetSendToTeachers.add(edited.teacher_id);
                return;
            }

            const structuralChange =
                original.start !== edited.start ||
                original.end !== edited.end ||
                original.class_room_id !== edited.class_room_id ||
                original.teacher_id !== edited.teacher_id;

            if (structuralChange) {
                this.queSetSendToStudents.push(edited.studentsObject);
                this.queSetSendToTeachers.add(edited.teacher_id);
            }

            if (original.teacher_id !== edited.teacher_id) {
                this.queSetSendToTeachers.add(original.teacher_id);
                this.queSetSendToTeachers.add(edited.teacher_id);
            }
        },

        async syncStudentsInClass(originalStudents, editedStudents, classId) {
            const originalIds = this.filterResourceIdsFromStudentObjects(originalStudents);
            const editedIds = this.filterResourceIdsFromStudentObjects(editedStudents);

            if (this.sameArrays(originalIds, editedIds)) return;
            
            // remove students
            for (const rid of this.onlyInFirstArray(originalIds, editedIds)) {
                await this.$store.dispatch('deleteStudentFromClassIds', {
                    resourceId: rid,
                    classId
                });
            }

            // add students
            for (const rid of this.onlyInFirstArray(editedIds, originalIds)) {
                await this.$store.dispatch('insertResourcesClasses', {
                    resources_classes_id: null,
                    resource_id: rid,
                    class_id: classId
                });
            }

            this.queSetSendToStudents.push(editedStudents);
        },

        async removeClassesInCourseOrGroup (itemClass) {
            let pos = null;
            if (itemClass) {
                pos = this.editedClassesInResource.map(function(e) { return e.key; }).indexOf(itemClass.key);
                if (pos > -1) {
                    this.editedClassesInResource.splice(pos,1);
                }
            } else {
                for (let i = 0; i < this.selectedClassesCourseOrGroup.length; i++) {
                    pos = this.editedClassesInResource.map(function(e) { return e.key; }).indexOf(this.selectedClassesCourseOrGroup[i].key);
                    if (pos > -1) {
                        this.editedClassesInResource.splice(pos,1);
                    }
                }
            }
            this.editedClassesInResource = [...this.editedClassesInResource];
            this.selectedClassesCourseOrGroup = [];
            this.noActionsTaken = false;
            return [this.editedResource, this.editedClassesInResource, this.resourcesInCourseComputed];
        },

        async deleteSingleClass(itemClass) {
            console.log('deleteSingleClass itemClass =', itemClass);
            this.$store.dispatch('setLoadingApp', 1);

            // get all resource_ids from class
            const resourceIds = this.filterResourceIdsFromStudentObjects(itemClass.studentsObject);

            // save class
            await this.deleteClass(itemClass);

            // update all resources
            for (const rid of resourceIds) {
                const resource = this.resourceMap.get(String(rid));
                await this.updateResource(resource);
            }

            this.queSetSendToStudents.push(itemClass.studentsObject);
            this.queSetSendToTeachers.add(itemClass.teacher_id);
            await this.setSendToTeacher();

            await this.loadDataAll();

            this.$store.dispatch('setLoadingApp', 0);
        },
        
        async deleteClass (itemClass) {
            let pos = this.events.map(function(e) { return e.class_id; }).indexOf(itemClass.class_id);
            if (pos > -1) {
                this.events.splice(pos,1);
            }
            let result = await this.$store.dispatch('deleteClass', itemClass.class_id);
            if (result !== 200) {
                this.$store.dispatch('errorMessage', 'Error deleting class, please check');
            }
            this.dialogClass = false;
            this.closeDialogClass();
        },

        async addNewClasses(resource) {
            this.$store.dispatch('setLoadingApp', 1);

            // --------------------------------------------------
            // 1️⃣ Validate week selection
            // --------------------------------------------------
            const hasSelectedDay = Object.values(this.weekSelect.day).some(Boolean);
            if (!hasSelectedDay) {
                this.$store.dispatch('warningMessage', 'Please select at least one day of the week');
                this.$store.dispatch('setLoadingApp', 0);
                return;
            }

            // --------------------------------------------------
            // 2️⃣ Find participant baseline
            // --------------------------------------------------
            const participant = this.resourcesInCourseComputed.find(
                r => String(r.resource_id) === String(this.editedResource.resource_id)
            );

            if (!participant) {
                this.$store.dispatch('errorMessage', 'Resource not found in course');
                this.$store.dispatch('setLoadingApp', 0);
                return;
            }

            // --------------------------------------------------
            // 3️⃣ First class vs follow-up classes
            // --------------------------------------------------
            if (this.editedClassesInResource.length === 0) {
                await this.addFirstClass(resource);
            } else {
                await this.addRecurringClasses();
            }

            // --------------------------------------------------
            // 4️⃣ Trigger reactivity (computed will handle everything)
            // --------------------------------------------------
            this.editedClassesInResource = [...this.editedClassesInResource];

            // optional: reset UI flags safely (do not mutate computed directly)
            this.editedClassesInResource.forEach(cls => {
                if (cls.newStudent !== undefined) {
                    cls.newStudent = false;
                }
            });


            this.noActionsTaken = false;
            this.$store.dispatch('setLoadingApp', 0);
        },

        async addFirstClass(resource) {
            const startDate = this.formattedDate(resource.start, 'date');

            const duration = resource.hours_per_class
                ? resource.hours_per_class * 60
                : 60;

            const startTimestamp = this.timeToTimeStamp(startDate, '09:00');
            const endTimestamp = startTimestamp + duration * 60000;

            const itemClass = {
                key: this.createUUID(),
                class_id: null,

                class_room_id: 1,
                class_room: 'Elsewhere',

                day: startDate,
                startTime: '09:00',
                endTime: this.formattedDate(endTimestamp, 'time'),

                start: startTimestamp,
                end: endTimestamp,

                duration,

                amount_students: 1,
                students: resource.full_name,
                studentsObject: this.createStudentsObject([resource]),

                individual_instead: this.isIndividualInstead(resource, 1),

                autoPayment: true,
                newClass: true,
                outgoing_id: null,
                isSelectable: true,
                class_group_id: null,

                startTime_changed: true,
                endTime_changed: true,
                teacher_changed: true,
                students_changed: true,
                class_room_changed: true,
            };

            // console.log('addFirstClass resource', resource);

            // ✅ single source of truth
            itemClass.minutes_used = this.computeMinutesUsed(itemClass);

            this.adoptCoursePropsToClass(resource, itemClass);
            this.assignFirstAvailableTeacher(itemClass);

            itemClass.paymentClass = this.decUtil
                .toDec(this.calcPaymentClass(itemClass).paymentClass)
                .toNumber();

            this.editedClassesInResource.push(itemClass);
        },

        isIndividualInstead(resource, studentCount) {
            return (
                resource.class_group === 'Group' &&
                resource.class_language === 'Spanish' &&
                studentCount === 1
            );
        },

        async addRecurringClasses() {
          const lastClass = this.editedClassesInResource.at(-1);
          if (!lastClass) return;

          let duration = lastClass.duration;
          if (duration <= 0) return;

          let dayCursor = dayjs(lastClass.day);

          const baseMinutes =
              this.minutesAvailableAtDialogOpenCourse.get(
                  String(this.editedResource.resource_id)
              ) ?? 0;

          const usedNew = this.editedClassesInResource
              .filter(cls => cls.class_id === null)
              .reduce((sum, cls) => sum + (cls.minutes_used || 0), 0);

          let remainingMinutes = baseMinutes - usedNew;

          // ✅ Build clean working copy of students with remaining minutes
          let remainingStudents = (lastClass.studentsObject || []).map(s => {
              const resource = this.resourcesInCourseComputed.find(
                  r => String(r.resource_id) === String(s.resource_id)
              );

              return {
                  ...s,
                  remainingMinutes: resource?.minutes_available ?? 0
              };
          });

          if (duration > remainingMinutes) {
            duration = remainingMinutes
          }

          while (remainingMinutes >= duration && remainingStudents.length > 0) {
              dayCursor = dayCursor.add(1, 'day');
              const dayName = dayCursor.format('ddd');

              if (!this.weekSelect.day[dayName]) continue;

              const day = this.formattedDate(dayCursor, 'date');

              // ✅ Filter + update in one pass (no mutation bugs)
              remainingStudents = remainingStudents
                  .map(student => {
                      if (student.remainingMinutes < duration) return null;

                      return {
                          ...student,
                          remainingMinutes: student.remainingMinutes - duration
                      };
                  })
                  .filter(Boolean);

              const nextClass = {
                  ...JSON.parse(JSON.stringify(lastClass)),
                  key: this.createUUID(),
                  class_id: null,

                  studentsObject: JSON.parse(JSON.stringify(remainingStudents)),
                  students: lastClass.students,
                  amount_students: remainingStudents.length,

                  individual_instead: this.isIndividualInstead(
                      this.editedResource,
                      remainingStudents.length
                  ),

                  day,
                  start: this.timeToTimeStamp(day, lastClass.startTime),
                  end: this.timeToTimeStamp(day, lastClass.startTime) + duration * 60000,

                  duration,
                  newClass: true,
                  outgoing_id: null,
                  isSelectable: true,

                  startTime_changed: true,
                  endTime_changed: true,
                  teacher_changed: true,
                  students_changed: true,
                  class_room_changed: true,
              };

              nextClass.minutes_used = this.computeMinutesUsed(nextClass);

              if (nextClass.minutes_used <= 0) break;

              remainingMinutes -= nextClass.minutes_used;

              this.editedClassesInResource.push(nextClass);
          }
      },

        pickClassTemplate(cls) {
            return {
                class_room_id: cls.class_room_id,
                class_room: cls.class_room,
                teacher_id: cls.teacher_id,
                contact: cls.contact,

                class_language: cls.class_language,
                class_group: cls.class_group,
                class_type: cls.class_type,

                studentsObject: JSON.parse(JSON.stringify(cls.studentsObject)),
                students: cls.students,
                amount_students: cls.amount_students,
            };
        },

        computeMinutesUsed(cls) {
            const base = Number(cls.duration) || 0;

            const isSpanishGroup =
                cls.class_language !== 'English' &&
                cls.class_group === 'Group';

            const studentCount = cls.studentsObject?.length || 0;

            // 🔑 Spanish group alone → inflate
            if (isSpanishGroup && studentCount === 1) {
                return Math.round(base / 0.75);
            }

            return base;
        },

        assignFirstAvailableTeacher(itemClass) {
            if (!this.activeTeachers || this.activeTeachers.length === 0) {
                return false;
            }

            let candidates = [];

            switch (itemClass.class_language) {
                case 'Spanish':
                    candidates = this.activeTeachers.filter(t => t.spanish);
                    break;
                case 'Quechua':
                    candidates = this.activeTeachers.filter(t => t.quechua);
                    break;
                case 'English':
                    candidates = this.activeTeachers.filter(t => t.english);
                    break;
                default:
                    return false;
            }

            if (candidates.length === 0) {
                return false;
            }

            const teacher = candidates[0];

            itemClass.teacher_id = teacher.id;
            itemClass.contact = teacher.contact;

            return true;
        },

        async saveCourse() {
            this.$store.dispatch('setLoadingApp', 1);

            console.log("BASELINE CLASSES", this.dialogBaseline.classes);
            console.log("EDITED CLASSES", this.editedClassesInResource);

            try {
                const resourceId = this.editedResource.resource_id;

                // --------------------------------------------------
                // 1️⃣ Check if main resource exists
                // --------------------------------------------------
                const [resourceFromDb] = await this.getResourcesFromIds([resourceId]);

                if (!resourceFromDb) {
                    this.$store.dispatch(
                        'errorMessage',
                        `Course resource ${resourceId} not found`
                    );
                    return;
                }

                // --------------------------------------------------
                // Create new Class Group if necessary
                // --------------------------------------------------

                const classes = this.selectedClassesCourseOrGroup;

                if ((this.newClsGroup || this.classGroupId) && classes.length > 0) {

                    let newClsGroupId;
                    let classGroupName;

                    if (this.newClsGroup) {

                        classGroupName = this.newClsGroup.trim();

                        const classGroup = {
                            class_group_id: null,
                            class_group_name: classGroupName,
                            language_level: null,
                            comments: '',
                            closed: 0,
                            class_language: this.editedResource.class_language,
                            class_type: this.editedResource.class_type,
                            class_group: this.editedResource.class_group,
                            class_location: this.editedResource.class_location,
                        };

                        newClsGroupId = await this.$store.dispatch('insertClsGroup', classGroup);

                        await this.loadClsGroups();

                    } else {

                        newClsGroupId = this.classGroupId;

                        // 🔑 IMPORTANT: get name from existing groups
                        const existing = this.classGroupsLoadedOpen.find(
                            g => g.class_group_id === this.classGroupId
                        );
                        classGroupName = existing ? existing.class_group_name : '';

                    }

                    classes.forEach(cls => {
                        cls.class_group_id = newClsGroupId;
                        cls.class_group_name = classGroupName;
                    });
                }
                

                // --------------------------------------------------
                // 2️⃣ Persist classes
                // --------------------------------------------------
                
                const baselineSnapshot = this.dialogBaseline.classes.map(c => ({ ...c }));

                await this.saveClasses(
                    baselineSnapshot,
                    this.editedClassesInResource
                );

                // --------------------------------------------------
                // 🔑 Collect ALL involved resource_ids
                // (baseline + current classes + computed resources)
                // --------------------------------------------------
                const resourceIds = new Set();

                // 1️⃣ From baseline minutes map
                if (this.minutesAvailableAtDialogOpenCourse) {
                    for (const key of this.minutesAvailableAtDialogOpenCourse.keys()) {
                        resourceIds.add(String(key));
                    }
                }

                // 2️⃣ From computed resources
                (this.resourcesInCourseComputed || []).forEach(r => {
                    if (r?.resource_id !== undefined) {
                        resourceIds.add(String(r.resource_id));
                    }
                });

                // --------------------------------------------------
                // 🔄 Fetch all resources fresh
                // --------------------------------------------------
                const resourcesFromDb = await this.getResourcesFromIds([...resourceIds]);

                // --------------------------------------------------
                // 💾 Persist ALL resources (recalculate minutes correctly)
                // --------------------------------------------------
                let resource = {};

                for (const res of resourcesFromDb) {

                    // 🚫 Skip invalid/incomplete resources (prevents NULL constraint errors)
                    if (!res || !res.service_id) {
                        console.warn("Skipping resource without service_id", res);
                        continue;
                    }

                    res.comments = this.editedResource.comments;

                    console.log("resource recalculated", res);

                    // Always use DB version (backend recalculates minutes)
                    const updated = await this.updateResource(res);

                    // Keep reference to the main edited resource
                    if (String(res.resource_id) === String(this.editedResource.resource_id)) {
                        resource = updated;
                    }
                }

                // const classesFromDb = await this.$store.dispatch(
                //     'getClassesClientId',
                //     this.editedResource.client_id
                // );

                const classesFromDb = await this.$store.dispatch('getClassesResourceId', resourceId);

                await this.loadDataAll();

                await this.prepareClassesAndCourseForDialog(classesFromDb, resource);
                
                this.dialogCourseReady = true;

                // --------------------------------------------------
                // 4️⃣ Success feedback
                // --------------------------------------------------
                this.$store.dispatch(
                    'successMessage',
                    'All changes applied successfully to the Course'
                );

                console.log("BASELINE CLASSES", this.dialogBaseline.classes);
                console.log("EDITED CLASSES", this.editedClassesInResource);

            } catch (err) {
                console.error('saveCourse failed', err);
                this.$store.dispatch(
                    'errorMessage',
                    'An unexpected error occurred while saving the course'
                );
            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }
        },

        async saveClsGroup(close) {
            this.$store.dispatch('setLoadingApp', 1);

            try {
                console.log('saveClsGroup', this.editedClsGroup);

                // --------------------------------------------------
                // 1️⃣ Update last_change
                // --------------------------------------------------
                const now = new Date();
                this.editedClsGroup.last_change = this.formattedDate(
                    this.toTimestamp(now),
                    'dateTime'
                );

                // --------------------------------------------------
                // 2️⃣ Persist class group
                // --------------------------------------------------
                await this.$store.dispatch('insertClsGroup', this.editedClsGroup);

                // --------------------------------------------------
                // 3️⃣ Persist classes
                // --------------------------------------------------
                await this.saveClasses(
                    this.classesInClsGroup,
                    this.editedClassesInClsGroup
                );

                // --------------------------------------------------
                // 4️⃣ Reload classes from DB
                // --------------------------------------------------
                const classesFromDb = await this.$store.dispatch(
                    'getClassesClassGroupId',
                    this.editedClsGroup.class_group_id
                );

                const cleanClasses = this.deepClone(classesFromDb);
                this.configureClassesFromDB(cleanClasses);

                // 🚫 prevent intermediate recompute
                this.dialogClsGroupReady = false;

                // --------------------------------------------------
                // 5️⃣ Reset working state
                // --------------------------------------------------
                this.editedClassesInClsGroup = [...cleanClasses];

                this.dialogClsGroupBaseline = this.deepClone({
                    classGroup: this.deepClone(this.editedClsGroup),
                    classes: this.deepClone(cleanClasses)
                });

                // --------------------------------------------------
                // 6️⃣ Rebuild resource map + minutes baseline
                // --------------------------------------------------
                const resourceIds = [...new Set(
                    cleanClasses
                        .flatMap(c => c.studentsObject || [])
                        .map(s => String(s.resource_id))
                )];

                const resources = await this.getResourcesFromIds(resourceIds);

                this.resourceMapClsGroup = new Map();
                resources.forEach(r => {
                    this.resourceMapClsGroup.set(String(r.resource_id), r);
                });

                this.minutesAvailableAtDialogOpenClsGroup = new Map();
                resources.forEach(r => {
                    this.minutesAvailableAtDialogOpenClsGroup.set(
                        String(r.resource_id),
                        r.minutes_available
                    );
                });

                // ✅ allow recompute (single correct run)
                this.dialogClsGroupReady = true;

                // --------------------------------------------------
                // 7️⃣ Reload global data (optional)
                // --------------------------------------------------
                await this.loadDataAll();

                // --------------------------------------------------
                // 5️⃣ Close dialog if requested
                // --------------------------------------------------
                if (close) {
                    this.dialogClsGroup = false;
                    this.resetDialogClsGroupState();
                }

                // --------------------------------------------------
                // 6️⃣ Success feedback
                // --------------------------------------------------
                this.$store.dispatch(
                    'successMessage',
                    'All changes applied successfully to the Class Group'
                );

            } catch (err) {
                console.error('saveClsGroup failed', err);
                this.$store.dispatch(
                    'errorMessage',
                    'An unexpected error occurred while saving the class group'
                );
            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }
        },

        async saveClasses(classes, editedClasses) {
            console.log('saveClasses', classes, editedClasses);

            const baseline = (classes || []).map(c => ({ ...c }));
            const edited   = (editedClasses || []).map(c => ({ ...c }));

            // --------------------------------------------------
            // 1️⃣ Compute diff (no side effects)
            // --------------------------------------------------
            const { toCreate, toUpdate, toDelete } = this.diffClasses(baseline, edited);

            // --------------------------------------------------
            // 2️⃣ DELETE
            // --------------------------------------------------
            for (const cls of toDelete) {
                this.queSetSendToStudents.push(
                    (cls.studentsObject || []).map(s => ({ ...s }))
                );
            }

            await Promise.all(
                toDelete.map(cls => this.deleteClass(cls))
            );

            // --------------------------------------------------
            // 3️⃣ CREATE + UPDATE (unified write path)
            // --------------------------------------------------
            this.queSetSendToTeachers.clear();
            this.queSetSendToStudents.length = 0;
            this.queSetSendToStudents = [];

            const writePayload = [
                ...toCreate.map(c => ({ originalClass: null, editedClass: c })),
                ...toUpdate.map(({ before, after }) => ({ originalClass: before, editedClass: after }))
            ];

            const results = await Promise.all(
                writePayload.map(async (item) => {
                    try {
                        await this.writeClassToDB(item);
                        return item;
                    } catch (err) {
                        console.error('Error processing class:', item, err);
                        return null;
                    }
                })
            );

            console.log('saveClasses: processed', results);

            // --------------------------------------------------
            // 4️⃣ Post-write adjustments
            // --------------------------------------------------
            if (this.queSetSendToTeachers.length > 0) {
                await this.setSendToTeacher();
            }

            return 'OK';
        },

        diffClasses(baselineRaw, editedRaw) {
            const baseline = (baselineRaw || []).map(c => ({
                ...c,
                key: String(c.key)
            }));

            const edited = (editedRaw || []).map(c => ({
                ...c,
                key: String(c.key)
            }));

            const baselineMap = new Map(baseline.map(c => [c.key, c]));
            const editedMap   = new Map(edited.map(c => [c.key, c]));

            const toDelete = [];
            const toCreate = [];
            const toUpdate = [];

            // 🔴 DELETE (exists before, not anymore)
            for (const [key, original] of baselineMap) {
                if (!editedMap.has(key)) {
                    toDelete.push(original);
                }
            }

            // 🟢 CREATE + 🟡 UPDATE
            for (const [key, current] of editedMap) {
                const original = baselineMap.get(key);

                if (!original) {
                    toCreate.push(current);
                } else {
                    // shallow compare (you can improve this later)
                    const changed =
                        JSON.stringify(original) !== JSON.stringify(current);

                    if (changed) {
                        toUpdate.push({ before: original, after: current });
                    }
                }
            }

            return { toCreate, toUpdate, toDelete };
        },

        resetClassEditFlags(classes) {
            classes.forEach(cls => {
                cls.newClass = false;
                cls.students_changed = false;
                cls.teacher_changed = false;
                cls.startTime_changed = false;
                cls.endTime_changed = false;
                cls.class_room_changed = false;
            });
        },

        async changeEditedClassesInCourse(action, resourceId, itemClass) {
            // ----------------------------------
            // 1️⃣ Handle single-class removal
            // ----------------------------------
            if (action === 'removeStudent' && itemClass) {
                this.removeStudentOrClass(itemClass, resourceId);
            }

            // ----------------------------------
            // 2️⃣ Apply bulk changes to selection
            // ----------------------------------
            for (const cls of this.selectedClassesCourseOrGroup) {

                if (this.resourceTeacher_id !== null) {
                    cls.teacher_id = this.resourceTeacher_id;
                    cls.teacher_changed = true;
                }

                if (this.resourceClassStartTime !== null) {
                    cls.startTime = this.resourceClassStartTime;
                    cls.startTime_changed = true;
                }

                if (this.resourceClassEndTime !== null) {
                    cls.endTime = this.resourceClassEndTime;
                    cls.endTime_changed = true;
                }

                if (this.resourceClass_room_id !== null) {
                    cls.class_room_id = this.resourceClass_room_id;
                    cls.class_room = this.getClassRoomId(this.resourceClass_room_id).name;
                    cls.class_room_changed = true;
                }

                // Recalculate timing if anything changed
                if (
                    cls.startTime_changed ||
                    cls.endTime_changed ||
                    cls.teacher_changed ||
                    cls.class_room_changed
                ) {
                    cls.duration = this.calcDurationClass(cls);
                    cls.minutes_used = this.calcMinutesUsed(cls);
                    this.createClassFromDayTime(cls);
                }

                // ----------------------------------
                // 3️⃣ Bulk remove student
                // ----------------------------------
                if (action === 'removeStudent') {
                    this.removeStudentOrClass(cls, resourceId);
                }
            }

            this.noActionsTaken = false;
        },

        removeStudentOrClass(cls, resourceId) {
            if (cls.amount_students === 1) {
                const pos = this.editedClassesInResource.findIndex(
                    c => c.key === cls.key
                );
                if (pos > -1) {
                    this.editedClassesInResource.splice(pos, 1);
                }
            } else {
                this.removeStudentFromClassinCourse(cls, resourceId);
                this.createClassFromDayTime(cls);
            }
        },

        removeStudentFromClassinCourse(itemClass, resourceId) {

            const index = itemClass.studentsObject.findIndex(
                s => s.resource_id === resourceId
            );

            if (index === -1) return itemClass;

            // 1️⃣ Remove student
            itemClass.studentsObject.splice(index, 1);

            // 2️⃣ Recalculate derived fields
            itemClass.amount_students = itemClass.studentsObject.length;
            itemClass.students = this.createStudentsFromObject(itemClass.studentsObject);
            itemClass.students_changed = true;

            // 3️⃣ Recalculate individual_instead
            itemClass.individual_instead =
                itemClass.amount_students === 1 &&
                itemClass.class_language !== 'English';

            return itemClass;
        },

        calcMinutesUsed(itemClass) {
            if (itemClass.individual_instead) {
                return itemClass.duration / 3 * 4;
            } else {
                return itemClass.duration;
            }
        },

        getClassRoomId(classRoomId) {
            console.log('getClassRoomId', classRoomId, this.classRooms);
            let classRoom =  this.classRooms.filter(function(select_item) {
                return select_item.id === classRoomId;
            })[0];
            return classRoom;
        },

        getClassRoomLabel(classRoomLabel) {
            let classRoom =  this.classRooms.filter(function(select_item) {
                return select_item.label === classRoomLabel;
            })[0];
            return classRoom;
        },

        async createClassRoomsWithAvailability(class_id, day, startTime, endTime) {
            console.log('classRoomsWithAvailability', class_id, day, startTime, endTime);
            let start = this.timeToTimeStamp(day, startTime);
            let end = this.timeToTimeStamp(day, endTime);
            let sqlTxt = '';
            if (class_id) {
                sqlTxt = 'class_id <> ' + class_id + ' AND ((start < "' + start + '" AND end > "' + start + '") OR (start < "' + end + '" AND end > "' + end + '") OR (start >= "' + start + '" AND end <= "' + end + '"))';
            } else {
                sqlTxt = '((start < "' + start + '" AND end > "' + start + '") OR (start < "' + end + '" AND end > "' + end + '") OR (start >= "' + start + '" AND end <= "' + end + '"))';
            }
            
            console.log('getAvailabilityClassRoom #1', start, end);
            let doubleBookedClasses = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassesSafe', sqlTxt)));
            console.log('getAvailabilityClassRoom #2', doubleBookedClasses, this.classRooms);

            let classRoomsAvailable = [];
            let occupied = null;
            let classRoomId = null;
            let lististem = {};
            for (let i = 0; i < this.classRooms.length; i++) {
                classRoomId = this.classRooms[i].id
                occupied = doubleBookedClasses.filter(function(select_item) {
                    return select_item.class_room_id === classRoomId;
                });
                if (occupied.length === 0 || this.classRooms[i].label === 'Elsewhere') {
                    lististem = {
                        id: this.classRooms[i].id,
                        name: this.classRooms[i].name,
                    }
                } else {
                    lististem = {
                        id: this.classRooms[i].id,
                        name: this.classRooms[i].name + " Not Available",
                    }
                }
                classRoomsAvailable.push(lististem);
            }
            console.log('getAvailabilityClassRoom #3', classRoomsAvailable);
            this.classRoomsWithAvailability = classRoomsAvailable;
        },

        async filterSelectionClassesResources() {
            this.resourceTeacher_id = null;
            this.resourceClassStartTime = null;
            this.resourceClassEndTime = null;
            this.resourceClass_room_id = null;
        },

        createUUID() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        async setToday () {
            var date = new Date();
            this.focusCalendar = this.formattedDate(date,'date');
            await this.loadCalendar();
            this.checkGraduations();
        },

        async prev () {
            this.$refs.calendar.prev();
            await this.loadCalendar();
            this.checkGraduations();
        },

        async next () {
            this.$refs.calendar.next();
            await this.loadCalendar();
            this.checkGraduations();
        },

        async clickDate() {
            if (this.scopeCalendar !== 'category') {
                this.changingScopeCalendar('category')
            }
            await this.loadCalendar();
            this.checkGraduations();
        },

        adoptCoursePropsToClass(resource, itemClass) {
            console.log('adoptCoursePropsToClass')
            itemClass.class_language = resource.class_language;
            itemClass.class_type = resource.class_type;
            itemClass.class_location = resource.class_location;
            itemClass.class_group = resource.class_group;
            itemClass.level = resource.initial_spanish_level;
            itemClass.icon = this.getIcon(resource);
        },

        getIcon(item) {
            if (item.class_language === 'English') {
                return "$vuetify.icons.icon_english";
            } else if (item.class_language === 'Quechua') {
                return "$vuetify.icons.icon_quechua";
            } else {
                return "$vuetify.icons.icon_spanish";
            }
        },
        
        checkAllTeachersSelected() {
            var allSelected = true;
            for (let index = 0; index < this.activeTeachers.length; index++) {
                if ((this.scopeLanguage === 'Spanish' && this.activeTeachers[index].spanish === 1) || (this.scopeLanguage === 'English' && this.activeTeachers[index].english === 1) || (this.scopeLanguage === 'Quechua' && this.activeTeachers[index].quechua === 1)) {
                    if (!this.activeTeachers[index].visible) {
                        allSelected = false
                    }
                }
            }
            this.$store.dispatch('changeSelectAllTeachers', allSelected);
        },

        changingScopeResources(event) {
            // console.log('changingScopeResources', event, this.resourcesLoaded.length, this.resourcesScope.length)
            this.$store.dispatch('changeScopeResources', event);
            if (this.scopeResources === 'completed') {
                this.loadCourses();
            } 
        },

        selectTeachers(item) { 
            if (item.class_language === 'Spanish') {
                return this.activeTeachers.filter(function(select_item) {
                    return select_item.obsolete === null && select_item.spanish;
                })
            }
            if (item.class_language === 'Quechua') {
                return this.activeTeachers.filter(function(select_item) {
                    return select_item.obsolete === null && select_item.quechua;
                })
            }
            if (item.class_language === 'English') {
                return this.activeTeachers.filter(function(select_item) {
                    return select_item.obsolete === null && select_item.english;
                })
            }
        },

        getTeacher(teacherId) {
            let teacher =  this.allTeachers.filter(function(select_item) {
                return select_item.id === teacherId;
            })[0];
            return teacher;
        },

        async changingScopeCalendar(event) {
             this.$store.dispatch('changeScopeCalendar', event);
             await this.loadCalendar();
             this.checkGraduations();
        },

        calcPaymentClass(itemClass) {
            if (
                !itemClass.teacher_id ||
                !(itemClass.autoPayment || itemClass.autoPayment === 1)
            ) {
                return itemClass;
            }

            const teacher = this.allTeachers.find(
                t => t.id === itemClass.teacher_id
            );

            if (!teacher) return itemClass;

            let rate = null;

            // NORMAL
            if (itemClass.class_type === 'Normal') {
                if (itemClass.class_group === 'Individual') {
                    rate = teacher.rate_individual;
                }

                if (itemClass.class_group === 'Group') {
                    rate = itemClass.amount_students === 1
                        ? teacher.rate_individual
                        : teacher.rate_group;
                }
            }

            // SPECIAL
            if (itemClass.class_type === 'Special') {
                if (itemClass.class_group === 'Individual') {
                    rate = teacher.rate_special;
                }

                if (itemClass.class_group === 'Group') {
                rate = itemClass.amount_students === 1
                    ? teacher.rate_special
                    : teacher.rate_special_group;
                }
            }

            if (rate !== null) {
                const payment = new this.decUtil.toDec(rate)
                .mul(itemClass.duration)
                .div(60);

                itemClass.paymentClass = payment.toFixed(2); // string
                itemClass.rate = rate;
            }

            return itemClass;

        },

        timeToTimeStamp(day, time) {
            // console.log("timeToTimeStamp", day, time)
            let minStart = time.substring(time.length - 2, time.length);
            let hourStart = time.substring(0, time.length - 3);
            // console.log('timeToTimeStamp', this.toTimestamp(this.formattedDate(dayjs(day).hour(hourStart).minute(minStart), "dateTime")))
            return this.toTimestamp(this.formattedDate(dayjs(day).hour(hourStart).minute(minStart), "dateTime"));
        },

        toTimestamp(strDate){
            var datum = Date.parse(strDate);
            return datum;
        },

        changeObjectInArray(array, object, pos) {
            if (pos > -1) {
                let objectPropNames = Object.keys(object)
                for ( let i = 0; i < objectPropNames.length; i++ ) {
                    array[pos][objectPropNames[i]] = object[objectPropNames[i]]
                }
            }
        },

        async updateResource (resource) {
            // console.log('updateResource', resource);
            (resource.start) ? resource.start = this.formattedDate(resource.start, 'date') : resource.start = null;
            (resource.end) ? resource.end = this.formattedDate(resource.end, 'date') : resource.end = null;
            (resource.info_to_provider) ? resource.info_to_provider = this.formattedDate(resource.info_to_provider, 'date') : resource.info_to_provider = null;
            (resource.info_to_client) ? resource.info_to_client = this.formattedDate(resource.info_to_client, 'date') : resource.info_to_client = null;
            (resource.reserved) ? resource.reserved = this.formattedDate(resource.reserved, 'date') : resource.reserved = null;
            resource.id = resource.resource_id; // table resources prim key is ID
            // console.log('updateResource insertResource', resource);
            let payload = {
                client: null,
                applications: null,
                services: null,
                radioGroups: null,
                radioOptions: null,
                options: null,
                resources: [],
            };

            const local = this.resourcesLoaded.find(r => r.resource_id === resource.resource_id)

            resource = {
                ...local,
                ...resource
            }
            
            payload.resources.push(resource);
            // await this.$store.dispatch('insertResource', resource);
            await this.$store.dispatch('insertUpdateMainItems', payload);

            return resource;
        },

        resetDialogCourseState() {
            this.editedResource = {};
            this.editedClassesInResource = [];
            this.selectedClassesCourseOrGroup = [];
            this.noActionsTaken = true;
            this.classGroup = null;
            this.classGroupId = null;
            this.classGroupIdHours = null;
            this.selectedResources = [];
            this.resourcesSelectList = [];
            this.resourceClassStartTime = null;
            this.resourceClassEndTime = null;
        },

        async onSaveCourse(close) {
            await this.saveCourse();

            this.noActionsTaken = true;

            if (close) {
                this.dialogCourse = false;
            }
        },

        resetDialogClsGroupState() {
            this.editedClsGroup = {};
            this.classesInClsGroup = [];
            this.editedClassesInClsGroup = [];
            this.selectedClassesInClsGroup = [];
            this.noActionsTaken = true;
            this.classGroup = null;
            this.classGroupId = null;
            this.selectedResources = [];
            this.resourcesSelectList = [];
            this.resourceClassStartTime = null;
            this.resourceClassEndTime = null;
        },

        changeScopeClassesTeachers(event) {
            this.$store.dispatch('changeScopeClassesTeachers', event);
            this.loadDataAll();
            this.checkGraduations();
        },

        async onSaveClsGroup(close) {
            await this.saveClsGroup();

            this.dialogClsGroupBaseline = this.deepClone({
                classGroup: this.editedClsGroup,
                classes: this.editedClassesInClsGroup
            });

            this.noActionsTaken = true;

            if (close) {
                this.dialogClsGroup = false;
            }
        },

        changingScopeClsGroups(event) {
            this.$store.dispatch('changeScopeClassGroups', event);
            this.loadDataAll();
            this.checkGraduations();
        },

        itemRowBackgroundResources: function (item) {
            if (item.class_group === "Group" && item.class_type === "Normal") {
                if (this.activeTabTeaching === 1) {
                    return 'background_normal_classgroup';
                } else {
                    return 'background_normal_group';
                }
            }
            if(item.class_group === "Group" && item.class_type === "Special") {
                if (this.activeTabTeaching === 1) {
                    return 'background_special_classgroup';
                } else {
                    return 'background_special_group';
                }
            }
            if(item.class_group === "Individual" && item.class_type === "Normal") {
                return 'background_normal_individual'
            }
            if(item.class_group === "Individual" && item.class_type === "Special") {
                return 'background_special_individual'
            }
            return 'white-background';
        },

        goClient(id, resourceId) {
            this.$store.dispatch('setLoadingApp', 1);
            this.$router.push({ name: 'Client', params: { id: id, resourceId: resourceId } })
        },

        async changeTeacherVisibility(index, teacher) {
            let payload = {index: index, visibility: !teacher.visible }; 
            this.$store.dispatch('changeTeacherVisibility', payload); 
            await this.checkAllTeachersSelected(); 
            await this.loadCalendar();
            this.checkGraduations();
        },

        showAllTeachers(visibility) {
            let payload = {};
            for (let index = 0; index < this.activeTeachers.length; index++) {
                if ((this.scopeLanguage === 'Spanish' && this.activeTeachers[index].spanish === 1) || (this.scopeLanguage === 'English' && this.activeTeachers[index].english === 1) || (this.scopeLanguage === 'Quechua' && this.activeTeachers[index].quechua === 1) || (this.scopeLanguage === 'allLanguages')) {
                    payload = {
                        index: index,
                        visibility: visibility,
                    }
                } else {
                    payload = {
                        index: index,
                        visibility: false,
                    }
                }
                this.$store.dispatch('changeTeacherVisibility', payload);
            }
        },

        async payClasses(teacher) {
            if (this.selectedClassesTeachers.length > 0) {
                // console.log(teacher);

                const correction = this.decUtil.toDec(teacher.correction || 0);
                const comments_correction = teacher.comments_correction || '';

                const paymentProfe = {
                    teacher: teacher.id,
                    contactId: teacher.contact_id,
                    language: this.selectedClassesTeachers[0].class_language,
                    discountPayment: teacher.discount_payment,
                    classes: this.selectedClassesTeachers,
                    correction,                 // Decimal ✔
                    comments_correction,
                };

                teacher.correction = null;
                teacher.comments_correction = null;

                this.$router.push({
                    name: 'Financial',
                    params: {
                    paymentProfe,
                    appId: null,
                    transId: null
                    }
                });
            }
        },

        openTransactionOutgoings(transIdOutgoings) {
            this.$store.dispatch('setLoadingApp', 1)
            this.$router.push({ name: 'Financial', params: { transIdOutgoings: transIdOutgoings } })
        },

        getBackgroundColorTeachers: function (item) {
            return item.teacherRowClass;
        },

        getStatusResource(resource) {
            let statusResourceId = resource.statusResourceId
            return this.$store.state.statusResources.filter((select_item) => {
                return select_item.id === statusResourceId;
            })[0];
        },

        setSendToTeacher() {
            if (this.queSetSendToTeachers.length > 0) {
                let pos = -1;
                for (let i = 0; i < this.queSetSendToTeachers.length; i++) {
                    let payload = {
                        id: this.queSetSendToTeachers[i],
                        lastSchedule: null
                    };
                    console.log('setSendToTeacher', this.indexTeachers, payload);
                    this.$store.dispatch('updateTeacherSchedule', payload);
                    pos = this.indexTeachers.map(function(e) { return e.id; }).indexOf(this.queSetSendToTeachers[i]);
                    this.indexTeachers[pos].lastSchedule = null;
                }
                this.queSetSendToTeachers.clear();
            }
        },

        sameArrays(arrayOne, arrayTwo) {
            let arrayOneJSON = JSON.stringify(arrayOne);
            let arrayTwoJSON = JSON.stringify(arrayTwo);
            let result = (arrayOneJSON === arrayTwoJSON);
            return result;
        },

        onlyInFirstArray(firstArray, secondArray) { 
            // console.log('onlyInFirstArray', firstArray, secondArray)
            let arrayOne = JSON.parse(JSON.stringify(firstArray))
            let arrayTwo = JSON.parse(JSON.stringify(secondArray))
            return arrayOne.filter(arrayOneValue =>
                !arrayTwo.some(arrayTwoValue => 
                    this.sameArrays(arrayOneValue, arrayTwoValue)));
        },

        async openClassInCalendar(item) {
            console.log('openClassInCalendar', item);
            this.$store.dispatch('setLoadingApp', 1);
            this.resetDialogCourseState();
            this.dialogCourse = false;
            this.dialogClsGroup = false;
            this.$store.dispatch('changeScopeCalendar', 'category');
            this.activeTabTeaching = 2;
            this.focusCalendar = this.formattedDate(item.day,'date');
            await this.loadCalendar();
            await this.openDialogClass(item);
            this.$store.dispatch('setLoadingApp', 0);
        },

        async changeDate (event) {
            console.log('changeDate', event);
            this.$store.dispatch('setLoadingApp', 1)
            this.focusCalendar = event;
            this.loadCalendar();
            this.$store.dispatch('setLoadingApp', 0);
        },

        async cleanTableClsGroups() {
            console.log('cleanTableClsGroups');
            let sqlTxt = 'amount_of_classes = 0';
            let classGroups = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassGroupsSafe', sqlTxt)));
            for (let index = 0; index < classGroups.length; index++) {
                var today = new Date();
                let days = dayjs(today).diff(dayjs(classGroups[index].last_change), 'd').toFixed(0);
                if (days > 1) {
                    await this.$store.dispatch('deleteClassGroup', classGroups[index].class_group_id);
                }
            }
        },

        async removeClsGroup(class_group_id) {
            this.checkLoadingApp();
            await this.$store.dispatch('deleteClassGroup', class_group_id);
            await Promise.all([this.loadTeachers(), this.loadCalendar(), this.loadClsGroups()]).then(() => {
                this.checkLoadingApp();
            });
        },

        async removeClassFromClsGroup(classId) {
            const newList = this.editedClassesInClsGroup.filter(
                c => c.class_id !== classId
            );

            if (newList.length === this.editedClassesInClsGroup.length) return;

            this.editedClassesInClsGroup = newList;
            this.noActionsTaken = false;
        },

        async revertDialogCourseChanges() {
            if (!this.dialogBaseline) return;

            const base = this.deepClone(this.dialogBaseline);

            this.editedResource = base.resource;
            this.editedClassesInResource = this.deepClone(base.classes);

            // 🔑 trigger reactivity
            this.editedClassesInResource = [...this.editedClassesInResource];

            this.classGroupId = null;

            this.noActionsTaken = true;
        },

        async revertChangesDialogClsGroup() {
            
            if (!this.dialogClsGroupBaseline) return;

            const base = this.deepClone(this.dialogClsGroupBaseline);

            this.editedClsGroup = base.classGroup;
            this.editedClassesInClsGroup = base.classes;

            this.noActionsTaken = true;
        },

        changeScopeTypeResources(scopeType) {
            console.log('changeScopeTypeResources', scopeType);
            this.$store.dispatch('changeScopeTypeResources', scopeType);
            this.events = this.filterClassesCalendar(JSON.parse(JSON.stringify(this.classesCalendarLoaded)));
            if (this.scopeClassGroups === 'open') {
                this.classGroupsDisplay = this.filterClsGroups(this.classGroupsLoadedOpen);
            } else {
                this.classGroupsDisplay = this.filterClsGroups(this.classGroupsLoadedClosed);
            }
        },

        checkScopeTypeResources(tab) {
            // console.log('checkScopeTypeResources', tab);
            if (tab === 0 && (this.scopeTypeResources !== 'GroupNormal' && this.scopeTypeResources !== 'GroupSpecial' && this.scopeTypeResources !== 'IndividualNormal' && this.scopeTypeResources !== 'IndividualSpecial')) {
                this.changeScopeTypeResources('all');
            } else if (tab === 1 && (this.scopeTypeResources !== 'GroupNormalClsGroup' && this.scopeTypeResources !== 'GroupSpecialClsGroup')) {
                this.changeScopeTypeResources('all');
            }
        },

        createPaymentTeacherForm (teacher) {
            this.$store.dispatch('setLoadingApp', 1);
            let classesPaid = this.selectedClassesTeachers;
            let correction = 0;
            (teacher.correction) ? correction = teacher.correction : correction = 0;
            correction = this.decUtil.toDec(correction);
            let comments_correction = '';
            (teacher.comments_correction) ? comments_correction = teacher.comments_correction : comments_correction = '';
            let discountPayment = teacher.discount_payment;

            let totalPayment = this.decUtil.toDec(0);

            for (let i = 0; i < this.selectedClassesTeachers.length; i++) {
                const payment = this.decUtil.toDec(this.selectedClassesTeachers[i].paymentClass);
                totalPayment = totalPayment.plus(payment);
            }
            totalPayment = totalPayment.toNumber();

            let totalMinutes = 0;
            for (let index = 0; index < classesPaid.length; index++) {
                totalMinutes = totalMinutes + classesPaid[index].duration;
                classesPaid[index].description = classesPaid[index].class_type + '-' + classesPaid[index].class_group + ': ' + ' (' + classesPaid[index].amount_students + ') ' + classesPaid[index].students;
                classesPaid[index].description = classesPaid[index].description.substring(0, 80);
            }
            classesPaid = classesPaid.sort(this.dynamicSort('start'));

            const formHeader = `
                <div style="margin-top: 0cm; display: flex; flex-direction: column; font-family: Raleway, Arial, Helvetica, sans-serif;">
                <div style="display: flex; flex-direction: row; justify-content: space-between; margin: 0 0 2cm 0;">
                    <div style="font-family: Roboto, sans-serif; font-size: 32px; color: #35b729;">
                    <span>PROYECTO</span><strong>PERU</strong>
                    </div>

                    <div style="font-size: 32px; color: grey; display: flex; flex-direction: column; align-items: flex-end;">
                    <div>PAGO PROFE</div>
                    <div style="font-size: 24px;">${teacher.contact}</div>
                    <div style="font-size: 18px;">${this.formattedDate(Date.now())}</div>
                    </div>
                </div>
                </div>
            `;

            const rows = classesPaid.map(c => {
                const durationHours = this.decUtil.toDec(c.duration).div(60);
                const ratePerHour = this.decUtil.toDec(c.paymentClass).div(durationHours);

                return `
                    <tr style="font-size: 12px">
                    <td>${this.formattedDate(c.start, 'dateAndTime')} (${c.duration})</td>
                    <td>${c.description}</td>
                    <td>${ratePerHour.toFixed(2)}</td>
                    <td>${this.decUtil.toDec(c.paymentClass).toFixed(2)}</td>
                    </tr>
                `;
            }).join('');

            const formBody = `
                <div>
                <table style="width: 100%;">
                    <tr>
                    <th style="text-align: left; width: 140px;">Fecha/hora (min)</th>
                    <th style="text-align: left;">Descripcion</th>
                    <th style="text-align: left; width: 120px;">Tarifa (hr)</th>
                    <th style="text-align: left;">Pago</th>
                    </tr>
                    ${rows}
                </table>
                </div>
            `;

            const subtotal = this.decUtil.toDec(totalPayment);
            const discountPercent = this.decUtil.toDec(discountPayment);
            const correctionDec = this.decUtil.toDec(correction);

            const discountAmount = subtotal
            .mul(discountPercent)
            .div(100);

            const totalFinal = subtotal
            .minus(discountAmount)
            .plus(correctionDec);

            let formFooter = `
                <div style="margin-top: 0.5cm; display: flex; flex-direction: column; font-family: Raleway, Arial, Helvetica, sans-serif; background-color: #c7d3d1; height: 2px;"></div>

                <div style="width: 100%; display: flex; flex-direction: column;">
                <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end">
                    <div>
                    <div style="text-align: right">
                        Subtotal:&nbsp;&nbsp;&nbsp;${subtotal.toFixed(2)}
                    </div><br/>

                    <div style="text-align: right">
                        AFP ${discountPayment}%:&nbsp;&nbsp;&nbsp;-${discountAmount.toFixed(2)}
                    </div><br/>

                    <div style="text-align: right">
                        Corrección ${comments_correction}:&nbsp;&nbsp;&nbsp;S/.${correctionDec.toFixed(2)}
                    </div>
                    </div><br/><br/>
                </div>

                <div style="margin-top: 0.5cm; display: flex; flex-direction: column; font-family: Raleway, Arial, Helvetica, sans-serif; background-color: #c7d3d1; height: 2px;"></div>

                <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end">
                    <h3>
                    Total: S/.${totalFinal.toFixed(2)}<br>
                    ${totalMinutes / 60} horas
                    </h3>
                </div>
                </div>
            `;

            let emailList = [];
            emailList.push(teacher.email);
            this.outputData = {
                submittedFrom: "PaymentTeacherForm",
                formHTML: formHeader + formBody + formFooter,
                emailList: emailList,
                emailSubject: "Pago Profe " + teacher.contact,
                emailTeacherId: teacher.id,
                teacher: teacher.contact
            }
            this.dialogForm = true;
            this.$store.dispatch('setLoadingApp', 0);
        },

        // ****************************************************************
        // createTeacherClassSchedule START
        // ****************************************************************

        async createTeacherClassSchedule(teacher) {
            this.setLoading(true);

            try {
                const prepared = this.prepareTeacherClasses(this.selectedClassesTeachers);
                const html = this.buildTeacherScheduleHtml(teacher, prepared);

                this.setTeacherScheduleOutput(teacher, html);
                this.dialogForm = true;
            } finally {
                this.setLoading(false);
            }
        },

        prepareTeacherClasses(classes) {
            const sorted = [...classes].sort(this.dynamicSort('start'));

            const totalMinutes = sorted.reduce(
                (sum, c) => sum + c.duration,
                0
            );

            const totalHours = Math.floor((totalMinutes / 60) * 2) / 2;

            const rows = sorted.map(c => ({
                date: this.formattedDate(c.start, 'dayAndDate'),
                time: `${this.formattedDate(c.start, 'time')} - ${this.formattedDate(c.end, 'time')}`,
                duration: `${c.duration / 60}h`,
                room: c.class_room_name,
                type: `${c.class_group ? c.class_group[0] : '?'}-${c.class_type ? c.class_type[0] : '?'}`,
                students: `(${c.amount_students}) ${c.students}`,
            }));

            return { rows, totalHours };
        },

        buildTeacherHeader(teacherName) {
            return `
                <div style="font-family:Raleway,Arial,sans-serif">
                <div style="display:flex;justify-content:space-between;margin-bottom:2cm">
                    <div style="font-size:32px;color:#35b729">
                    <span>PROYECTO</span><strong>PERU</strong>
                    </div>
                    <div style="text-align:right;color:grey">
                    <div>PLANIFICACIÓN</div>
                    <div style="font-size:24px">${teacherName}</div>
                    <div style="font-size:18px">${this.formattedDate(Date.now())}</div>
                    </div>
                </div>
                </div>
            `;
        },

        buildTeacherTable(rows, totalHours) {
            const body = rows.map(r => `
                <tr style="font-size:14px">
                <td>${r.date}</td>
                <td>${r.time}</td>
                <td>${r.duration}</td>
                <td>${r.room}</td>
                <td>${r.type}</td>
                <td>${r.students}</td>
                </tr>
            `).join('');

            return `
                <table style="width:100%">
                <tr>
                    <th style="width:100px">Fecha</th>
                    <th style="width:100px">Hora</th>
                    <th style="width:50px">Dur</th>
                    <th style="width:100px">Lugar</th>
                    <th style="width:50px">Tipo *</th>
                    <th>Estudiantes</th>
                </tr>
                ${body}
                </table>

                <br/>
                <strong>Total:</strong> ${totalHours} horas
                <br/><br/>

                <div style="font-size:12px">
                * G-N: Grupo-Normal, G-S: Grupo-Special,
                I-N: Individual-Normal, I-S: Individual-Special
                </div>

                <div style="margin-top:6px;font-size:12px">
                Revisar el nivel del estudiante en Spanish test
                </div>
            `;
        },

        buildSimpleFooter() {
            return `
                <div style="margin-top:2cm;height:2px;background:#c7d3d1"></div>
            `;
        },

        buildTeacherScheduleHtml(teacher, prepared) {
            return (
                this.buildTeacherHeader(teacher.contactFullName) +
                this.buildTeacherTable(prepared.rows, prepared.totalHours) +
                this.buildSimpleFooter()
            );
        },

        setTeacherScheduleOutput(teacher, html) {
            this.outputData = {
                submittedFrom: 'ClassScheduleTeacher',
                formHTML: html,
                emailList: [teacher.email],
                emailSubject: `Class Schedule Proyecto Peru ${teacher.contact}`,
                emailTeacherId: teacher.id,
                teacher: teacher.contact
            };
        },

        // ****************************************************************
        // createTeacherClassSchedule END
        // ****************************************************************


        // ****************************************************************
        // createStudentClassSchedule START
        // ****************************************************************

        async createStudentClassSchedule(resource, openDialogForm) {
            // console.log("createStudentClassSchedule", resource);

            let resourceId = resource.resource_id;

            resource = await this.getResourcesFromIds([resourceId]);

            // console.log("createStudentClassSchedule", resource);

            if (resource.length === 1) {
                resource = resource[0];
            } else {
                return this.noClassesWarning();
            }

            this.setLoading(true);

            try {
                const classes = await this.loadSelectedUpcomingClasses(resource.client_id);
                if (!classes.length) return this.noClassesWarning();

                this.ensureInfoToClient(resource);
                const prepared = this.prepareClasses(classes, resource);

                const html = this.buildScheduleHtml(resource, prepared);
                this.setOutputData(resource, prepared.meta, html);

                if (openDialogForm) this.dialogForm = true;
            } finally {
                this.setLoading(false);
            }
        },

        setLoading(state) {
            this.$store.dispatch('setLoadingApp', state ? 1 : 0);
        },

        noClassesWarning() {
            this.$store.dispatch('warningMessage', 'No classes planned for this client');
        },

        async loadSelectedUpcomingClasses(clientId) {
          const classes = await this.$store.dispatch('getClassesClientId', clientId);

          const nowTs = this.toTimestamp(
              this.formattedDate(Date.now(), 'dateTime')
          );

          const upcomingClasses = classes.filter(c => c.end > nowTs);

          if (this.selectedClassesCourseOrGroup.length === 0) {
              return this.configureClassesFromDB(upcomingClasses);
          } else {
              return this.configureClassesFromDB(
                  this.selectedClassesCourseOrGroup
              );
          }

        },

        ensureInfoToClient(resource) {
            if (!resource.info_to_client) {
                resource.info_to_client = this.formattedDate(new Date(), 'date');
                this.updateResource(resource);
            }
        },

        prepareClasses(classes, resource) {
            const meta = {
                group: false,
                individualInstead: false,
                locationSchool: false,
                breakClass: false,
            };

            const sorted = [...classes].sort(this.dynamicSort('start'));

            const rows = sorted.map(c => {
                meta.group ||= c.class_group === 'Group';

                if (
                    c.class_group === 'Group' &&
                    c.amount_students === 1 &&
                    c.class_language !== 'English'
                ) {
                    meta.individualInstead = true;
                }

                meta.locationSchool ||= c.class_location === 'School Cusco';
                meta.breakClass ||= c.duration_class > 180;

                let status = "";

                if (resource.class_language === 'English') {
                    status = c.duration_class === c.minutes_completed ? 'terminado' : 'planificado';
                } else {
                    status = c.duration_class === c.minutes_completed ? 'finished' : 'planned';
                }

                return {
                  date: this.formattedDate(c.start, 'dayAndDate'),
                  time: `${this.formattedDate(c.start, 'time')} - ${this.formattedDate(c.end, 'time')}`,
                  duration: `${c.duration / 60}h`,
                  room: c.class_room_name,
                  teacher: c.contact,
                  status: status,
                };
            });

            return { rows, meta };
        },

        buildHeader(resource) {
            return `
                <div style="font-family: Raleway, Arial, sans-serif">
                    <div style="display:flex;justify-content:space-between;margin-bottom:2cm">
                        <div style="font-size:32px;color:#35b729">
                        <span>PROYECTO</span><strong>PERU</strong>
                        </div>
                        <div style="text-align:right;color:grey">
                        <div>CLASS SCHEDULE</div>
                        <div style="font-size:24px">${resource.full_name}</div>
                        <div style="font-size:18px">${this.formattedDate(Date.now())}</div>
                        </div>
                    </div>
                </div>
            `;
        },

        buildTable(rows, resource) {

            const body = rows.map(r => `
                <tr>
                  <td>${
                    resource.class_language === 'English'
                      ? dayjs(r.date.substring(4), 'DD MMM', 'en')
                          .locale('es')
                          .format('ddd D [de] MMM')
                      : r.date
                  }</td>
                  <td>${r.time}</td>
                  <td>${r.duration}</td>
                  <td>${r.room}</td>
                  <td>${r.teacher}</td>
                  <td>${r.status}</td>
                </tr>
            `).join('');

            if (resource.class_language === 'English') {
              
              return `
                  <table style="width:100%">
                    <tr>
                        <th>Fecha</th><th>Hora</th><th>Duración</th>
                        <th>Aula</th><th>Profesor(a)</th><th>Estado</th>
                    </tr>
                    ${body}
                  </table>
              `;
            } else {

              return `
                  <table style="width:100%">
                    <tr>
                        <th>Date</th><th>Time</th><th>Duration</th>
                        <th>Room</th><th>Teacher</th><th>Status</th>
                    </tr>
                    ${body}
                  </table>
              `;
            }

            
        },

        buildFooter(resource) {
            if (resource.class_language === 'English') {
                return this.buildSpanishFooter();
            }

            return this.buildOtherLanguageFooter();
        },

        buildScheduleHtml(resource, prepared) {
            return (
                this.buildHeader(resource) +
                this.buildTable(prepared.rows, resource) +
                this.buildFooter(resource, prepared.meta)
            );
        },

        setOutputData(resource, meta, html) {
            this.outputData = {
                submittedFrom: 'ClassScheduleStudent',
                formHTML: html,
                emailList: [resource.email],
                emailSubject: 'Class Schedule Proyecto Peru',
                student: resource.full_name,
                language: resource.class_language,
                resourceId: resource.resource_id,
                ...meta
            };
        },

        buildSpanishFooter() {
            return `
                <div style="margin-top:1cm;height:2px;background:#c7d3d1"></div>
                1. Si el ESTUDIANTE llega tarde, el profesor esperará al ESTUDIANTE solo 20 minutos. Si el ESTUDIANTE llega más de 20 minutos tarde sin haber contactado a Proyecto Perú Inglés o simplemente no se presenta a la clase sin aviso previo, el ESTUDIANTE perderá la clase.
                <br/>
                2. El ESTUDIANTE puede cancelar o reprogramar una clase privada, si el ESTUDIANTE se compromete a contactar a Proyecto Perú Inglés al menos 24 horas antes del inicio de su clase. El ESTUDIANTE puede contactar directamente a Proyecto Perú Inglés al +51 950 301 314. Si la cancelación ocurre con menos de 24 horas de antelación o si el ESTUDIANTE no asiste a la clase, el ESTUDIANTE perderá la lección. Classes grupales no se puede reprogramar.
                <br/>
                3. Al elegir el paquete de grupo, debes seleccionar un horario y días fijos. Una vez elegido, debes comprometerte a asistir esos días y horas todas las semanas. Los paquetes de grupo no son flexibles, por lo que no se pueden cambiar los horarios una vez establecidos.
                <br/><br/>
                El número de aula está sujeto a cambios. Por favor, consulte con su profesor o en la recepción de la escuela.
                <br/><br/>
                <a target="_blank" href="https://www.google.com/maps/place/Proyecto+Peru+Centre">
                Ubicación Escuela
                </a>
            `;
        },

        buildOtherLanguageFooter() {
            let html = `
                <div style="margin-top:1cm;height:2px;background:#c7d3d1"></div>
                <div style="margin-top:10px">
                <strong>Notes:</strong>
                <br/><br/>
            `;

            html += `
                1. <strong>Group Classes:</strong>
                <br/>
                - If there is no other student with the same level available for your group class, you will instead receive a private class with
                75% of the hours. For example instead of 4 hours, you will receive 3 hours of private class.
                <br/>
                - If you miss a group class, your class can not be rescheduled.
                <br/><br/>
                2. <strong>Private Classes:</strong>
                <br/>
                If you expect to miss a private class, notify us <strong>at least 24 hours</strong> in advanced, and we will reschedule it for another day. 
                <br/><br/>
                3. <strong>Public Holidays:</strong>
                <br/>
                We will reschedule classes that fall on holidays.
                <br/><br/>
                Class rooms are subject to change. Please contact the reception at the school if you have any questions.
            `;

            html += `
                <div style="margin-top:20px">
                    <a target="_blank" href="https://www.google.com/maps/place/Proyecto+Peru+Centre">
                    School Location
                    </a>
                    &#9900;
                    <a target="_blank" href="https://proyectoperucentre.org/terms-and-conditions.html">
                    Terms & Conditions
                    </a>
                </div>
                </div>
            `;

            return html;
        },

        // ****************************************************************
        // createStudentClassSchedule END
        // ****************************************************************

        async createEmailContent(sendDirect, resourceId) {
            console.log('createEmailContent');
            let emailIntro = '';
            if (this.outputData.submittedFrom === 'PaymentTeacherForm') {
                emailIntro = "Estimado " + this.outputData.teacher + ",\n\n" + 
                "Presentamos abajo el informe de los pagos de sus clases con los detalles correspondientes. Por favor revisa todo la información y avisa nos lo mas pronto si observa datos incorrectos.\n\n" + 
                "Saludos, \n\n" + this.$store.state.user + "\n\n" +
                "info@proyectoperucentre.org\n" +
                "Proyecto Peru Centre\n" +
                "Avenida Arcopata 466-A\n" +
                "Cusco, Cusco, 45\n" +
                "+ 51 84 240 278"
                this.outputData.emailIntro = emailIntro;
                this.outputData.messagePlain = '';
                this.outputData.saveInvoice = false;
                this.outputData.attachments = null;
                this.dialogEmail = true;
            } else if (this.outputData.submittedFrom === 'ClassScheduleTeacher') {
                emailIntro = "Estimado " + this.outputData.teacher + ",\n\n" + 
                "Presentamos abajo la planificación de sus clases con los detalles correspondientes. Revisa todos los puntos importantes que debe tener en cuenta para dar un excelente servicio al estudiante.\n\n" +
                "1. Revisar el nivel del estudiante en Spanish test:\n" +
                "https://docs.google.com/spreadsheets/d/1fOwOMKTI8_RxKoP72phq5BNeQ1QZWzctJw8V5a4-CYs/edit?resourcekey&usp=forms_web_b#gid=353365034\n" +
                "2. Hacer el plan de clases enviarlo a más tardar en lunes por la noche 22:00 hrs.\n" +
                "3. Confirmar si todo está conforme con el correo (horario) por WhatsUp a nosotros.\n" +
                "4. Escribir en tu reporte mensual el nivel del estudiante y sus datos completos (nombre completo, horas, faltas, feriados etc.).\n" +
                "5. El día lunes darle un cuaderno y el lapicero al estudiante y desinfectar el aula con alcohol.\n" +
                "6. El primer día debes presentar las reglas del aula al estudiante (cancelación de clases de último minuto, cancelar las clases un día antes, cambios especiales con nosotros, recuperación de horas etc.).\n" +
                "7. Avisar a nosotros la falta del estudiante (con anticipación, o cualquier problema que tenga su estudiante).\n" +
                "8. Cualquier cambio especial que el estudiante quiera hacer primero consultar con nosotros antes de confirmar al estudiante.\n" +
                "9. Respetar la asignación del # de aula que está en Horario (de lo contrario eso causara confusiones o problemas innecesarios en administración).\n" +
                "10. El martes o segundo día de sus clases entregar la encuesta #1 y al final de su paquete la encuesta # 2, el estudiante debe dejar en el escritorio de la recepción o dárselo directamente a Dora.\n" +
                "11. Planear con anticipación el plan de salida (mercado, museo etc.) no espere el último minuto.\n" +
                "12. No sacar copias o preparar materiales extras durante la clase dejando al estudiante sin profesora (hacerlo antes que comience sus clases o en el recreo de 15 min).\n" +
                "13. Respetar el recreo estandarizado (por la mañana 10:30 a 10:45 am y por la tarde 3:30 a 3:45pm) de 15 min y avisar a sus estudiantes para volver a clase (solo tienen recreo los estudiantes de 3 horas o 4 horas para arriba no aplica para recuperación de horas perdidas o menos a 3 horas).\n\n" +
                "Saludos, \n\n" + this.$store.state.user + "\n\n" +
                "info@proyectoperucentre.org\n" +
                "Proyecto Peru Centre\n" +
                "Avenida Arcopata 466-A\n" +
                "Cusco, Cusco, 45\n" +
                "+ 51 84 240 278"
                this.outputData.emailIntro = emailIntro;
                this.outputData.messagePlain = '';
                this.outputData.saveInvoice = false;
                this.outputData.attachments = null;
                this.dialogEmail = true;
            } else if (this.outputData.submittedFrom === 'ClassScheduleStudent') {
                if (this.outputData.language === 'English') {
                    emailIntro = "Estimada " + this.outputData.student + ",\n\n" + 
                    "¡Gracias por tomar clases con Proyecto Perú Inglés!" + "\n\n" + 
                    "Estamos emocionados de tenerlos con nosotros y confiamos en que disfrutarán de esta experiencia de aprendizaje. Nuestro objetivo es " +
                    "apoyarlos en su camino hacia la fluidez en inglés, asegurándonos de que aprovechen al máximo cada clase. Si tienen alguna pregunta o " +
                    "inquietud, no duden en comunicarse con nosotros. ¡Nos vemos en clase!\n\n" +
                    "Por favor, revise su horario de clases a continuación.\n\n" +
                    "Hasta pronto, \n" + this.$store.state.user + "\n\n" +
                    "info@proyectoperucentre.org\n" +
                    "Proyecto Peru Centre\n" +
                    "Avenida Arcopata 466-A\n" +
                    "Cusco, Cusco, 45\n" +
                    "+51 950 301 314"
                } else {
                    emailIntro = "Dear " + this.outputData.student + ",\n\n" + 
                    "Thank you for booking classes with Proyecto Peru!\n\n" +
                    "Please check your class schedule below.\n\n"
                    if (this.outputData.individual_instead) {
                        emailIntro += "If you requested the 20 hour group class and there is no one available to put in a group with you, you will be given 15 hours of private classes at the same cost.\n\n"
                    }
                    if (this.outputData.breakClass) {
                        emailIntro += "There's a break of 15 minutes included when your class is longer than 3 hours.\n\n"
                    }
                    if (this.outputData.locationSchool) {
                        emailIntro +=   "Please be 10 minutes early to check the board in school for last minute changes, " + 
                                        "to find your classroom and to grab a cup of coffee or tea.\n" + 
                                        "On your first day you will also receive the necessary materials such as pen and notebook.\n\n"
                    }
                    emailIntro += "If you didn't have the opportunity to complete your Spanish exam yet, please do so at this link <Spanish Placement Test> before your first class so your teacher can be prepared and provide you with the best service.\n\n"
                    if (this.outputData.group) {
                        emailIntro +=   "If you will not be able to make it to a class, please notify us as soon as possible. You can contact us on WhatsApp +51 950301311. \n\n"
                    } else {
                        emailIntro +=   "If you will not be able to make it to a class, please notify us at least one day ahead of time. You can contact us on WhatsApp +51 950301311. This way you will be able to make up the hours you missed at another time. " + 
                                        "If there is an emergency and you are only able to notify us on the day of your class, you will be given half the time of the scheduled class to make up. For make-up classes please arrange these with us directly. \n\n"
                    }
                    emailIntro += "Please contact <office email> to let us know that you received this schedule or if you have any questions or concerns about your classes.\n\n" +
                    "Hasta pronto, \n" + this.$store.state.user + "\n\n" +
                    "info@proyectoperucentre.org\n" +
                    "Proyecto Peru Centre\n" +
                    "Avenida Arcopata 466-A\n" +
                    "Cusco, Cusco, 45\n" +
                    "+ 51 84 240 278"
                }
                this.outputData.emailIntro = emailIntro;
                this.outputData.messagePlain = '';
                this.outputData.saveInvoice = false;
                this.outputData.attachments = null;
                if (sendDirect) {
                    this.sendEmail(resourceId);
                } else {
                    this.dialogEmail = true;
                }
            }
        },

        async sendEmail (resourceId) {
            this.$store.dispatch('setLoadingApp', 1);
            let messageHTML = "<html><body style='max-width: 21cm; margin: 20px; font-family: Raleway, Arial, Helvetica, sans-serif;'><span>" + 
            this.outputData.emailIntro + "</span><br><br>" + this.outputData.formHTML + "</body></html>";
            messageHTML = messageHTML.replace(/\n/g, "<br />");
            messageHTML = messageHTML.replace(/<google>/g, "<a href='https://www.google.com/search?q=proyecto%20peru&sxsrf=ALeKk01w0t_6jBUmS4wAhC6ShgbQb1O-XQ:1627373829160&source=hp&ei=_cD_YM-CAcGIafGcsfgO&iflsig=AINFCbYAAAAAYP_PDTqt8YGv_dAxkU83fnt5PQY_l9-S&oq=proye&gs_lcp=Cgdnd3Mtd2l6EAMYADIECCMQJzICCC4yAggAMgIIADICCAAyAggAMgUIABDLATICCAAyBQgAEMsBMgUIABDLAToECAAQQzoICC4QxwEQowI6BQgAEJECOgQIABAKUPYrWNYxYOM7aABwAHgAgAFjiAGFA5IBATWYAQCgAQGqAQdnd3Mtd2l6&sclient=gws-wiz&tbs=lrf:!1m4!1u3!2m2!3m1!1e1!1m4!1u2!2m2!2m1!1e1!1m4!1u16!2m2!16m1!1e1!1m4!1u16!2m2!16m1!1e2!2m1!1e2!2m1!1e16!2m1!1e3!3sIAE,lf:1,lf_ui:2&tbm=lcl&rflfq=1&num=10&rldimm=4342304706273858016&lqi=Cg1wcm95ZWN0byBwZXJ1SOjP9YbdgYCACFoVEAAYABgBIg1wcm95ZWN0byBwZXJ1kgEPbGFuZ3VhZ2Vfc2Nob29sqgEQEAEqDCIIcHJveWVjdG8oDg&ved=2ahUKEwiEuIP454LyAhUpsKQKHWmlC-AQvS4wDHoECBIQMg&rlst=f#rlfi=hd:;si:4342304706273858016,l,Cg1wcm95ZWN0byBwZXJ1SOjP9YbdgYCACFoVEAAYABgBIg1wcm95ZWN0byBwZXJ1kgEPbGFuZ3VhZ2Vfc2Nob29sqgEQEAEqDCIIcHJveWVjdG8oDg;mv:[[-6.1240304,-71.3310992],[-17.629842,-79.4959938]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!1m4!1u2!2m2!2m1!1e1!1m4!1u16!2m2!16m1!1e1!1m4!1u16!2m2!16m1!1e2!2m1!1e2!2m1!1e16!2m1!1e3!3sIAE,lf:1,lf_ui:2'>Google</a>")
            messageHTML = messageHTML.replace(/<facebook>/g, "<a href='https://www.facebook.com/ProyectoPeru'>Facebook</a>")
            messageHTML = messageHTML.replace(/<online classes>/g, "<a href='https://proyectoperucentre.org/online-spanish-classes.php'>Online Spanish Classes</a>")
            messageHTML = messageHTML.replace(/<Spanish Placement Test>/g, "<a href='https://docs.google.com/forms/d/1u2WVaaYdNo0n22Y8MeHeb3gtwXPhsJg34VAcN1TvL6Q'>Spanish Placement Test</a>")
            messageHTML = messageHTML.replace(/<information on tours>/g, "<a href='https://proyectoperucentre.org/tours/'>here</a>")
            messageHTML = messageHTML.replace(/<office email>/g, "<a href='office@proyectoperucentre.org'>office@proyectoperucentre.org</a>")
            messageHTML = messageHTML.replace(/<Application Form>/g, "<a href='https://proyectoperucentre.org/form'>Application Form</a>")
            this.outputData.messageHTML = messageHTML;
            this.dialogEmail = false;
            if (this.outputData.submittedFrom === 'ClassScheduleStudent') {
                this.adjustSendScheduleStudentsInDialogs(resourceId, null);
            }
            this.$store.dispatch('setLoadingApp', 0);
            let result = await this.$store.dispatch('emailNow', this.outputData);
            if (result === 'OK' && this.outputData.submittedFrom === 'ClassScheduleTeacher') {
                this.saveCurrentScheduleTeacher(this.outputData.emailTeacherId);
            }
            if (result === 'OK' && this.outputData.submittedFrom === 'ClassScheduleStudent') {
                this.$store.dispatch('setOKStudentSchedule', resourceId);
                this.adjustSendScheduleStudentsInDialogs(resourceId, 0);
            }
        },

        saveCurrentScheduleTeacher(teacherId) {
            let pos = -1;
            let payload = {
                id: teacherId,
                schedule: new Date().toISOString().slice(0, 19).replace('T', ' '),
            } 
            this.$store.dispatch('updateTeacherSchedule', payload);
            pos = this.indexTeachers.map(function(e) { return e.id; }).indexOf(teacherId);
            this.indexTeachers[pos].lastSchedule = payload.schedule;
        },
        
        async printNow (html) {
            console.log('printNow ')
            print(html);
            let pos = -1;
            if (this.outputData.submittedFrom === 'ClassScheduleTeacher') {
                console.log('printNow #1b')
                let payload = {
                    id: this.outputData.emailTeacherId,
                    schedule: new Date().toISOString().slice(0, 19).replace('T', ' '),
                } 
                this.$store.dispatch('updateTeacherSchedule', payload);
                pos = this.indexTeachers.map(function(e) { return e.id; }).indexOf(this.outputData.emailTeacherId);
                this.indexTeachers[pos].lastSchedule = payload.schedule;
            }
            if (this.outputData.submittedFrom === 'ClassScheduleStudent') {
                console.log('printNow #1c')
                await this.$store.dispatch('setOKStudentSchedule', this.outputData.resourceId);
                this.adjustSendScheduleStudentsInDialogs(this.outputData.resourceId, 0);
            }
        },

        intToColor(num) {
            num = Number(num); // 👈 force numeric

            if (!Number.isFinite(num)) {
                console.warn('Invalid number for color:', num);
                num = 0;
            }

            num = Math.abs(num);

            const goldenAngle = 137.508;
            const hue = (num * goldenAngle) % 360;

            const isLight = num % 2 === 0;

            const L = isLight ? 0.78 : 0.55;
            const C = 0.14;

            return {
                background: `oklch(${L} ${C} ${hue})`,
                text: isLight ? '#000' : '#fff'
            };
        },

        // Convert HSL → HEX
        hslToHex(h, s, l) {
            s /= 100;
            l /= 100;
            const k = n => (n + h / 30) % 12;
            const a = s * Math.min(l, 1 - l);
            const f = n =>
            l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
            const toHex = x =>
            Math.round(x * 255)
                .toString(16)
                .padStart(2, "0");
            return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
        },

        adjustSendScheduleStudentsInDialogs(resourceId, value) {
            const update = arr => {
                const r = arr?.find(e => e.resource_id === resourceId);
                if (r) r.sendScheduleStudent = value ?? r.sendScheduleStudent;
            };

            update(this.resourcesLoaded);

        },

        getLanguageLevels(school) {
            return this.$store.state.language_levels.filter((select_item) => {
                return select_item.school === school;
            });
        },

        changeDateInDialogClass() {
            console.log('changeDateInDialogClass')
            this.createClassRoomsWithAvailability(this.editedClass.class_id, this.editedClass.day, this.editedClass.startTime, this.editedClass.endTime);
            this.noActionsTaken = false;
            console.log('changeDateInDialogClass #1', this.noActionsTaken)
        },

        get75PercentRounded(hours) {
            const minutes = hours * 60 * 0.75;
            return Math.round(minutes);
        },

        minutesToHm(totalMinutes) {
            const h = Math.floor(totalMinutes / 60);
            const m = totalMinutes % 60;
            return m === 0 ? `${h}h` : `${h}h ${m}m`;
        },

        changeTeacherInClass() {
            this.editedClass.paymentClass = this.decUtil.toDec(this.calcPaymentClass(this.editedClass).paymentClass).toNumber(), 
            this.editedClass.rate = this.decUtil.toDec(this.calcPaymentClass(this.editedClass).rate).toNumber(), 
            this.noActionsTaken = false  
        },

        deepClone(obj) {
            if (obj == null) return obj;

            if (typeof structuredClone === 'function') {
                return structuredClone(obj);
            }

            return JSON.parse(JSON.stringify(obj));
        },

        changeClsGroup(classGroupId) {
            const classGroups = this.classGroupsLoadedOpen || [];
            const existing = classGroups.find(g => g.class_group_id === classGroupId);
            const classGroupName = existing?.class_group_name || '';

            const selectedIds = this.selectedClassesCourseOrGroup.map(c => c.class_id);

            const apply = arr => {
                arr.forEach(c => {
                    if (selectedIds.includes(c.class_id)) {
                        c.class_group_id = classGroupId;
                        c.class_group_name = classGroupName;
                        c.class_group_changed = true;
                    }
                });
            };

            apply(this.selectedClassesCourseOrGroup);
            apply(this.editedClassesInResource);

            this.noActionsTaken = false;
        },

        async openSelectStudent(itemClass) {

            console.log('openSelectStudent itemClass = ', itemClass, this.resourcesLoaded.length);

            this.selectedClassesCourseOrGroup = [itemClass];
            this.editedClass = itemClass;

            await this.openDialogSelectResources(null, {
                useCurrentResourcesInClass: true,
                dayTime: this.formattedDate(itemClass.day, 'date'),
                minutesToFill: itemClass.duration,
            });
        },

        async openDialogSelectResources(editedResource, options = {}) {

            this.selectedStudents = [];
            this.availableStudents = [];

            const {
                useCurrentResourcesInClass = false,
                minutesToFill: forcedMinutesToFill = null,
            } = options;

            const classes = this.selectedClassesCourseOrGroup?.length
                ? this.selectedClassesCourseOrGroup
                : [this.editedClass];

            const baseResource = editedResource;

            let current = [];

            if (useCurrentResourcesInClass) {
                current = this.resourcesInClass || [];
            } else if (this.dialogCourse || this.dialogClsGroup) {
                current = (this.selectedClassesCourseOrGroup || [])
                    .flatMap(c => c.studentsObject || []);
            } else {
                current = this.resourcesInClass || [];
            }

            const currentIds = new Set(
                current.map(r => String(r.resource_id))
            );

            // 🔹 total minutes needed
            const minutesToFill =
                forcedMinutesToFill ??
                classes.reduce((acc, c) => acc + c.duration, 0);

            let eligible = [];

            // 🔹 time range
            const startRange = Math.min(...classes.map(c => new Date(c.start).getTime()));
            const endRange   = Math.max(...classes.map(c => new Date(c.end).getTime()));

            if (this.scopeLanguage !== "allLanguages") {
                eligible = this.resourcesLoaded.filter(r => {
                    return (
                        r.class_language === this.scopeLanguage
                    );
                });
            } else {
                eligible = this.resourcesLoaded;
            }

            eligible = eligible.filter(r => {

                const studentStart = dayjs(r.start).startOf('day').valueOf();
                const studentEnd = dayjs(r.end).add(1, 'day').startOf('day').valueOf();

                return (
                    r.hours > 0 &&
                    ![1, 8, 9, 15].includes(r.statusResourceId) &&

                    studentStart <= endRange &&
                    studentEnd   >= startRange &&

                    (!classes[0].class_location || r.class_location === classes[0].class_location) &&
                    (!classes[0].class_type || r.class_type === classes[0].class_type) &&
                    (!classes[0].class_group || r.class_group === classes[0].class_group) &&
                    (!classes[0].class_language || r.class_language === classes[0].class_language) &&

                    r.resource_id !== baseResource?.resource_id &&
                    !currentIds.has(String(r.resource_id))
                );
            });

            this.availableStudents = eligible.map(r => {

                return {
                    ...r,
                    minutes_available_not_selected: r.minutes_available,
                    minutes_available_preview: r.minutes_available,
                    enough_hours: minutesToFill <= r.minutes_available,
                };
            });

            if (!this.availableStudents.length) {
                this.$store.dispatch('warningMessage', 'No courses found around this date');
                this.events.pop();
                return;
            }
            const seen = new Set();

            const selected = current
                .filter(r => {
                    const id = String(r.resource_id);
                    if (seen.has(id)) return false;
                    seen.add(id);
                    return true;
                });

            const selectedIds = new Set(
                selected.map(r => String(r.resource_id))
            );

            const selectedResources = await this.getResourcesFromIds(selectedIds);
            
            const count = selectedResources.length;

            const isSpanishGroup =
                selectedResources?.[0]?.class_language !== 'English' &&
                selectedResources?.[0]?.class_group === 'Group';

            this.selectedStudents = selectedResources.map(r => {

                let base = r.minutes_available;

                if (count === 1 && isSpanishGroup) {
                  // console.log('minutesToFill ######## 2a', minutesToFill/60, base/60)
                  base = base + ((Number(minutesToFill) || 0) * (4 / 3));
                } else {
                  // console.log('minutesToFill ######## 2b', minutesToFill/60, base/60)
                  base = base + (Number(minutesToFill) || 0);
                }

                return {
                    ...r,
                    minutes_available_preview: base,
                    minutes_available_not_selected: base,
                    enough_hours: true
                };
            });

            this.recalculateSelectedStudents();

            this.dialogSelectResources = true;
        },

        addStudent(item) {

            this.selectedStudents.push({ ...item });

            // console.log('addStudent', item.minutes_available/60, item.minutes_available_preview/60);

            item.class_group = this.selectedStudents[0].class_group;
            item.class_location = this.selectedStudents[0].class_location;
            item.class_type = this.selectedStudents[0].class_type;
            item.class_language = this.selectedStudents[0].class_language;

            this.availableStudents = this.availableStudents.filter(r => {
              return (
                r.class_group === item.class_group &&
                r.class_location === item.class_location &&
                r.class_type === item.class_type &&
                r.class_language === item.class_language
              );
            });

            this.recalculateSelectedStudents();

            this.availableStudents = this.availableStudents.filter(
                r => r.resource_id !== item.resource_id
            );
        },

        removeStudent(item) {
            // console.log("removeStudent", item)

            const ownerId = this.editedResource.resource_id || null;

            if (this.selectedStudents.length <= 1) return;

            this.selectedStudents = this.selectedStudents.filter(
                r => r.resource_id !== item.resource_id
            );

            // Deduplicated insert to availableStudents
            const newItem = {
                ...item,
                minutes_available_preview: item.minutes_available_preview + (Number(this.totalSelectedClassMinutes) || 0)
            };
            // remove any existing instance of this resource first
            this.availableStudents = this.availableStudents.filter(
                r => String(r.resource_id) !== String(item.resource_id)
            );
            // then add it back once
            this.availableStudents.push(newItem);
            // safety deduplication step
            this.availableStudents = this.availableStudents.filter(
                (v, i, arr) =>
                    i === arr.findIndex(r => String(r.resource_id) === String(v.resource_id))
            );

            this.recalculateSelectedStudents();

            this.selectedStudents.sort((a, b) => {
                if (a.resource_id === ownerId) return -1;
                if (b.resource_id === ownerId) return 1;
                return a.full_name.localeCompare(b.full_name);
            });
        },

        recalculateSelectedStudents() {
            const count = this.selectedStudents.length;

            let eff = Number(this.totalSelectedClassMinutes) || 0;

            const isSpanishGroup =
                this.selectedStudents?.[0]?.class_language !== 'English' &&
                this.selectedStudents?.[0]?.class_group === 'Group';

            for (let index = 0; index < this.selectedStudents.length; index++) {
                const item = this.selectedStudents[index];

                const base = Number(item.minutes_available_not_selected) || 0;

                if (isSpanishGroup && count === 1) {
                  console.log('recalculateSelectedStudents #1', base/60, eff/60, Math.round((eff * 4 / 3) / 30) * 30 / 60);
                  item.minutes_available_preview = base - Math.round((eff * 4 / 3) / 30) * 30;
                } else {
                  console.log('recalculateSelectedStudents #2', base/60, eff/60, (base - eff)/60, isSpanishGroup);
                  item.minutes_available_preview = base - eff;
                }
                
            }

            return this.selectedStudents;
        },

        async applySelectedStudents() {

          let dragClass = false;
          let singleClass = false;

            if (!this.dialogClass && !this.dialogCourse && !this.dialogClsGroup) {
              dragClass = true;
            }

            if (this.dialogClass && !this.dialogCourse && !this.dialogClsGroup) {
              singleClass = true;
            }

            // console.log('applySelectedStudents', dragClass, singleClass);

            const selected = this.selectedStudents.map(s => {
              const full = this.resourceMap.get(String(s.resource_id));
              return full ? { ...full } : { ...s };
            });

            if (!dragClass) {
              const selectedIds = new Set(
                this.selectedClassesCourseOrGroup.map(c => c.key)
              );

              this.editedClassesInResource = this.editedClassesInResource.map(cls => {

                  if (selectedIds.has(cls.key)) {
                      return {
                          ...cls,
                          studentsObject: selected.map(s => ({ 
                              full_name: s.full_name,
                              client_id: s.client_id,
                              initial_spanish_level: s.initial_spanish_level,
                              resource_id: s.resource_id,
                              color: {
                                  text: this.getStudentColorStyle(s).color,
                                  background: this.getStudentColorStyle(s).backgroundColor
                              }
                          })),
                          students_changed: true
                      };
                  }

                  return cls;
              });
            }

            this.noActionsTaken = false;

            this.dialogSelectResources = false;

            if (singleClass) {
              this.editedClass.studentsObject = selected.map(s => ({ 
                  full_name: s.full_name,
                  client_id: s.client_id,
                  initial_spanish_level: s.initial_spanish_level,
                  resource_id: s.resource_id,
                  color: {
                      text: this.getStudentColorStyle(s).color,
                      background: this.getStudentColorStyle(s).backgroundColor
                  }
              }));
              if (this.editedClass.studentsObject.length > 0) {
                this.resourcesInClass =
                  await this.createResourcesFromStudentsObject(this.editedClass.studentsObject);
              }
              this.editedClass.students_changed = true;
              console.log('applySelectedStudents #2', this.editedClass);
            }

            if (dragClass) {
              console.log('applySelectedStudents #3', this.editedClass);

              this.editedClass.studentsObject = selected.map(s => ({
                  full_name: s.full_name,
                  client_id: s.client_id,
                  initial_spanish_level: s.initial_spanish_level,
                  resource_id: s.resource_id,
                  color: {
                      text: this.getStudentColorStyle(s).color,
                      background: this.getStudentColorStyle(s).backgroundColor
                  }
              }))

              this.editedClass.class_language = this.selectedStudents[0].class_language;
              this.editedClass.class_group = this.selectedStudents[0].class_group;
              this.editedClass.class_type = this.selectedStudents[0].class_type;
              this.editedClass.class_location = this.selectedStudents[0].class_location;
              
              this.openDialogClass(this.editedClass);
            }
        },

        cancelSelectStudent() {
            console.log('cancelSelectStudent')
            if (!this.dialogClass && !this.dialogCourse) {
                this.events.pop();
            }
            this.dialogSelectResources = false;
            this.selectedResourcesSingleSelect = true;
        },

        getStudentStart(item) {
            // normal students
            if (item.start) {
                return this.formattedDate(item.start, 'date');
            }

            // fallback → earliest selected class
            if (this.selectedClassesCourseOrGroup?.length) {
                const min = Math.min(
                    ...this.selectedClassesCourseOrGroup.map(c => new Date(c.start).getTime())
                );
                return this.formattedDate(min, 'date');
            }

            return '';
        },

        getStudentEnd(item) {
            // normal students
            if (item.end) {
                return this.formattedDate(item.end, 'date');
            }

            // fallback → latest selected class
            if (this.selectedClassesCourseOrGroup?.length) {
                const max = Math.max(
                    ...this.selectedClassesCourseOrGroup.map(c => new Date(c.end).getTime())
                );
                return this.formattedDate(max, 'date');
            }

            return '';
        },

        getEffectiveMinutesForStudents(count) {
            const total = Number(this.effectiveMinutesRequired) || 0;

            const isSpanish =
                this.editedResource.class_language !== 'English';

            const isGroup =
                this.editedResource.class_group === 'Group';

            // Spanish group with only 1 student → 75% rule
            if (isGroup && isSpanish && count === 1) {
                return this.get75PercentRounded(total / 60); // expects hours → returns minutes
            }

            // Default: full duration
            return total;
        },

        buildResourcesInCourse({ baselineClasses, editedClasses, minutesMap, resource }) {

            if (!minutesMap) {
                console.warn("minutesMap missing → skip compute");
                return [];
            }

            const before = {};
            const after = {};
            const participants = new Set();

            for (const cls of baselineClasses || []) {
                for (const s of cls.studentsObject || []) {
                    const rid = String(s.resource_id);
                    participants.add(rid);

                    const mins = this.computeMinutesUsed(cls);
                    
                    before[rid] = (before[rid] || 0) + mins;
                }
            }

            for (const cls of editedClasses || []) {
                for (const s of cls.studentsObject || []) {
                    const rid = String(s.resource_id);
                    participants.add(rid);

                    const mins = this.computeMinutesUsed(cls);
                    after[rid] = (after[rid] || 0) + mins;
                }
            }

            if (resource?.resource_id) {
                participants.add(String(resource.resource_id));
            }

            const result = [];

            for (const rid of participants) {
                const base = minutesMap.get(String(rid)) ?? 0;

                // console.log("buildResourcesInCourse", base/60, (before[rid] || 0)/60, (after[rid] || 0)/60, (base + (before[rid] || 0) - (after[rid] || 0))/60)

                result.push({
                    resource_id: rid,
                    minutes_available: base + (before[rid] || 0) - (after[rid] || 0),
                    minutesPlannedBaseline: before[rid] || 0,
                    minutesPlannedCurrent: after[rid] || 0,
                });

            }

            return result;
        },

        getStudentColorStyle(student) {
            const color = this.intToColor(student.resource_id);

            return {
                backgroundColor: color.background,
                color: color.text
            };
        },

        ensureMinutesMap() {
            // add resources if not present with available minutes from resourcesLoaded
            const map = new Map(this.minutesAvailableAtDialogOpenCourse || []);

            for (const cls of this.editedClassesInResource || []) {
                for (const s of cls.studentsObject || []) {
                    const id = String(s.resource_id);

                    if (!map.has(id)) {
                        const full = this.resourceMap?.get(id);
                        const base = Number(full?.minutes_available) || 0;

                        map.set(id, base);
                    }
                }
            }

            return map;
        },


    },
}



</script>

<style>

    .text_color_changed_content {
        color: #2f5abe;
    }

    .background_normal_group {
        background-color: #93c595;
    }

    .background_special_group {
        background-color: #d6f3d8;
    }

    .background_normal_classgroup {
        background-color: #d2dd7e;
    }

    .background_special_classgroup {
        background-color: #90ee90;
    }

    .background_normal_individual {
        background-color: #91d5de;
    }

    .background_special_individual {
        background-color: #c6eef3;
    }
    
    .white-background {
        background-color: white;
    }

    .backgroundColor1 {
        background-color: #D5F5E3;
    }

    .backgroundColor2 {
        background-color: #EBDEF0;
    }

    .backgroundColor3 {
        background-color: #FDEBD0;
    }

    .backgroundColor4 {
        background-color: #AED6F1;
    }

    .v-event-draggable {
        padding-left: 6px;
    }

    .v-event-timed {
        user-select: none;
        -webkit-user-select: none;
    }

    .v-event-drag-bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 4px;
            height: 4px;
            cursor: ns-resize;

            &::after {
            display: none;
            position: absolute;
            left: 50%;
            height: 4px;
            border-top: 1px solid white;
            border-bottom: 1px solid white;
            width: 16px;
            margin-left: -8px;
            opacity: 0.8;
            content: '';
        }

        &:hover::after {
            display: block;
        }
    }

    .event-title {
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }

    .event-button-div {
        display: flex;
    }

    .event-button {
        margin-left: auto;
        margin-right: -3%;
        margin-top: -3%;
    }
    


</style>
        